
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1c76"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1c76"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lU1sx", function(module, exports) {

$parcel$export(module.exports, "Messages", function () { return $ff1ff5b9cd3d1264$export$ceaacf8b390a3600; });

var $6uMv9 = parcelRequire("6uMv9");

var $7IQ0C = parcelRequire("7IQ0C");

var $cFTyZ = parcelRequire("cFTyZ");

var $cb4tE = parcelRequire("cb4tE");

var $eR8nv = parcelRequire("eR8nv");

var $8Mqhq = parcelRequire("8Mqhq");

var $15euW = parcelRequire("15euW");

var $5DOdF = parcelRequire("5DOdF");

var $9P7B9 = parcelRequire("9P7B9");

var $iWNGS = parcelRequire("iWNGS");

var $hC3fb = parcelRequire("hC3fb");

var $1WOJW = parcelRequire("1WOJW");

var $8VKpw = parcelRequire("8VKpw");
"use client";
function $ff1ff5b9cd3d1264$var$_extends() {
    $ff1ff5b9cd3d1264$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ff1ff5b9cd3d1264$var$_extends.apply(this, arguments);
}
function $ff1ff5b9cd3d1264$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ff1ff5b9cd3d1264$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ff1ff5b9cd3d1264$var$_arrayLikeToArray(arr);
}
function $ff1ff5b9cd3d1264$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ff1ff5b9cd3d1264$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ff1ff5b9cd3d1264$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ff1ff5b9cd3d1264$var$_arrayLikeToArray(o, minLen);
}
function $ff1ff5b9cd3d1264$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ff1ff5b9cd3d1264$var$_toConsumableArray(arr) {
    return $ff1ff5b9cd3d1264$var$_arrayWithoutHoles(arr) || $ff1ff5b9cd3d1264$var$_iterableToArray(arr) || $ff1ff5b9cd3d1264$var$_unsupportedIterableToArray(arr) || $ff1ff5b9cd3d1264$var$_nonIterableSpread();
}
function $ff1ff5b9cd3d1264$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ff1ff5b9cd3d1264$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ff1ff5b9cd3d1264$var$_typeof(o);
}
function $ff1ff5b9cd3d1264$var$_toPrimitive(input, hint) {
    if ($ff1ff5b9cd3d1264$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ff1ff5b9cd3d1264$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ff1ff5b9cd3d1264$var$_toPropertyKey(arg) {
    var key = $ff1ff5b9cd3d1264$var$_toPrimitive(arg, "string");
    return $ff1ff5b9cd3d1264$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ff1ff5b9cd3d1264$var$_defineProperty(obj, key, value) {
    key = $ff1ff5b9cd3d1264$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ff1ff5b9cd3d1264$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ff1ff5b9cd3d1264$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ff1ff5b9cd3d1264$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ff1ff5b9cd3d1264$var$_slicedToArray(arr, i) {
    return $ff1ff5b9cd3d1264$var$_arrayWithHoles(arr) || $ff1ff5b9cd3d1264$var$_iterableToArrayLimit(arr, i) || $ff1ff5b9cd3d1264$var$_unsupportedIterableToArray(arr, i) || $ff1ff5b9cd3d1264$var$_nonIterableRest();
}
var $ff1ff5b9cd3d1264$var$styles = "\n@layer primereact {\n    .p-message-wrapper {\n        display: flex;\n        align-items: center;\n    }\n\n    .p-message-icon {\n        flex-shrink: 0;\n    }\n    \n    .p-message-close {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    \n    .p-message-close.p-link {\n        margin-left: auto;\n        overflow: hidden;\n        position: relative;\n    }\n    \n    .p-message-enter {\n        opacity: 0;\n    }\n    \n    .p-message-enter-active {\n        opacity: 1;\n        transition: opacity .3s;\n    }\n    \n    .p-message-exit {\n        opacity: 1;\n        max-height: 1000px;\n    }\n    \n    .p-message-exit-active {\n        opacity: 0;\n        max-height: 0;\n        margin: 0;\n        overflow: hidden;\n        transition: max-height .3s cubic-bezier(0, 1, 0, 1), opacity .3s, margin .3s;\n    }\n    \n    .p-message-exit-active .p-message-close {\n        display: none;\n    }\n}\n";
var $ff1ff5b9cd3d1264$var$classes = {
    uimessage: {
        root: function root(_ref) {
            var severity = _ref.severity;
            return (0, $15euW.classNames)("p-message p-component", $ff1ff5b9cd3d1264$var$_defineProperty({}, "p-message-".concat(severity), severity));
        },
        wrapper: "p-message-wrapper",
        detail: "p-message-detail",
        summary: "p-message-summary",
        icon: "p-message-icon",
        buttonicon: "p-message-close-icon",
        button: "p-message-close p-link",
        transition: "p-message"
    }
};
var $ff1ff5b9cd3d1264$var$MessagesBase = (0, $cb4tE.ComponentBase).extend({
    defaultProps: {
        __TYPE: "Messages",
        __parentMetadata: null,
        id: null,
        className: null,
        style: null,
        transitionOptions: null,
        onRemove: null,
        onClick: null,
        children: undefined
    },
    css: {
        classes: $ff1ff5b9cd3d1264$var$classes,
        styles: $ff1ff5b9cd3d1264$var$styles
    }
});
function $ff1ff5b9cd3d1264$var$ownKeys$1(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ff1ff5b9cd3d1264$var$_objectSpread$1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ff1ff5b9cd3d1264$var$ownKeys$1(Object(t), !0).forEach(function(r) {
            $ff1ff5b9cd3d1264$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ff1ff5b9cd3d1264$var$ownKeys$1(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ff1ff5b9cd3d1264$var$UIMessage = /*#__PURE__*/ $6uMv9.memo(/*#__PURE__*/ $6uMv9.forwardRef(function(props, ref) {
    var mergeProps = (0, $8Mqhq.useMergeProps)();
    var messageInfo = props.message, parentMetaData = props.metaData, _props$ptCallbacks = props.ptCallbacks, ptm = _props$ptCallbacks.ptm, ptmo = _props$ptCallbacks.ptmo, cx = _props$ptCallbacks.cx, index = props.index;
    var _messageInfo$message = messageInfo.message, severity = _messageInfo$message.severity, content = _messageInfo$message.content, summary = _messageInfo$message.summary, detail = _messageInfo$message.detail, closable = _messageInfo$message.closable, life = _messageInfo$message.life, sticky = _messageInfo$message.sticky, _className = _messageInfo$message.className, style = _messageInfo$message.style, _contentClassName = _messageInfo$message.contentClassName, contentStyle = _messageInfo$message.contentStyle, _icon = _messageInfo$message.icon, _closeIcon = _messageInfo$message.closeIcon, pt = _messageInfo$message.pt;
    var params = {
        index: index
    };
    var parentParams = $ff1ff5b9cd3d1264$var$_objectSpread$1($ff1ff5b9cd3d1264$var$_objectSpread$1({}, parentMetaData), params);
    var _useTimeout = (0, $8Mqhq.useTimeout)(function() {
        onClose(null);
    }, life || 3000, !sticky), _useTimeout2 = $ff1ff5b9cd3d1264$var$_slicedToArray(_useTimeout, 1), clearTimer = _useTimeout2[0];
    var getPTOptions = function getPTOptions(key, options) {
        return ptm(key, $ff1ff5b9cd3d1264$var$_objectSpread$1({
            hostName: props.hostName
        }, options));
    };
    var onClose = function onClose(event) {
        clearTimer();
        props.onClose && props.onClose(props.message);
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    var onClick = function onClick() {
        props.onClick && props.onClick(props.message);
    };
    var createCloseIcon = function createCloseIcon() {
        if (closable !== false) {
            var ariaLabel = (0, $cFTyZ.localeOption)("close");
            var buttonIconProps = mergeProps({
                className: cx("uimessage.buttonicon")
            }, getPTOptions("buttonicon", parentParams), ptmo(pt, "buttonicon", $ff1ff5b9cd3d1264$var$_objectSpread$1($ff1ff5b9cd3d1264$var$_objectSpread$1({}, params), {}, {
                hostName: props.hostName
            })));
            var icon = _closeIcon || /*#__PURE__*/ $6uMv9.createElement((0, $hC3fb.TimesIcon), buttonIconProps);
            var _closeIcon2 = (0, $15euW.IconUtils).getJSXIcon(icon, $ff1ff5b9cd3d1264$var$_objectSpread$1({}, buttonIconProps), {
                props: props
            });
            var buttonProps = mergeProps({
                type: "button",
                className: cx("uimessage.button"),
                "aria-label": ariaLabel,
                onClick: onClose
            }, getPTOptions("button", parentParams), ptmo(pt, "button", $ff1ff5b9cd3d1264$var$_objectSpread$1($ff1ff5b9cd3d1264$var$_objectSpread$1({}, params), {}, {
                hostName: props.hostName
            })));
            return /*#__PURE__*/ $6uMv9.createElement("button", buttonProps, _closeIcon2, /*#__PURE__*/ $6uMv9.createElement((0, $8VKpw.Ripple), null));
        }
        return null;
    };
    var createMessage = function createMessage() {
        if (props.message) {
            var iconProps = mergeProps({
                className: cx("uimessage.icon")
            }, getPTOptions("icon", parentParams), ptmo(pt, "icon", $ff1ff5b9cd3d1264$var$_objectSpread$1($ff1ff5b9cd3d1264$var$_objectSpread$1({}, params), {}, {
                hostName: props.hostName
            })));
            var icon = _icon;
            if (!_icon) switch(severity){
                case "info":
                    icon = /*#__PURE__*/ $6uMv9.createElement((0, $iWNGS.InfoCircleIcon), iconProps);
                    break;
                case "warn":
                    icon = /*#__PURE__*/ $6uMv9.createElement((0, $9P7B9.ExclamationTriangleIcon), iconProps);
                    break;
                case "error":
                    icon = /*#__PURE__*/ $6uMv9.createElement((0, $1WOJW.TimesCircleIcon), iconProps);
                    break;
                case "success":
                    icon = /*#__PURE__*/ $6uMv9.createElement((0, $5DOdF.CheckIcon), iconProps);
                    break;
            }
            var iconContent = (0, $15euW.IconUtils).getJSXIcon(icon, $ff1ff5b9cd3d1264$var$_objectSpread$1({}, iconProps), {
                props: props
            });
            var summaryProps = mergeProps({
                className: cx("uimessage.summary")
            }, getPTOptions("summary", parentParams), ptmo(pt, "summary", $ff1ff5b9cd3d1264$var$_objectSpread$1($ff1ff5b9cd3d1264$var$_objectSpread$1({}, params), {}, {
                hostName: props.hostName
            })));
            var detailProps = mergeProps({
                className: cx("uimessage.detail")
            }, getPTOptions("detail", parentParams), ptmo(pt, "detail", $ff1ff5b9cd3d1264$var$_objectSpread$1($ff1ff5b9cd3d1264$var$_objectSpread$1({}, params), {}, {
                hostName: props.hostName
            })));
            return content || /*#__PURE__*/ $6uMv9.createElement($6uMv9.Fragment, null, iconContent, /*#__PURE__*/ $6uMv9.createElement("span", summaryProps, summary), /*#__PURE__*/ $6uMv9.createElement("span", detailProps, detail));
        }
        return null;
    };
    var closeIcon = createCloseIcon();
    var message = createMessage();
    var wrapperProps = mergeProps({
        className: (0, $15euW.classNames)(_contentClassName, cx("uimessage.wrapper")),
        style: contentStyle
    }, getPTOptions("wrapper", parentParams), ptmo(pt, "wrapper", $ff1ff5b9cd3d1264$var$_objectSpread$1($ff1ff5b9cd3d1264$var$_objectSpread$1({}, params), {}, {
        hostName: props.hostName
    })));
    var rootProps = mergeProps({
        ref: ref,
        className: (0, $15euW.classNames)(_className, cx("uimessage.root", {
            severity: severity
        })),
        style: style,
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true",
        onClick: onClick
    }, getPTOptions("root", parentParams), ptmo(pt, "root", $ff1ff5b9cd3d1264$var$_objectSpread$1($ff1ff5b9cd3d1264$var$_objectSpread$1({}, params), {}, {
        hostName: props.hostName
    })));
    return /*#__PURE__*/ $6uMv9.createElement("div", rootProps, /*#__PURE__*/ $6uMv9.createElement("div", wrapperProps, message, closeIcon));
}));
$ff1ff5b9cd3d1264$var$UIMessage.displayName = "UIMessage";
function $ff1ff5b9cd3d1264$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ff1ff5b9cd3d1264$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ff1ff5b9cd3d1264$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ff1ff5b9cd3d1264$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ff1ff5b9cd3d1264$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ff1ff5b9cd3d1264$var$messageIdx = 0;
var $ff1ff5b9cd3d1264$export$ceaacf8b390a3600 = /*#__PURE__*/ $6uMv9.memo(/*#__PURE__*/ $6uMv9.forwardRef(function(inProps, ref) {
    var mergeProps = (0, $8Mqhq.useMergeProps)();
    var context = $6uMv9.useContext((0, $cFTyZ.PrimeReactContext));
    var props = $ff1ff5b9cd3d1264$var$MessagesBase.getProps(inProps, context);
    var _React$useState = $6uMv9.useState([]), _React$useState2 = $ff1ff5b9cd3d1264$var$_slicedToArray(_React$useState, 2), messagesState = _React$useState2[0], setMessagesState = _React$useState2[1];
    var elementRef = $6uMv9.useRef(null);
    var metaData = $ff1ff5b9cd3d1264$var$_objectSpread($ff1ff5b9cd3d1264$var$_objectSpread({
        props: props
    }, props.__parentMetadata), {}, {
        state: {
            messages: messagesState
        }
    });
    var ptCallbacks = $ff1ff5b9cd3d1264$var$MessagesBase.setMetaData(metaData);
    (0, $cb4tE.useHandleStyle)($ff1ff5b9cd3d1264$var$MessagesBase.css.styles, ptCallbacks.isUnstyled, {
        name: "messages"
    });
    var show = function show(messageInfo) {
        if (messageInfo) setMessagesState(function(prev) {
            return assignIdentifiers(prev, messageInfo, true);
        });
    };
    var assignIdentifiers = function assignIdentifiers(currentState, messageInfo, copy) {
        var messages;
        if (Array.isArray(messageInfo)) {
            var multipleMessages = messageInfo.reduce(function(acc, message) {
                acc.push({
                    _pId: $ff1ff5b9cd3d1264$var$messageIdx++,
                    message: message
                });
                return acc;
            }, []);
            if (copy) messages = currentState ? [].concat($ff1ff5b9cd3d1264$var$_toConsumableArray(currentState), $ff1ff5b9cd3d1264$var$_toConsumableArray(multipleMessages)) : multipleMessages;
            else messages = multipleMessages;
        } else {
            var message = {
                _pId: $ff1ff5b9cd3d1264$var$messageIdx++,
                message: messageInfo
            };
            if (copy) messages = currentState ? [].concat($ff1ff5b9cd3d1264$var$_toConsumableArray(currentState), [
                message
            ]) : [
                message
            ];
            else messages = [
                message
            ];
        }
        return messages;
    };
    var clear = function clear() {
        setMessagesState([]);
    };
    var replace = function replace(messageInfo) {
        setMessagesState(function(prev) {
            return assignIdentifiers(prev, messageInfo, false);
        });
    };
    var remove = function remove(messageInfo) {
        // allow removal by ID or by message equality
        var removeMessage = messageInfo._pId ? messageInfo._pId : messageInfo.message || messageInfo;
        setMessagesState(function(prev) {
            return prev.filter(function(msg) {
                return msg._pId !== messageInfo._pId && !(0, $15euW.ObjectUtils).deepEquals(msg.message, removeMessage);
            });
        });
        props.onRemove && props.onRemove(removeMessage.message || removeMessage);
    };
    var onClose = function onClose(messageInfo) {
        remove(messageInfo);
    };
    $6uMv9.useImperativeHandle(ref, function() {
        return {
            props: props,
            show: show,
            replace: replace,
            remove: remove,
            clear: clear,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    });
    var rootProps = mergeProps({
        id: props.id,
        className: props.className,
        style: props.style
    }, $ff1ff5b9cd3d1264$var$MessagesBase.getOtherProps(props), ptCallbacks.ptm("root"));
    var transitionProps = mergeProps({
        classNames: ptCallbacks.cx("uimessage.transition"),
        unmountOnExit: true,
        timeout: {
            enter: 300,
            exit: 300
        },
        options: props.transitionOptions
    }, ptCallbacks.ptm("transition"));
    return /*#__PURE__*/ $6uMv9.createElement("div", $ff1ff5b9cd3d1264$var$_extends({
        ref: elementRef
    }, rootProps), /*#__PURE__*/ $6uMv9.createElement((0, $7IQ0C.default), null, messagesState && messagesState.map(function(message, index) {
        var messageRef = /*#__PURE__*/ $6uMv9.createRef();
        return /*#__PURE__*/ $6uMv9.createElement((0, $eR8nv.CSSTransition), $ff1ff5b9cd3d1264$var$_extends({
            nodeRef: messageRef,
            key: message._pId
        }, transitionProps), /*#__PURE__*/ $6uMv9.createElement($ff1ff5b9cd3d1264$var$UIMessage, {
            hostName: "Messages",
            ref: messageRef,
            message: message,
            onClick: props.onClick,
            onClose: onClose,
            ptCallbacks: ptCallbacks,
            metaData: metaData,
            index: index
        }));
    })));
}));
$ff1ff5b9cd3d1264$export$ceaacf8b390a3600.displayName = "Messages";

});

parcelRegister("izFg3", function(module, exports) {
$parcel$export(module.exports, "ChargePointFavoritesDashboardWidget", function () { return (parcelRequire("Q10m9")).ChargePointFavoritesDashboardWidget; });
parcelRequire("Q10m9");

});
parcelRegister("Q10m9", function(module, exports) {

$parcel$export(module.exports, "ChargePointFavoritesDashboardWidget", function () { return $e3c67dac5ff9cd87$export$753c3355b2d2374a; });

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $iZaUM = parcelRequire("iZaUM");

var $1xw2Y = parcelRequire("1xw2Y");
const $e3c67dac5ff9cd87$var$SLink = (0, $akcQ4.default).a`
    & {
        color: ${({ theme: theme })=>theme.font.darkestColor};
        text-decoration: underline;
        text-underline-offset: 5px;
        font-weight: 400;
        line-height: 30px;
    }

    &:hover {
        color: ${({ theme: theme })=>theme.font.successColor};
        cursor: pointer;
    }

    &:active {
        color: ${({ theme: theme })=>theme.font.midDarkColor};
    }
`;
const $e3c67dac5ff9cd87$export$753c3355b2d2374a = /*#__PURE__*/ (0, $6uMv9.memo)(function ChargePointFavoritesDashboardWidget({ style: style, favourites: favourites }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "widget",
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "widget-report widget-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblFavourites"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "dashboard-widget"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, favourites?.map((favorite)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
            key: favorite.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e3c67dac5ff9cd87$var$SLink, {
            as: (0, $iZaUM.Link),
            "data-testid": "chargePoint-id",
            to: `/chargepoints/${favorite.id}`
        }, favorite.chargePointStatus == "Offline" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
            "data-testid": "offline",
            className: "fa fa-circle redFont padding-4"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
            "data-testid": "online",
            className: "fa fa-circle availableGreenFont padding-4"
        }), favorite.id)))))));
});

});


parcelRegister("iKfQu", function(module, exports) {
$parcel$export(module.exports, "DashboardAlarmsWidget", function () { return (parcelRequire("kOabU")).DashboardAlarmsWidget; });
parcelRequire("kOabU");

});
parcelRegister("kOabU", function(module, exports) {

$parcel$export(module.exports, "DashboardAlarmsWidget", function () { return $a91796b4bca218af$export$9b9ca954b4d83534; });

var $6uMv9 = parcelRequire("6uMv9");

var $4vH3e = parcelRequire("4vH3e");

var $dpspD = parcelRequire("dpspD");

var $luiwW = parcelRequire("luiwW");

var $aIcGc = parcelRequire("aIcGc");

var $iZaUM = parcelRequire("iZaUM");

var $cFTyZ = parcelRequire("cFTyZ");

var $8N7S6 = parcelRequire("8N7S6");

var $8RYO3 = parcelRequire("8RYO3");

var $8LupL = parcelRequire("8LupL");

var $8Gccq = parcelRequire("8Gccq");

var $fvmYM = parcelRequire("fvmYM");

var $aL1Vp = parcelRequire("aL1Vp");

var $1oBYI = parcelRequire("1oBYI");
const $a91796b4bca218af$export$9b9ca954b4d83534 = ()=>{
    const text = (0, $aL1Vp.default)();
    const { partnerId: partnerId } = (0, $4vH3e.useSelector)((state)=>state.user);
    const [showConfirmed, setShowConfirmed] = (0, $6uMv9.useState)(false);
    const { data: alarms, isLoading: isLoadingAlarms } = (0, $8Gccq.useAlarmQuery)(partnerId, showConfirmed);
    const [globalFilter, setGlobalFilter] = (0, $6uMv9.useState)("");
    const [acknowledgeAlarm] = (0, $fvmYM.usePartnerSetAcknowledgedMutation)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex align-items-center justify-content-between mb-4"
    }, (0, $8LupL.isPartnerDomain) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex align-items-center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $luiwW.InputSwitch), {
        checked: showConfirmed ?? undefined,
        onChange: (e)=>setShowConfirmed(e.value),
        inputId: "input-show-confirmed",
        name: "show-confirmed"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("label", {
        htmlFor: "input-show-confirmed",
        className: "m-0 ml-2"
    }, text("lblShowConfirmedField"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1oBYI.Input), {
        id: "alarms-search-input",
        type: "search",
        value: globalFilter,
        onChange: (e)=>setGlobalFilter(e.target.value),
        placeholder: text("msgSearch"),
        icon: (0, $cFTyZ.PrimeIcons).SEARCH,
        "data-testid": "alarms-search-input"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8RYO3.Table), {
        value: alarms,
        size: "normal",
        loading: isLoadingAlarms,
        globalFilter: globalFilter,
        globalFilterFields: [
            "alarmDefinition.name",
            "alarmDefinition.description",
            "company.name",
            "chargePointId"
        ],
        dataKey: "id",
        paginator: true,
        rows: 10,
        emptyMessage: text("msgNoAlarmsFound"),
        "data-testid": "alarms-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "chargePointId",
        header: text("lblSerialNumberShort"),
        body: (alarm)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
                className: "pr-4",
                to: `/chargepoints/${alarm.chargePointId}`
            }, alarm.chargePointId);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "company.name",
        header: text("lblOrganisation")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "lastOccurence",
        header: text("lblTime"),
        body: (alarm)=>(0, $8N7S6.dateLocalize)(alarm.lastOccurence)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "alarmDefinition.name",
        header: text("lblType")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "noOfOccurences",
        header: "#"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "alarmDefinition.description",
        header: text("lblDescription"),
        className: "w-2 "
    }), (0, $8LupL.isPartnerDomain) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "acknowledged",
        header: text("lblConfirm"),
        body: (alarm)=>alarm.acknowledged ? (0, $8N7S6.dateLocalize)(alarm.acknowledged) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
                size: "small",
                rounded: true,
                icon: "pi pi-check",
                title: text("btnConfirm"),
                onClick: ()=>acknowledgeAlarm({
                        alarmId: alarm.id,
                        partnerId: partnerId
                    })
            })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "acknowledged",
        header: text("lblConfirm"),
        body: (alarm)=>alarm.acknowledged ? (0, $8N7S6.dateLocalize)(alarm.acknowledged) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", null, "---")
    })));
};

});


parcelRegister("6N5PZ", function(module, exports) {
$parcel$export(module.exports, "validateHostNameFormat", function () { return (parcelRequire("4WjE8")).validateHostNameFormat; });
parcelRequire("4WjE8");

});
parcelRegister("4WjE8", function(module, exports) {

$parcel$export(module.exports, "validateHostNameFormat", function () { return $a19a035baf0a5230$export$5d2f8e30afbe9878; });
function $a19a035baf0a5230$export$5d2f8e30afbe9878(hostname) {
    const topLevelDomain = hostname.substring(0, hostname.indexOf("."));
    const containsOnlyLetters = (str)=>str.match(/^[A-Za-z]+$/);
    return topLevelDomain.length !== 0 && !!containsOnlyLetters(topLevelDomain) && topLevelDomain + ".charge.space" === hostname;
}

});


parcelRegister("icCom", function(module, exports) {
$parcel$export(module.exports, "FirmwareListItem", function () { return (parcelRequire("fyYJX")).FirmwareListItem; });
$parcel$export(module.exports, "STextarea", function () { return (parcelRequire("fyYJX")).STextarea; });
parcelRequire("fyYJX");

});
parcelRegister("fyYJX", function(module, exports) {

$parcel$export(module.exports, "STextarea", function () { return $03e72d11df4398ed$export$4f8ad93191abeaa4; });
$parcel$export(module.exports, "FirmwareListItem", function () { return $03e72d11df4398ed$export$e082dceca8891223; });

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $lpowX = parcelRequire("lpowX");

var $bhWK5 = parcelRequire("bhWK5");

var $1xw2Y = parcelRequire("1xw2Y");

var $dXAqI = parcelRequire("dXAqI");

var $i4Oah = parcelRequire("i4Oah");

var $1dgSH = parcelRequire("1dgSH");

var $2naDF = parcelRequire("2naDF");

var $duQ8A = parcelRequire("duQ8A");

var $f7UZA = parcelRequire("f7UZA");

var $cfXjW = parcelRequire("cfXjW");

var $aL1Vp = parcelRequire("aL1Vp");
const $03e72d11df4398ed$export$4f8ad93191abeaa4 = (0, $akcQ4.default).textarea`
    font-weight: 400;
    display: block;
    width: 100%;
    height: auto;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
`;
const $03e72d11df4398ed$var$SActiveFirmwareMessage = (0, $akcQ4.default).div`
    font-weight: 500;
    padding-top: 10px;
`;
function $03e72d11df4398ed$export$e082dceca8891223({ isOcpp: isOcpp, data: data, onActivate: onActivate, onRemove: onRemove, isActivationDisabled: isActivationDisabled, showActionMenu: showActionMenu }) {
    const text = (0, $aL1Vp.default)();
    const canSelectFirmware = (0, $lpowX.default)(data.firmwareType) && !data.isActive && onActivate && !isOcpp;
    const [editFirmwareModalIsOpen, setEditFirmwareModalIsOpen] = (0, $6uMv9.useState)(false);
    const [selectedFirmwareData, setSelectedFirmwareData] = (0, $6uMv9.useState)(null);
    const openModal = (selectedData)=>{
        setSelectedFirmwareData(selectedData);
        setEditFirmwareModalIsOpen(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, data && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
        "data-testid": "list-fw-version"
    }, data.firmwareVersion), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
        "data-testid": "list-upload-date"
    }, (0, $bhWK5.default)(data.uploadDate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
        "data-testid": "list-status-"
    }, data.firmwareStatus), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
        "data-testid": "list-desc"
    }, data.description, data.isActive && data.productId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($03e72d11df4398ed$var$SActiveFirmwareMessage, {
        "data-testid": "list-active"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgFWActivateFWMsg",
        values: {
            type: data.productId > 3 ? "Aura" : "Halo"
        }
    }))), isOcpp && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
        "data-testid": "list-ocpp-enabled"
    }, data.ocppEnabledFirmware && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cfXjW.CheckMarkIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
        "data-testid": "list-count"
    }, data.chargePointsCount), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), {
        "data-testid": "list-count"
    }, canSelectFirmware && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        size: "sm",
        label: text("lblUpgradeFirmware"),
        disabled: isActivationDisabled,
        type: "button",
        onClick: ()=>onActivate(data.id)
    })), showActionMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableBodyCell), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $duQ8A.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $duQ8A.DropdownMenuItem), {
        text: text("lblEdit"),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $i4Oah.EditIcon), {
            size: 14
        }),
        onClick: ()=>{
            openModal(data);
            setEditFirmwareModalIsOpen(true);
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $duQ8A.DropdownMenuItem), {
        text: text("btnRemove"),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1dgSH.default), {
            size: 14
        }),
        disabled: data.isActive || !!data.chargePointsCount,
        onClick: ()=>onRemove && onRemove(data?.id)
    }))))), editFirmwareModalIsOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dXAqI.EditFirmwareModal), {
        setEditFirmwareModalIsOpen: setEditFirmwareModalIsOpen,
        selectedFirmwareData: selectedFirmwareData
    }));
}

});
parcelRegister("lpowX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65436ca921ff7612$export$2e2bcd8739ae039; });
parcelRequire("82mZs");
var $1oism = parcelRequire("1oism");
const $65436ca921ff7612$var$canActivateFirmware = (firmwareType)=>{
    return firmwareType === (0, $1oism.FirmwareType).Master;
};
var $65436ca921ff7612$export$2e2bcd8739ae039 = $65436ca921ff7612$var$canActivateFirmware;

});
parcelRegister("82mZs", function(module, exports) {
$parcel$export(module.exports, "FirmwareType", function () { return (parcelRequire("1oism")).FirmwareType; });
parcelRequire("1oism");

});
parcelRegister("1oism", function(module, exports) {

$parcel$export(module.exports, "FirmwareType", function () { return $ccf1c631a27eaf27$export$58d9e2c1b2e4543b; });
$parcel$export(module.exports, "default", function () { return $ccf1c631a27eaf27$export$2e2bcd8739ae039; });

var $afw9z = parcelRequire("afw9z");

var $8MuU1 = parcelRequire("8MuU1");

var $apvVy = parcelRequire("apvVy");

var $174na = parcelRequire("174na");

var $6uMv9 = parcelRequire("6uMv9");

var $jkk71 = parcelRequire("jkk71");

var $5xOHE = parcelRequire("5xOHE");

var $akcQ4 = parcelRequire("akcQ4");

var $iZaUM = parcelRequire("iZaUM");

var $aL1Vp = parcelRequire("aL1Vp");

var $fvmYM = parcelRequire("fvmYM");

var $gZhRQ = parcelRequire("gZhRQ");

var $QoO6n = parcelRequire("QoO6n");

var $eK784 = parcelRequire("eK784");

var $2gfhP = parcelRequire("2gfhP");

var $7o7Qd = parcelRequire("7o7Qd");

var $32rQe = parcelRequire("32rQe");

var $kkkuC = parcelRequire("kkkuC");

var $1pBSr = parcelRequire("1pBSr");
const $ccf1c631a27eaf27$export$a85c47b0d1ce366 = 3;
const $ccf1c631a27eaf27$var$Select = (0, $akcQ4.default)((0, $5xOHE.default))`
    font-weight: 500;
`;
const $ccf1c631a27eaf27$var$SDeviceTitleName = (0, $akcQ4.default).h2`
    font-family: ${({ theme: theme })=>theme.font.extendedName};
    font-size: 36px;
    font-weight: 500;
    line-height: 36px;
`;
const $ccf1c631a27eaf27$var$SSubtitleTip = (0, $akcQ4.default).div`
    font-family: ${({ theme: theme })=>theme.font.name};
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    max-width: 600px;
`;
const $ccf1c631a27eaf27$var$SFirmwareFilter = (0, $akcQ4.default).div`
    margin-bottom: 30px;
`;
const $ccf1c631a27eaf27$var$SFilterLabel = (0, $akcQ4.default).label`
    font-family: ${({ theme: theme })=>theme.font.name};
    font-size: 16px;
    font-weight: 300;
    line-height: 36px;
    margin-top: 1em;
    display: block;
`;
var $ccf1c631a27eaf27$export$58d9e2c1b2e4543b;
(function(FirmwareType) {
    FirmwareType["Master"] = "Master";
    FirmwareType["Slave"] = "Slave";
    FirmwareType["Wifi"] = "Wifi";
})($ccf1c631a27eaf27$export$58d9e2c1b2e4543b || ($ccf1c631a27eaf27$export$58d9e2c1b2e4543b = {}));
var $ccf1c631a27eaf27$export$acdfad52bc8c6626;
(function(ProductName) {
    ProductName["HALO"] = "HALO";
    ProductName["HALO_CAPI"] = "HALO 2 CAPI";
    ProductName["HALO_OCPP"] = "HALO 2 OCPP";
    ProductName["AURA_CAPI"] = "AURA CAPI";
    ProductName["AURA_OCPP"] = "AURA OCPP";
    ProductName["DAWN"] = "DAWN";
})($ccf1c631a27eaf27$export$acdfad52bc8c6626 || ($ccf1c631a27eaf27$export$acdfad52bc8c6626 = {}));
const $ccf1c631a27eaf27$var$mapSearchParamsToFilter = ({ activeTab: activeTab, productName: productName, firmwareType: firmwareType, productId: productId })=>{
    return {
        activeTab: activeTab,
        productName: productName,
        firmwareType: firmwareType,
        productId: productId
    };
};
const $ccf1c631a27eaf27$var$productSort = Object.values($ccf1c631a27eaf27$export$acdfad52bc8c6626);
const $ccf1c631a27eaf27$var$FirmwarePage = ()=>{
    const text = (0, $aL1Vp.default)();
    const [searchParams, setParams] = (0, $iZaUM.useSearchParams)();
    const params = Object.fromEntries(searchParams.entries());
    const { activeTab: activeTab, productName: productName, firmwareType: firmwareType, productId: productId } = $ccf1c631a27eaf27$var$mapSearchParamsToFilter(params);
    const isDesktopScreen = (0, $jkk71.useMediaPredicate)("(min-width: 900px)");
    const { data: products } = (0, $fvmYM.useProductGetOptionsQuery)({
        productVariant: (0, $gZhRQ.ProductVariant).Chargepoint
    });
    const [firmwareTypes, setFirmwareTypes] = (0, $6uMv9.useState)([]);
    const firmwareTypeOptions = firmwareTypes.map((x)=>({
            value: x,
            label: x
        }));
    const productsSelectOptions = (0, $6uMv9.useMemo)(()=>products?.slice()?.sort((a, b)=>$ccf1c631a27eaf27$var$productSort.indexOf($ccf1c631a27eaf27$var$productSort.find((p)=>p === a.displayName) ?? $ccf1c631a27eaf27$var$productSort[0]) - $ccf1c631a27eaf27$var$productSort.indexOf($ccf1c631a27eaf27$var$productSort.find((p)=>p === b.displayName) ?? $ccf1c631a27eaf27$var$productSort[0])).map((product)=>({
                label: product.displayName,
                value: product.displayName
            })), [
        products
    ]);
    const [currentProduct, setCurrentProduct] = (0, $6uMv9.useState)({
        productId: productId,
        firmwareType: undefined,
        ocppEnabledFirmware: undefined,
        description: undefined,
        title: undefined,
        firmwareVersion: undefined,
        file: undefined,
        // TODO: Implement server selecting later
        firmwareServerLocationId: 1
    });
    (0, $6uMv9.useEffect)(()=>{
        if (products && products?.length > 0) {
            const product = products.find((item)=>productName ? item.displayName === productName : item.displayName === "HALO");
            if (product) {
                setFirmwareTypes(product.firmwareTypes ?? []);
                setCurrentProduct((prevValue)=>({
                        ...prevValue,
                        productId: product.productId,
                        ocppEnabledFirmware: product.ocppEnabled,
                        description: product?.displayName,
                        title: product?.displayName,
                        firmwareType: firmwareType ?? "Master"
                    }));
            }
        }
    }, [
        firmwareType,
        productName,
        products
    ]);
    const onChangeFirmwareUploadForm = (fieldName, value)=>{
        setCurrentProduct((prevValue)=>({
                ...prevValue,
                [fieldName]: value
            }));
    };
    const onProductChange = (option)=>{
        const selectedProduct = products?.find((product)=>product.displayName === option.value);
        if (!selectedProduct) return;
        setParams({
            ...params,
            productName: option.value,
            productId: selectedProduct.productId
        });
        setFirmwareTypes(selectedProduct.firmwareTypes);
        setCurrentProduct((prevValue)=>({
                ...prevValue,
                productId: selectedProduct.productId,
                ocppEnabledFirmware: selectedProduct.ocppEnabled,
                title: selectedProduct.displayName,
                description: selectedProduct.displayName,
                file: undefined,
                firmwareVersion: undefined,
                firmwareType: "Master"
            }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $QoO6n.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "w-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ccf1c631a27eaf27$var$SDeviceTitleName, {
        "data-testid": "title"
    }, currentProduct.title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "w-12 sm:w-8"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ccf1c631a27eaf27$var$SSubtitleTip, {
        "data-testid": "subtitle"
    }, text("msgSelectProductAndFirmware")))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ccf1c631a27eaf27$var$SFirmwareFilter, {
        className: "flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "w-12 sm:w-4 md:w-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "firmwareUploadForm-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ccf1c631a27eaf27$var$SFilterLabel, {
        "data-testid": "select-title"
    }, text("lblSelectProduct")), productsSelectOptions && productsSelectOptions.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ccf1c631a27eaf27$var$Select, {
        "data-testid": "select",
        isSearchable: false,
        options: productsSelectOptions,
        defaultValue: productName ?? productsSelectOptions[0],
        value: productsSelectOptions?.find((option)=>productName ? option.value === productName : option.value === currentProduct.title),
        onChange: (newValue)=>onProductChange(newValue)
    }) : null)), firmwareTypeOptions.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "w-12 sm:w-4 md:w-3 ml-8"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "firmwareUploadForm-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ccf1c631a27eaf27$var$SFilterLabel, {
        "data-testid": "select-type"
    }, text("lblSelectFirmwareType")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $eK784.default), {
        value: firmwareType ?? currentProduct.firmwareType,
        options: firmwareTypeOptions,
        onChange: (data)=>{
            setParams({
                ...params,
                firmwareType: data?.value
            });
            onChangeFirmwareUploadForm("firmwareType", data?.value);
        },
        withCheckmark: true
    }))) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))(isDesktopScreen && "w-12"),
        "data-testid": "tabs"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1pBSr.PersistentTabs), {
        active: activeTab,
        onTabClick: (label)=>{
            setParams({
                ...params,
                activeTab: label
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7o7Qd.default), {
        label: "Upload firmware",
        icon: (0, $8MuU1.faCloudUploadAlt),
        "data-testid": "upload"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2gfhP.default), {
        product: currentProduct
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7o7Qd.default), {
        label: "Update chargers",
        icon: (0, $apvVy.faRedo)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $kkkuC.default), {
        product: currentProduct
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7o7Qd.default), {
        label: "Select factory firmware",
        icon: (0, $afw9z.faStar),
        hidden: currentProduct.ocppEnabledFirmware
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $32rQe.default), {
        product: currentProduct
    }))))));
};
var $ccf1c631a27eaf27$export$2e2bcd8739ae039 = $ccf1c631a27eaf27$var$FirmwarePage;

});
parcelRegister("afw9z", function(module, exports) {

$parcel$export(module.exports, "faStar", function () { return $77643f1129269c08$export$a3b0eb2cd7942125; });
/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */ var $77643f1129269c08$export$82e9f45cca5ba907 = "far";
var $77643f1129269c08$export$853fd1561789e3bb = {
    prefix: "far",
    iconName: "address-book",
    icon: [
        448,
        512,
        [],
        "f2b9",
        "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-68 304H48V48h320v416zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
    ]
};
var $77643f1129269c08$export$6ea408c7266ed557 = {
    prefix: "far",
    iconName: "address-card",
    icon: [
        576,
        512,
        [],
        "f2bb",
        "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H48V80h480v352zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2zM360 320h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z"
    ]
};
var $77643f1129269c08$export$3c96c08e234498c5 = {
    prefix: "far",
    iconName: "angry",
    icon: [
        496,
        512,
        [],
        "f556",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-144c-33.6 0-65.2 14.8-86.8 40.6-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.2 33.8-3c24.8-29.7 75-29.7 99.8 0 8.1 9.7 23.2 11.9 33.8 3 10.2-8.5 11.5-23.6 3.1-33.8-21.6-25.8-53.2-40.6-86.8-40.6zm-48-72c10.3 0 19.9-6.7 23-17.1 3.8-12.7-3.4-26.1-16.1-29.9l-80-24c-12.8-3.9-26.1 3.4-29.9 16.1-3.8 12.7 3.4 26.1 16.1 29.9l28.2 8.5c-3.1 4.9-5.3 10.4-5.3 16.6 0 17.7 14.3 32 32 32s32-14.4 32-32.1zm199-54.9c-3.8-12.7-17.1-19.9-29.9-16.1l-80 24c-12.7 3.8-19.9 17.2-16.1 29.9 3.1 10.4 12.7 17.1 23 17.1 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.2-2.2-11.7-5.3-16.6l28.2-8.5c12.7-3.7 19.9-17.1 16.1-29.8z"
    ]
};
var $77643f1129269c08$export$ff3afbc8c0bc5d59 = {
    prefix: "far",
    iconName: "arrow-alt-circle-down",
    icon: [
        512,
        512,
        [],
        "f358",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm-32-316v116h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5h-67V140c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12z"
    ]
};
var $77643f1129269c08$export$5460a5b11a24996f = {
    prefix: "far",
    iconName: "arrow-alt-circle-left",
    icon: [
        512,
        512,
        [],
        "f359",
        "M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zm448 0c0 110.5-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56s200 89.5 200 200zm-72-20v40c0 6.6-5.4 12-12 12H256v67c0 10.7-12.9 16-20.5 8.5l-99-99c-4.7-4.7-4.7-12.3 0-17l99-99c7.6-7.6 20.5-2.2 20.5 8.5v67h116c6.6 0 12 5.4 12 12z"
    ]
};
var $77643f1129269c08$export$88962ffdad8b856d = {
    prefix: "far",
    iconName: "arrow-alt-circle-right",
    icon: [
        512,
        512,
        [],
        "f35a",
        "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm72 20v-40c0-6.6 5.4-12 12-12h116v-67c0-10.7 12.9-16 20.5-8.5l99 99c4.7 4.7 4.7 12.3 0 17l-99 99c-7.6 7.6-20.5 2.2-20.5-8.5v-67H140c-6.6 0-12-5.4-12-12z"
    ]
};
var $77643f1129269c08$export$3747a8ef0995eadf = {
    prefix: "far",
    iconName: "arrow-alt-circle-up",
    icon: [
        512,
        512,
        [],
        "f35b",
        "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zm0-448c110.5 0 200 89.5 200 200s-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56zm20 328h-40c-6.6 0-12-5.4-12-12V256h-67c-10.7 0-16-12.9-8.5-20.5l99-99c4.7-4.7 12.3-4.7 17 0l99 99c7.6 7.6 2.2 20.5-8.5 20.5h-67v116c0 6.6-5.4 12-12 12z"
    ]
};
var $77643f1129269c08$export$9b6162797ab1b255 = {
    prefix: "far",
    iconName: "bell",
    icon: [
        448,
        512,
        [],
        "f0f3",
        "M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z"
    ]
};
var $77643f1129269c08$export$6b31a1e5968b2378 = {
    prefix: "far",
    iconName: "bell-slash",
    icon: [
        640,
        512,
        [],
        "f1f6",
        "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM163.53 368c16.71-22.03 34.48-55.8 41.4-110.58l-45.47-35.55c-3.27 90.73-36.47 120.68-54.84 140.42-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h279.66l-61.4-48H163.53zM320 96c61.86 0 112 50.14 112 112 0 .2-.06.38-.06.58.02 16.84 1.16 31.77 2.79 45.73l59.53 46.54c-8.31-22.13-14.34-51.49-14.34-92.85 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-26.02 5.41-49.45 16.94-69.13 32.72l38.17 29.84C275 103.18 296.65 96 320 96zm0 416c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
    ]
};
var $77643f1129269c08$export$4ed9da5c3cca0ef1 = {
    prefix: "far",
    iconName: "bookmark",
    icon: [
        384,
        512,
        [],
        "f02e",
        "M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"
    ]
};
var $77643f1129269c08$export$f26673f8b10c3d46 = {
    prefix: "far",
    iconName: "building",
    icon: [
        448,
        512,
        [],
        "f1ad",
        "M128 148v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zm140 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-128 96h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm128 0h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-76 84v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm76 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm180 124v36H0v-36c0-6.6 5.4-12 12-12h19.5V24c0-13.3 10.7-24 24-24h337c13.3 0 24 10.7 24 24v440H436c6.6 0 12 5.4 12 12zM79.5 463H192v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5V49L80 48l-.5 415z"
    ]
};
var $77643f1129269c08$export$34f5c36a3e80efa2 = {
    prefix: "far",
    iconName: "calendar",
    icon: [
        448,
        512,
        [],
        "f133",
        "M400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"
    ]
};
var $77643f1129269c08$export$cbc139f33cff356 = {
    prefix: "far",
    iconName: "calendar-alt",
    icon: [
        448,
        512,
        [],
        "f073",
        "M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var $77643f1129269c08$export$5655108e1162ba45 = {
    prefix: "far",
    iconName: "calendar-check",
    icon: [
        448,
        512,
        [],
        "f274",
        "M400 64h-48V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H160V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V160h352v298a6 6 0 0 1-6 6zm-52.849-200.65L198.842 404.519c-4.705 4.667-12.303 4.637-16.971-.068l-75.091-75.699c-4.667-4.705-4.637-12.303.068-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l44.104 44.461 111.072-110.181c4.705-4.667 12.303-4.637 16.971.068l22.536 22.718c4.667 4.705 4.636 12.303-.069 16.97z"
    ]
};
var $77643f1129269c08$export$23e8b4955c2d951b = {
    prefix: "far",
    iconName: "calendar-minus",
    icon: [
        448,
        512,
        [],
        "f272",
        "M124 328c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H124zm324-216v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var $77643f1129269c08$export$16768a660ae3ca9d = {
    prefix: "far",
    iconName: "calendar-plus",
    icon: [
        448,
        512,
        [],
        "f271",
        "M336 292v24c0 6.6-5.4 12-12 12h-76v76c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-76h-76c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h76v-76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v76h76c6.6 0 12 5.4 12 12zm112-180v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var $77643f1129269c08$export$99b20d7352fbcf08 = {
    prefix: "far",
    iconName: "calendar-times",
    icon: [
        448,
        512,
        [],
        "f273",
        "M311.7 374.7l-17 17c-4.7 4.7-12.3 4.7-17 0L224 337.9l-53.7 53.7c-4.7 4.7-12.3 4.7-17 0l-17-17c-4.7-4.7-4.7-12.3 0-17l53.7-53.7-53.7-53.7c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l53.7 53.7 53.7-53.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17L257.9 304l53.7 53.7c4.8 4.7 4.8 12.3.1 17zM448 112v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var $77643f1129269c08$export$61aea18df1c84401 = {
    prefix: "far",
    iconName: "caret-square-down",
    icon: [
        448,
        512,
        [],
        "f150",
        "M125.1 208h197.8c10.7 0 16.1 13 8.5 20.5l-98.9 98.3c-4.7 4.7-12.2 4.7-16.9 0l-98.9-98.3c-7.7-7.5-2.3-20.5 8.4-20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var $77643f1129269c08$export$d0c8ba444f1f9581 = {
    prefix: "far",
    iconName: "caret-square-left",
    icon: [
        448,
        512,
        [],
        "f191",
        "M272 157.1v197.8c0 10.7-13 16.1-20.5 8.5l-98.3-98.9c-4.7-4.7-4.7-12.2 0-16.9l98.3-98.9c7.5-7.7 20.5-2.3 20.5 8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var $77643f1129269c08$export$ae86c9de7e0f62fa = {
    prefix: "far",
    iconName: "caret-square-right",
    icon: [
        448,
        512,
        [],
        "f152",
        "M176 354.9V157.1c0-10.7 13-16.1 20.5-8.5l98.3 98.9c4.7 4.7 4.7 12.2 0 16.9l-98.3 98.9c-7.5 7.7-20.5 2.3-20.5-8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var $77643f1129269c08$export$307ae80b26533ce5 = {
    prefix: "far",
    iconName: "caret-square-up",
    icon: [
        448,
        512,
        [],
        "f151",
        "M322.9 304H125.1c-10.7 0-16.1-13-8.5-20.5l98.9-98.3c4.7-4.7 12.2-4.7 16.9 0l98.9 98.3c7.7 7.5 2.3 20.5-8.4 20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var $77643f1129269c08$export$b532f5d25de97633 = {
    prefix: "far",
    iconName: "chart-bar",
    icon: [
        512,
        512,
        [],
        "f080",
        "M396.8 352h22.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h22.4c6.4 0 12.8-6.4 12.8-12.8V140.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h22.4c6.4 0 12.8-6.4 12.8-12.8V204.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-387.2-48h22.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8z"
    ]
};
var $77643f1129269c08$export$be9e388158c74f29 = {
    prefix: "far",
    iconName: "check-circle",
    icon: [
        512,
        512,
        [],
        "f058",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
    ]
};
var $77643f1129269c08$export$f0c8040f596df7fe = {
    prefix: "far",
    iconName: "check-square",
    icon: [
        448,
        512,
        [],
        "f14a",
        "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z"
    ]
};
var $77643f1129269c08$export$4280b2387fbdad12 = {
    prefix: "far",
    iconName: "circle",
    icon: [
        512,
        512,
        [],
        "f111",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"
    ]
};
var $77643f1129269c08$export$97d84347d71ba297 = {
    prefix: "far",
    iconName: "clipboard",
    icon: [
        384,
        512,
        [],
        "f328",
        "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"
    ]
};
var $77643f1129269c08$export$95b9968e7fceb821 = {
    prefix: "far",
    iconName: "clock",
    icon: [
        512,
        512,
        [],
        "f017",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"
    ]
};
var $77643f1129269c08$export$76c1aa4bf9a39458 = {
    prefix: "far",
    iconName: "clone",
    icon: [
        512,
        512,
        [],
        "f24d",
        "M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"
    ]
};
var $77643f1129269c08$export$8e047801a8603af7 = {
    prefix: "far",
    iconName: "closed-captioning",
    icon: [
        512,
        512,
        [],
        "f20a",
        "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 336H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v276c0 3.3-2.7 6-6 6zm-211.1-85.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7zm190.4 0c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.9-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 220.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7z"
    ]
};
var $77643f1129269c08$export$805cd88398a70581 = {
    prefix: "far",
    iconName: "comment",
    icon: [
        512,
        512,
        [],
        "f075",
        "M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
    ]
};
var $77643f1129269c08$export$6e96904d9af0ec4a = {
    prefix: "far",
    iconName: "comment-alt",
    icon: [
        512,
        512,
        [],
        "f27a",
        "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288z"
    ]
};
var $77643f1129269c08$export$63ffcb3d4e94cb92 = {
    prefix: "far",
    iconName: "comment-dots",
    icon: [
        512,
        512,
        [],
        "f4ad",
        "M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
    ]
};
var $77643f1129269c08$export$932912e74adb8939 = {
    prefix: "far",
    iconName: "comments",
    icon: [
        576,
        512,
        [],
        "f086",
        "M532 386.2c27.5-27.1 44-61.1 44-98.2 0-80-76.5-146.1-176.2-157.9C368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192c0 37 16.5 71 44 98.2-15.3 30.7-37.3 54.5-37.7 54.9-6.3 6.7-8.1 16.5-4.4 25 3.6 8.5 12 14 21.2 14 53.5 0 96.7-20.2 125.2-38.8 9.2 2.1 18.7 3.7 28.4 4.9C208.1 407.6 281.8 448 368 448c20.8 0 40.8-2.4 59.8-6.8C456.3 459.7 499.4 480 553 480c9.2 0 17.5-5.5 21.2-14 3.6-8.5 1.9-18.3-4.4-25-.4-.3-22.5-24.1-37.8-54.8zm-392.8-92.3L122.1 305c-14.1 9.1-28.5 16.3-43.1 21.4 2.7-4.7 5.4-9.7 8-14.8l15.5-31.1L77.7 256C64.2 242.6 48 220.7 48 192c0-60.7 73.3-112 160-112s160 51.3 160 112-73.3 112-160 112c-16.5 0-33-1.9-49-5.6l-19.8-4.5zM498.3 352l-24.7 24.4 15.5 31.1c2.6 5.1 5.3 10.1 8 14.8-14.6-5.1-29-12.3-43.1-21.4l-17.1-11.1-19.9 4.6c-16 3.7-32.5 5.6-49 5.6-54 0-102.2-20.1-131.3-49.7C338 339.5 416 272.9 416 192c0-3.4-.4-6.7-.7-10C479.7 196.5 528 238.8 528 288c0 28.7-16.2 50.6-29.7 64z"
    ]
};
var $77643f1129269c08$export$b4d344633433e50e = {
    prefix: "far",
    iconName: "compass",
    icon: [
        496,
        512,
        [],
        "f14e",
        "M347.94 129.86L203.6 195.83a31.938 31.938 0 0 0-15.77 15.77l-65.97 144.34c-7.61 16.65 9.54 33.81 26.2 26.2l144.34-65.97a31.938 31.938 0 0 0 15.77-15.77l65.97-144.34c7.61-16.66-9.54-33.81-26.2-26.2zm-77.36 148.72c-12.47 12.47-32.69 12.47-45.16 0-12.47-12.47-12.47-32.69 0-45.16 12.47-12.47 32.69-12.47 45.16 0 12.47 12.47 12.47 32.69 0 45.16zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
    ]
};
var $77643f1129269c08$export$e9bd786d30cb716c = {
    prefix: "far",
    iconName: "copy",
    icon: [
        448,
        512,
        [],
        "f0c5",
        "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"
    ]
};
var $77643f1129269c08$export$da61665fff8aebfe = {
    prefix: "far",
    iconName: "copyright",
    icon: [
        512,
        512,
        [],
        "f1f9",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm107.351-101.064c-9.614 9.712-45.53 41.396-104.065 41.396-82.43 0-140.484-61.425-140.484-141.567 0-79.152 60.275-139.401 139.762-139.401 55.531 0 88.738 26.62 97.593 34.779a11.965 11.965 0 0 1 1.936 15.322l-18.155 28.113c-3.841 5.95-11.966 7.282-17.499 2.921-8.595-6.776-31.814-22.538-61.708-22.538-48.303 0-77.916 35.33-77.916 80.082 0 41.589 26.888 83.692 78.277 83.692 32.657 0 56.843-19.039 65.726-27.225 5.27-4.857 13.596-4.039 17.82 1.738l19.865 27.17a11.947 11.947 0 0 1-1.152 15.518z"
    ]
};
var $77643f1129269c08$export$3e7437bf6535bef0 = {
    prefix: "far",
    iconName: "credit-card",
    icon: [
        576,
        512,
        [],
        "f09d",
        "M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"
    ]
};
var $77643f1129269c08$export$89a2b10dabc487e8 = {
    prefix: "far",
    iconName: "dizzy",
    icon: [
        496,
        512,
        [],
        "f567",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-33.8-217.9c7.8-7.8 7.8-20.5 0-28.3L196.3 192l17.9-17.9c7.8-7.8 7.8-20.5 0-28.3-7.8-7.8-20.5-7.8-28.3 0L168 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.9 7.7 20.5 7.7 28.4-.2zm160-92.2c-7.8-7.8-20.5-7.8-28.3 0L328 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.8 7.8 20.5 7.8 28.3 0 7.8-7.8 7.8-20.5 0-28.3l-17.8-18 17.9-17.9c7.7-7.8 7.7-20.4 0-28.2zM248 272c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"
    ]
};
var $77643f1129269c08$export$92bc269cb244d66a = {
    prefix: "far",
    iconName: "dot-circle",
    icon: [
        512,
        512,
        [],
        "f192",
        "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
    ]
};
var $77643f1129269c08$export$7be713e57d023733 = {
    prefix: "far",
    iconName: "edit",
    icon: [
        576,
        512,
        [],
        "f044",
        "M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1.8-4.1 2.3-5.6zm156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8zM460.1 174L402 115.9 216.2 301.8l-7.3 65.3 65.3-7.3L460.1 174zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1 30.9-30.9c4-4.2 4-10.8-.1-14.9z"
    ]
};
var $77643f1129269c08$export$6f095630677adc = {
    prefix: "far",
    iconName: "envelope",
    icon: [
        512,
        512,
        [],
        "f0e0",
        "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
    ]
};
var $77643f1129269c08$export$c6c3bd5f7d9b8bf2 = {
    prefix: "far",
    iconName: "envelope-open",
    icon: [
        512,
        512,
        [],
        "f2b6",
        "M494.586 164.516c-4.697-3.883-111.723-89.95-135.251-108.657C337.231 38.191 299.437 0 256 0c-43.205 0-80.636 37.717-103.335 55.859-24.463 19.45-131.07 105.195-135.15 108.549A48.004 48.004 0 0 0 0 201.485V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V201.509a48 48 0 0 0-17.414-36.993zM464 458a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V204.347c0-1.813.816-3.526 2.226-4.665 15.87-12.814 108.793-87.554 132.364-106.293C200.755 78.88 232.398 48 256 48c23.693 0 55.857 31.369 73.41 45.389 23.573 18.741 116.503 93.493 132.366 106.316a5.99 5.99 0 0 1 2.224 4.663V458zm-31.991-187.704c4.249 5.159 3.465 12.795-1.745 16.981-28.975 23.283-59.274 47.597-70.929 56.863C336.636 362.283 299.205 400 256 400c-43.452 0-81.287-38.237-103.335-55.86-11.279-8.967-41.744-33.413-70.927-56.865-5.21-4.187-5.993-11.822-1.745-16.981l15.258-18.528c4.178-5.073 11.657-5.843 16.779-1.726 28.618 23.001 58.566 47.035 70.56 56.571C200.143 320.631 232.307 352 256 352c23.602 0 55.246-30.88 73.41-45.389 11.994-9.535 41.944-33.57 70.563-56.568 5.122-4.116 12.601-3.346 16.778 1.727l15.258 18.526z"
    ]
};
var $77643f1129269c08$export$b8c3e79e8c99c95b = {
    prefix: "far",
    iconName: "eye",
    icon: [
        576,
        512,
        [],
        "f06e",
        "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
    ]
};
var $77643f1129269c08$export$ed3f2918429d029a = {
    prefix: "far",
    iconName: "eye-slash",
    icon: [
        640,
        512,
        [],
        "f070",
        "M634 471L36 3.51A16 16 0 0 0 13.51 6l-10 12.49A16 16 0 0 0 6 41l598 467.49a16 16 0 0 0 22.49-2.49l10-12.49A16 16 0 0 0 634 471zM296.79 146.47l134.79 105.38C429.36 191.91 380.48 144 320 144a112.26 112.26 0 0 0-23.21 2.47zm46.42 219.07L208.42 260.16C210.65 320.09 259.53 368 320 368a113 113 0 0 0 23.21-2.46zM320 112c98.65 0 189.09 55 237.93 144a285.53 285.53 0 0 1-44 60.2l37.74 29.5a333.7 333.7 0 0 0 52.9-75.11 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64c-36.7 0-71.71 7-104.63 18.81l46.41 36.29c18.94-4.3 38.34-7.1 58.22-7.1zm0 288c-98.65 0-189.08-55-237.93-144a285.47 285.47 0 0 1 44.05-60.19l-37.74-29.5a333.6 333.6 0 0 0-52.89 75.1 32.35 32.35 0 0 0 0 29.19C89.72 376.41 197.08 448 320 448c36.7 0 71.71-7.05 104.63-18.81l-46.41-36.28C359.28 397.2 339.89 400 320 400z"
    ]
};
var $77643f1129269c08$export$cad54bead856a678 = {
    prefix: "far",
    iconName: "file",
    icon: [
        384,
        512,
        [],
        "f15b",
        "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"
    ]
};
var $77643f1129269c08$export$243b47dca32bf0b8 = {
    prefix: "far",
    iconName: "file-alt",
    icon: [
        384,
        512,
        [],
        "f15c",
        "M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"
    ]
};
var $77643f1129269c08$export$bf2047a9946b5c3f = {
    prefix: "far",
    iconName: "file-archive",
    icon: [
        384,
        512,
        [],
        "f1c6",
        "M128.3 160v32h32v-32zm64-96h-32v32h32zm-64 32v32h32V96zm64 32h-32v32h32zm177.6-30.1L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h79.7v16h32V48H208v104c0 13.3 10.7 24 24 24h104zM194.2 265.7c-1.1-5.6-6-9.7-11.8-9.7h-22.1v-32h-32v32l-19.7 97.1C102 385.6 126.8 416 160 416c33.1 0 57.9-30.2 51.5-62.6zm-33.9 124.4c-17.9 0-32.4-12.1-32.4-27s14.5-27 32.4-27 32.4 12.1 32.4 27-14.5 27-32.4 27zm32-198.1h-32v32h32z"
    ]
};
var $77643f1129269c08$export$b8d24c57c9e64933 = {
    prefix: "far",
    iconName: "file-audio",
    icon: [
        384,
        512,
        [],
        "f1c7",
        "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm144-76.024c0 10.691-12.926 16.045-20.485 8.485L136 360.486h-28c-6.627 0-12-5.373-12-12v-56c0-6.627 5.373-12 12-12h28l35.515-36.947c7.56-7.56 20.485-2.206 20.485 8.485v135.952zm41.201-47.13c9.051-9.297 9.06-24.133.001-33.439-22.149-22.752 12.235-56.246 34.395-33.481 27.198 27.94 27.212 72.444.001 100.401-21.793 22.386-56.947-10.315-34.397-33.481z"
    ]
};
var $77643f1129269c08$export$143d0ca7d2200f20 = {
    prefix: "far",
    iconName: "file-code",
    icon: [
        384,
        512,
        [],
        "f1c9",
        "M149.9 349.1l-.2-.2-32.8-28.9 32.8-28.9c3.6-3.2 4-8.8.8-12.4l-.2-.2-17.4-18.6c-3.4-3.6-9-3.7-12.4-.4l-57.7 54.1c-3.7 3.5-3.7 9.4 0 12.8l57.7 54.1c1.6 1.5 3.8 2.4 6 2.4 2.4 0 4.8-1 6.4-2.8l17.4-18.6c3.3-3.5 3.1-9.1-.4-12.4zm220-251.2L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h160v104c0 13.3 10.7 24 24 24h104zM209.6 214c-4.7-1.4-9.5 1.3-10.9 6L144 408.1c-1.4 4.7 1.3 9.6 6 10.9l24.4 7.1c4.7 1.4 9.6-1.4 10.9-6L240 231.9c1.4-4.7-1.3-9.6-6-10.9zm24.5 76.9l.2.2 32.8 28.9-32.8 28.9c-3.6 3.2-4 8.8-.8 12.4l.2.2 17.4 18.6c3.3 3.5 8.9 3.7 12.4.4l57.7-54.1c3.7-3.5 3.7-9.4 0-12.8l-57.7-54.1c-3.5-3.3-9.1-3.2-12.4.4l-17.4 18.6c-3.3 3.5-3.1 9.1.4 12.4z"
    ]
};
var $77643f1129269c08$export$77cb1a465c4fe84 = {
    prefix: "far",
    iconName: "file-excel",
    icon: [
        384,
        512,
        [],
        "f1c3",
        "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"
    ]
};
var $77643f1129269c08$export$6440b286d3cbac9b = {
    prefix: "far",
    iconName: "file-image",
    icon: [
        384,
        512,
        [],
        "f1c5",
        "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm32-48h224V288l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0L176 352l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L80 352v64zm48-240c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"
    ]
};
var $77643f1129269c08$export$38611f1c776aba73 = {
    prefix: "far",
    iconName: "file-pdf",
    icon: [
        384,
        512,
        [],
        "f1c1",
        "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"
    ]
};
var $77643f1129269c08$export$c341daeecdea449a = {
    prefix: "far",
    iconName: "file-powerpoint",
    icon: [
        384,
        512,
        [],
        "f1c4",
        "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm72-60V236c0-6.6 5.4-12 12-12h69.2c36.7 0 62.8 27 62.8 66.3 0 74.3-68.7 66.5-95.5 66.5V404c0 6.6-5.4 12-12 12H132c-6.6 0-12-5.4-12-12zm48.5-87.4h23c7.9 0 13.9-2.4 18.1-7.2 8.5-9.8 8.4-28.5.1-37.8-4.1-4.6-9.9-7-17.4-7h-23.9v52z"
    ]
};
var $77643f1129269c08$export$b44eb38345c6a964 = {
    prefix: "far",
    iconName: "file-video",
    icon: [
        384,
        512,
        [],
        "f1c8",
        "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm228.687-211.303L224 305.374V268c0-11.046-8.954-20-20-20H100c-11.046 0-20 8.954-20 20v104c0 11.046 8.954 20 20 20h104c11.046 0 20-8.954 20-20v-37.374l52.687 52.674C286.704 397.318 304 390.28 304 375.986V264.011c0-14.311-17.309-21.319-27.313-11.314z"
    ]
};
var $77643f1129269c08$export$f0858dff6e769cf6 = {
    prefix: "far",
    iconName: "file-word",
    icon: [
        384,
        512,
        [],
        "f1c2",
        "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm220.1-208c-5.7 0-10.6 4-11.7 9.5-20.6 97.7-20.4 95.4-21 103.5-.2-1.2-.4-2.6-.7-4.3-.8-5.1.3.2-23.6-99.5-1.3-5.4-6.1-9.2-11.7-9.2h-13.3c-5.5 0-10.3 3.8-11.7 9.1-24.4 99-24 96.2-24.8 103.7-.1-1.1-.2-2.5-.5-4.2-.7-5.2-14.1-73.3-19.1-99-1.1-5.6-6-9.7-11.8-9.7h-16.8c-7.8 0-13.5 7.3-11.7 14.8 8 32.6 26.7 109.5 33.2 136 1.3 5.4 6.1 9.1 11.7 9.1h25.2c5.5 0 10.3-3.7 11.6-9.1l17.9-71.4c1.5-6.2 2.5-12 3-17.3l2.9 17.3c.1.4 12.6 50.5 17.9 71.4 1.3 5.3 6.1 9.1 11.6 9.1h24.7c5.5 0 10.3-3.7 11.6-9.1 20.8-81.9 30.2-119 34.5-136 1.9-7.6-3.8-14.9-11.6-14.9h-15.8z"
    ]
};
var $77643f1129269c08$export$6591b1ea509be9da = {
    prefix: "far",
    iconName: "flag",
    icon: [
        512,
        512,
        [],
        "f024",
        "M336.174 80c-49.132 0-93.305-32-161.913-32-31.301 0-58.303 6.482-80.721 15.168a48.04 48.04 0 0 0 2.142-20.727C93.067 19.575 74.167 1.594 51.201.104 23.242-1.71 0 20.431 0 48c0 17.764 9.657 33.262 24 41.562V496c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-83.443C109.869 395.28 143.259 384 199.826 384c49.132 0 93.305 32 161.913 32 58.479 0 101.972-22.617 128.548-39.981C503.846 367.161 512 352.051 512 335.855V95.937c0-34.459-35.264-57.768-66.904-44.117C409.193 67.309 371.641 80 336.174 80zM464 336c-21.783 15.412-60.824 32-102.261 32-59.945 0-102.002-32-161.913-32-43.361 0-96.379 9.403-127.826 24V128c21.784-15.412 60.824-32 102.261-32 59.945 0 102.002 32 161.913 32 43.271 0 96.32-17.366 127.826-32v240z"
    ]
};
var $77643f1129269c08$export$dfd2bd012685aeac = {
    prefix: "far",
    iconName: "flushed",
    icon: [
        496,
        512,
        [],
        "f579",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm96-312c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-112 24c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80 80-35.8 80-80zm-80 48c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm160 144H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
    ]
};
var $77643f1129269c08$export$72b780186370e953 = {
    prefix: "far",
    iconName: "folder",
    icon: [
        512,
        512,
        [],
        "f07b",
        "M464 128H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm0 272H48V112h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H464v224z"
    ]
};
var $77643f1129269c08$export$ff7e93418af88b78 = {
    prefix: "far",
    iconName: "folder-open",
    icon: [
        576,
        512,
        [],
        "f07c",
        "M527.9 224H480v-48c0-26.5-21.5-48-48-48H272l-64-64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h400c16.5 0 31.9-8.5 40.7-22.6l79.9-128c20-31.9-3-73.4-40.7-73.4zM48 118c0-3.3 2.7-6 6-6h134.1l64 64H426c3.3 0 6 2.7 6 6v42H152c-16.8 0-32.4 8.8-41.1 23.2L48 351.4zm400 282H72l77.2-128H528z"
    ]
};
var $77643f1129269c08$export$6e20d421a2e0f320 = {
    prefix: "far",
    iconName: "font-awesome-logo-full",
    icon: [
        3992,
        512,
        [
            "Font Awesome"
        ],
        "f4e6",
        "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"
    ]
};
var $77643f1129269c08$export$43b7108508aecc5f = {
    prefix: "far",
    iconName: "frown",
    icon: [
        496,
        512,
        [],
        "f119",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 128c-40.2 0-78 17.7-103.8 48.6-8.5 10.2-7.1 25.3 3.1 33.8 10.2 8.4 25.3 7.1 33.8-3.1 16.6-19.9 41-31.4 66.9-31.4s50.3 11.4 66.9 31.4c8.1 9.7 23.1 11.9 33.8 3.1 10.2-8.5 11.5-23.6 3.1-33.8C326 321.7 288.2 304 248 304z"
    ]
};
var $77643f1129269c08$export$c4775e66bed5d96 = {
    prefix: "far",
    iconName: "frown-open",
    icon: [
        496,
        512,
        [],
        "f57a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-48-248c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 112c-35.6 0-88.8 21.3-95.8 61.2-2 11.8 9 21.5 20.5 18.1 31.2-9.6 59.4-15.3 75.3-15.3s44.1 5.7 75.3 15.3c11.4 3.5 22.5-6.3 20.5-18.1-7-39.9-60.2-61.2-95.8-61.2z"
    ]
};
var $77643f1129269c08$export$65a345b33858a655 = {
    prefix: "far",
    iconName: "futbol",
    icon: [
        496,
        512,
        [],
        "f1e3",
        "M483.8 179.4C449.8 74.6 352.6 8 248.1 8c-25.4 0-51.2 3.9-76.7 12.2C41.2 62.5-30.1 202.4 12.2 332.6 46.2 437.4 143.4 504 247.9 504c25.4 0 51.2-3.9 76.7-12.2 130.2-42.3 201.5-182.2 159.2-312.4zm-74.5 193.7l-52.2 6.4-43.7-60.9 24.4-75.2 71.1-22.1 38.9 36.4c-.2 30.7-7.4 61.1-21.7 89.2-4.7 9.3-10.7 17.8-16.8 26.2zm0-235.4l-10.4 53.1-70.7 22-64.2-46.5V92.5l47.4-26.2c39.2 13 73.4 38 97.9 71.4zM184.9 66.4L232 92.5v73.8l-64.2 46.5-70.6-22-10.1-52.5c24.3-33.4 57.9-58.6 97.8-71.9zM139 379.5L85.9 373c-14.4-20.1-37.3-59.6-37.8-115.3l39-36.4 71.1 22.2 24.3 74.3-43.5 61.7zm48.2 67l-22.4-48.1 43.6-61.7H287l44.3 61.7-22.4 48.1c-6.2 1.8-57.6 20.4-121.7 0z"
    ]
};
var $77643f1129269c08$export$31ee86ac717db552 = {
    prefix: "far",
    iconName: "gem",
    icon: [
        576,
        512,
        [],
        "f3a5",
        "M464 0H112c-4 0-7.8 2-10 5.4L2 152.6c-2.9 4.4-2.6 10.2.7 14.2l276 340.8c4.8 5.9 13.8 5.9 18.6 0l276-340.8c3.3-4.1 3.6-9.8.7-14.2L474.1 5.4C471.8 2 468.1 0 464 0zm-19.3 48l63.3 96h-68.4l-51.7-96h56.8zm-202.1 0h90.7l51.7 96H191l51.6-96zm-111.3 0h56.8l-51.7 96H68l63.3-96zm-43 144h51.4L208 352 88.3 192zm102.9 0h193.6L288 435.3 191.2 192zM368 352l68.2-160h51.4L368 352z"
    ]
};
var $77643f1129269c08$export$3d08cd36ac1ef231 = {
    prefix: "far",
    iconName: "grimace",
    icon: [
        496,
        512,
        [],
        "f57f",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm16 16H152c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48zm-168 96h-24c-8.8 0-16-7.2-16-16v-8h40v24zm0-40h-40v-8c0-8.8 7.2-16 16-16h24v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm56 24c0 8.8-7.2 16-16 16h-24v-24h40v8zm0-24h-40v-24h24c8.8 0 16 7.2 16 16v8z"
    ]
};
var $77643f1129269c08$export$37e1f10b6de76621 = {
    prefix: "far",
    iconName: "grin",
    icon: [
        496,
        512,
        [],
        "f580",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
    ]
};
var $77643f1129269c08$export$b4abebfe416d36ba = {
    prefix: "far",
    iconName: "grin-alt",
    icon: [
        496,
        512,
        [],
        "f581",
        "M200.3 248c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zm128 0c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3z"
    ]
};
var $77643f1129269c08$export$734da5249381ec7e = {
    prefix: "far",
    iconName: "grin-beam",
    icon: [
        496,
        512,
        [],
        "f582",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-235.9-72.9c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm160 0c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3z"
    ]
};
var $77643f1129269c08$export$14d0ccc54c5b6826 = {
    prefix: "far",
    iconName: "grin-beam-sweat",
    icon: [
        496,
        512,
        [],
        "f583",
        "M440 160c29.5 0 53.3-26.3 53.3-58.7 0-25-31.7-75.5-46.2-97.3-3.6-5.3-10.7-5.3-14.2 0-14.5 21.8-46.2 72.3-46.2 97.3 0 32.4 23.8 58.7 53.3 58.7zM248 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zm105.3-52.9c-24.6 15.7-46 12.9-46.4 12.9 6.9 20.2 10.8 41.8 10.8 64.3 0 110.3-89.7 200-200 200S48 366.3 48 256 137.7 56 248 56c39.8 0 76.8 11.8 108 31.9 1.7-9.5 6.3-24.1 17.2-45.7C336.4 20.6 293.7 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-27-4.4-52.9-12.4-77.2zM168 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
    ]
};
var $77643f1129269c08$export$c56cf0e0c3bc5ed2 = {
    prefix: "far",
    iconName: "grin-hearts",
    icon: [
        496,
        512,
        [],
        "f584",
        "M353.6 304.6c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-152.8-48.9c4.5 1.2 9.2-1.5 10.5-6l19.4-69.9c5.6-20.3-7.4-41.1-28.8-44.5-18.6-3-36.4 9.8-41.5 27.9l-2 7.1-7.1-1.9c-18.2-4.7-38.2 4.3-44.9 22-7.7 20.2 3.8 41.9 24.2 47.2l70.2 18.1zm188.8-65.3c-6.7-17.6-26.7-26.7-44.9-22l-7.1 1.9-2-7.1c-5-18.1-22.8-30.9-41.5-27.9-21.4 3.4-34.4 24.2-28.8 44.5l19.4 69.9c1.2 4.5 5.9 7.2 10.5 6l70.2-18.2c20.4-5.3 31.9-26.9 24.2-47.1zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200z"
    ]
};
var $77643f1129269c08$export$243ae757907b1580 = {
    prefix: "far",
    iconName: "grin-squint",
    icon: [
        496,
        512,
        [],
        "f585",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-234.7-40.8c3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3l-80-48c-5.1-3-11.4-1.9-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11.1.1 15.5zm242.9 2.5c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11-.1-15.5-3.8-4.4-10.2-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48z"
    ]
};
var $77643f1129269c08$export$542206d6a85f3b42 = {
    prefix: "far",
    iconName: "grin-squint-tears",
    icon: [
        512,
        512,
        [],
        "f586",
        "M117.1 384.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 479 124.3 420.8 128 395c.8-6.4-4.6-11.8-10.9-10.9zm-41.2-41.7C40.3 268 53 176.1 114.6 114.6 152.4 76.8 202.6 56 256 56c36.2 0 70.8 9.8 101.2 27.7 3.8-20.3 8-36.1 12-48.3C333.8 17.2 294.9 8 256 8 192.5 8 129.1 32.2 80.6 80.6c-74.1 74.1-91.3 183.4-52 274 12.2-4.1 27.7-8.3 47.3-12.2zm352.3-187.6c45 76.6 34.9 176.9-30.8 242.6-37.8 37.8-88 58.6-141.4 58.6-30.5 0-59.8-7-86.4-19.8-3.9 19.5-8 35-12.2 47.2 31.4 13.6 65 20.6 98.7 20.6 63.5 0 126.9-24.2 175.4-72.6 78.1-78.1 93.1-195.4 45.2-288.6-12.3 4-28.2 8.1-48.5 12zm-33.3-26.9c25.8-3.7 84-13.7 100.9-30.6 21.9-21.9 21.5-57.9-.9-80.3s-58.3-22.8-80.3-.9C397.7 33 387.7 91.2 384 117c-.8 6.4 4.6 11.8 10.9 10.9zm-187 108.3c-3-3-7.2-4.2-11.4-3.2L106 255.7c-5.7 1.4-9.5 6.7-9.1 12.6.5 5.8 5.1 10.5 10.9 11l52.3 4.8 4.8 52.3c.5 5.8 5.2 10.4 11 10.9h.9c5.5 0 10.3-3.7 11.7-9.1l22.6-90.5c1-4.2-.2-8.5-3.2-11.5zm39.7-25.1l90.5-22.6c5.7-1.4 9.5-6.7 9.1-12.6-.5-5.8-5.1-10.5-10.9-11l-52.3-4.8-4.8-52.3c-.5-5.8-5.2-10.4-11-10.9-5.6-.1-11.2 3.4-12.6 9.1L233 196.5c-1 4.1.2 8.4 3.2 11.4 5 5 11.3 3.2 11.4 3.2zm52 88.5c-29.1 29.1-59.7 52.9-83.9 65.4-9.2 4.8-10 17.5-1.7 23.4 38.9 27.7 107 6.2 143.7-30.6S416 253 388.3 214.1c-5.8-8.2-18.5-7.6-23.4 1.7-12.3 24.2-36.2 54.7-65.3 83.8z"
    ]
};
var $77643f1129269c08$export$64347a5c8c402ef4 = {
    prefix: "far",
    iconName: "grin-stars",
    icon: [
        496,
        512,
        [],
        "f587",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-227.9-57.5c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.5 1.9-12.2-4.3-13.2l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6.1 34.9zm259.7-72.7l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6 34.9c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.6 1.8-12.2-4.4-13.2z"
    ]
};
var $77643f1129269c08$export$b2f7512221512b5b = {
    prefix: "far",
    iconName: "grin-tears",
    icon: [
        640,
        512,
        [],
        "f588",
        "M117.1 256.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 351 124.3 292.8 128 267c.8-6.4-4.6-11.8-10.9-10.9zm506.7 30.6c-16.9-16.9-75.1-26.9-100.9-30.6-6.3-.9-11.7 4.5-10.8 10.8 3.7 25.8 13.7 84 30.6 100.9 21.9 21.9 57.9 21.5 80.3-.9 22.3-22.3 22.7-58.3.8-80.2zm-126.6 61.7C463.8 412.3 396.9 456 320 456c-76.9 0-143.8-43.7-177.2-107.6-12.5 37.4-25.2 43.9-28.3 46.5C159.1 460.7 234.5 504 320 504s160.9-43.3 205.5-109.1c-3.2-2.7-15.9-9.2-28.3-46.5zM122.7 224.5C137.9 129.2 220.5 56 320 56c99.5 0 182.1 73.2 197.3 168.5 2.1-.2 5.2-2.4 49.5 7C554.4 106 448.7 8 320 8S85.6 106 73.2 231.4c44.5-9.4 47.1-7.2 49.5-6.9zM320 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zM240 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
    ]
};
var $77643f1129269c08$export$ef222816a43a4b3a = {
    prefix: "far",
    iconName: "grin-tongue",
    icon: [
        496,
        512,
        [],
        "f589",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zM168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
    ]
};
var $77643f1129269c08$export$4edf34c3def09a31 = {
    prefix: "far",
    iconName: "grin-tongue-squint",
    icon: [
        496,
        512,
        [],
        "f58a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zm36.9-281.1c-3.8-4.4-10.3-5.5-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zm-162.9 45.5l-80-48c-5-3-11.4-2-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3z"
    ]
};
var $77643f1129269c08$export$58099903d50aefb3 = {
    prefix: "far",
    iconName: "grin-tongue-wink",
    icon: [
        496,
        512,
        [],
        "f58b",
        "M152 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm176-52c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3z"
    ]
};
var $77643f1129269c08$export$2397fcd34eb12177 = {
    prefix: "far",
    iconName: "grin-wink",
    icon: [
        496,
        512,
        [],
        "f58c",
        "M328 180c-25.69 0-55.88 16.92-59.86 42.12-1.75 11.22 11.5 18.24 19.83 10.84l9.55-8.48c14.81-13.19 46.16-13.19 60.97 0l9.55 8.48c8.48 7.43 21.56.25 19.83-10.84C383.88 196.92 353.69 180 328 180zm-160 60c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm185.55 64.64c-25.93 8.3-64.4 13.06-105.55 13.06s-79.62-4.75-105.55-13.06c-9.94-3.13-19.4 5.37-17.71 15.34C132.67 367.13 196.06 400 248 400s115.33-32.87 123.26-80.02c1.68-9.89-7.67-18.48-17.71-15.34zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
    ]
};
var $77643f1129269c08$export$54608d0a883fea4d = {
    prefix: "far",
    iconName: "hand-lizard",
    icon: [
        576,
        512,
        [],
        "f258",
        "M556.686 290.542L410.328 64.829C397.001 44.272 374.417 32 349.917 32H56C25.121 32 0 57.122 0 88v8c0 44.112 35.888 80 80 80h196.042l-18.333 48H144c-48.523 0-88 39.477-88 88 0 30.879 25.121 56 56 56h131.552c2.987 0 5.914.549 8.697 1.631L352 408.418V480h224V355.829c0-23.225-6.679-45.801-19.314-65.287zM528 432H400v-23.582c0-19.948-12.014-37.508-30.604-44.736l-99.751-38.788A71.733 71.733 0 0 0 243.552 320H112c-4.411 0-8-3.589-8-8 0-22.056 17.944-40 40-40h113.709c19.767 0 37.786-12.407 44.84-30.873l24.552-64.281c8.996-23.553-8.428-48.846-33.63-48.846H80c-17.645 0-32-14.355-32-32v-8c0-4.411 3.589-8 8-8h293.917c8.166 0 15.693 4.09 20.137 10.942l146.358 225.715A71.84 71.84 0 0 1 528 355.829V432z"
    ]
};
var $77643f1129269c08$export$6e6216c8b50471bb = {
    prefix: "far",
    iconName: "hand-paper",
    icon: [
        448,
        512,
        [],
        "f256",
        "M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z"
    ]
};
var $77643f1129269c08$export$e49e3cfceea441cc = {
    prefix: "far",
    iconName: "hand-peace",
    icon: [
        448,
        512,
        [],
        "f25b",
        "M362.146 191.976c-13.71-21.649-38.761-34.016-65.006-30.341V74c0-40.804-32.811-74-73.141-74-40.33 0-73.14 33.196-73.14 74L160 168l-18.679-78.85C126.578 50.843 83.85 32.11 46.209 47.208 8.735 62.238-9.571 104.963 5.008 142.85l55.757 144.927c-30.557 24.956-43.994 57.809-24.733 92.218l54.853 97.999C102.625 498.97 124.73 512 148.575 512h205.702c30.744 0 57.558-21.44 64.555-51.797l27.427-118.999a67.801 67.801 0 0 0 1.729-15.203L448 256c0-44.956-43.263-77.343-85.854-64.024zM399.987 326c0 1.488-.169 2.977-.502 4.423l-27.427 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H148.575c-6.486 0-12.542-3.621-15.805-9.449l-54.854-98c-4.557-8.141-2.619-18.668 4.508-24.488l26.647-21.764a16 16 0 0 0 4.812-18.139l-64.09-166.549C37.226 92.956 84.37 74.837 96.51 106.389l59.784 155.357A16 16 0 0 0 171.227 272h11.632c8.837 0 16-7.163 16-16V74c0-34.375 50.281-34.43 50.281 0v182c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16v-28c0-25.122 36.567-25.159 36.567 0v28c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16 0-25.12 36.567-25.16 36.567 0v70z"
    ]
};
var $77643f1129269c08$export$f6dcbf0a940428f4 = {
    prefix: "far",
    iconName: "hand-point-down",
    icon: [
        448,
        512,
        [],
        "f0a7",
        "M188.8 512c45.616 0 83.2-37.765 83.2-83.2v-35.647a93.148 93.148 0 0 0 22.064-7.929c22.006 2.507 44.978-3.503 62.791-15.985C409.342 368.1 448 331.841 448 269.299V248c0-60.063-40-98.512-40-127.2v-2.679c4.952-5.747 8-13.536 8-22.12V32c0-17.673-12.894-32-28.8-32H156.8C140.894 0 128 14.327 128 32v64c0 8.584 3.048 16.373 8 22.12v2.679c0 6.964-6.193 14.862-23.668 30.183l-.148.129-.146.131c-9.937 8.856-20.841 18.116-33.253 25.851C48.537 195.798 0 207.486 0 252.8c0 56.928 35.286 92 83.2 92 8.026 0 15.489-.814 22.4-2.176V428.8c0 45.099 38.101 83.2 83.2 83.2zm0-48c-18.7 0-35.2-16.775-35.2-35.2V270.4c-17.325 0-35.2 26.4-70.4 26.4-26.4 0-35.2-20.625-35.2-44 0-8.794 32.712-20.445 56.1-34.926 14.575-9.074 27.225-19.524 39.875-30.799 18.374-16.109 36.633-33.836 39.596-59.075h176.752C364.087 170.79 400 202.509 400 248v21.299c0 40.524-22.197 57.124-61.325 50.601-8.001 14.612-33.979 24.151-53.625 12.925-18.225 19.365-46.381 17.787-61.05 4.95V428.8c0 18.975-16.225 35.2-35.2 35.2zM328 64c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24z"
    ]
};
var $77643f1129269c08$export$b276ec3dc9760d39 = {
    prefix: "far",
    iconName: "hand-point-left",
    icon: [
        512,
        512,
        [],
        "f0a5",
        "M0 220.8C0 266.416 37.765 304 83.2 304h35.647a93.148 93.148 0 0 0 7.929 22.064c-2.507 22.006 3.503 44.978 15.985 62.791C143.9 441.342 180.159 480 242.701 480H264c60.063 0 98.512-40 127.2-40h2.679c5.747 4.952 13.536 8 22.12 8h64c17.673 0 32-12.894 32-28.8V188.8c0-15.906-14.327-28.8-32-28.8h-64c-8.584 0-16.373 3.048-22.12 8H391.2c-6.964 0-14.862-6.193-30.183-23.668l-.129-.148-.131-.146c-8.856-9.937-18.116-20.841-25.851-33.253C316.202 80.537 304.514 32 259.2 32c-56.928 0-92 35.286-92 83.2 0 8.026.814 15.489 2.176 22.4H83.2C38.101 137.6 0 175.701 0 220.8zm48 0c0-18.7 16.775-35.2 35.2-35.2h158.4c0-17.325-26.4-35.2-26.4-70.4 0-26.4 20.625-35.2 44-35.2 8.794 0 20.445 32.712 34.926 56.1 9.074 14.575 19.524 27.225 30.799 39.875 16.109 18.374 33.836 36.633 59.075 39.596v176.752C341.21 396.087 309.491 432 264 432h-21.299c-40.524 0-57.124-22.197-50.601-61.325-14.612-8.001-24.151-33.979-12.925-53.625-19.365-18.225-17.787-46.381-4.95-61.05H83.2C64.225 256 48 239.775 48 220.8zM448 360c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
    ]
};
var $77643f1129269c08$export$f7bc8714c970afa4 = {
    prefix: "far",
    iconName: "hand-point-right",
    icon: [
        512,
        512,
        [],
        "f0a4",
        "M428.8 137.6h-86.177a115.52 115.52 0 0 0 2.176-22.4c0-47.914-35.072-83.2-92-83.2-45.314 0-57.002 48.537-75.707 78.784-7.735 12.413-16.994 23.317-25.851 33.253l-.131.146-.129.148C135.662 161.807 127.764 168 120.8 168h-2.679c-5.747-4.952-13.536-8-22.12-8H32c-17.673 0-32 12.894-32 28.8v230.4C0 435.106 14.327 448 32 448h64c8.584 0 16.373-3.048 22.12-8h2.679c28.688 0 67.137 40 127.2 40h21.299c62.542 0 98.8-38.658 99.94-91.145 12.482-17.813 18.491-40.785 15.985-62.791A93.148 93.148 0 0 0 393.152 304H428.8c45.435 0 83.2-37.584 83.2-83.2 0-45.099-38.101-83.2-83.2-83.2zm0 118.4h-91.026c12.837 14.669 14.415 42.825-4.95 61.05 11.227 19.646 1.687 45.624-12.925 53.625 6.524 39.128-10.076 61.325-50.6 61.325H248c-45.491 0-77.21-35.913-120-39.676V215.571c25.239-2.964 42.966-21.222 59.075-39.596 11.275-12.65 21.725-25.3 30.799-39.875C232.355 112.712 244.006 80 252.8 80c23.375 0 44 8.8 44 35.2 0 35.2-26.4 53.075-26.4 70.4h158.4c18.425 0 35.2 16.5 35.2 35.2 0 18.975-16.225 35.2-35.2 35.2zM88 384c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
    ]
};
var $77643f1129269c08$export$cdc9f5e7e94e76da = {
    prefix: "far",
    iconName: "hand-point-up",
    icon: [
        448,
        512,
        [],
        "f0a6",
        "M105.6 83.2v86.177a115.52 115.52 0 0 0-22.4-2.176c-47.914 0-83.2 35.072-83.2 92 0 45.314 48.537 57.002 78.784 75.707 12.413 7.735 23.317 16.994 33.253 25.851l.146.131.148.129C129.807 376.338 136 384.236 136 391.2v2.679c-4.952 5.747-8 13.536-8 22.12v64c0 17.673 12.894 32 28.8 32h230.4c15.906 0 28.8-14.327 28.8-32v-64c0-8.584-3.048-16.373-8-22.12V391.2c0-28.688 40-67.137 40-127.2v-21.299c0-62.542-38.658-98.8-91.145-99.94-17.813-12.482-40.785-18.491-62.791-15.985A93.148 93.148 0 0 0 272 118.847V83.2C272 37.765 234.416 0 188.8 0c-45.099 0-83.2 38.101-83.2 83.2zm118.4 0v91.026c14.669-12.837 42.825-14.415 61.05 4.95 19.646-11.227 45.624-1.687 53.625 12.925 39.128-6.524 61.325 10.076 61.325 50.6V264c0 45.491-35.913 77.21-39.676 120H183.571c-2.964-25.239-21.222-42.966-39.596-59.075-12.65-11.275-25.3-21.725-39.875-30.799C80.712 279.645 48 267.994 48 259.2c0-23.375 8.8-44 35.2-44 35.2 0 53.075 26.4 70.4 26.4V83.2c0-18.425 16.5-35.2 35.2-35.2 18.975 0 35.2 16.225 35.2 35.2zM352 424c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
    ]
};
var $77643f1129269c08$export$d97ff927c450c87f = {
    prefix: "far",
    iconName: "hand-pointer",
    icon: [
        448,
        512,
        [],
        "f25a",
        "M358.182 179.361c-19.493-24.768-52.679-31.945-79.872-19.098-15.127-15.687-36.182-22.487-56.595-19.629V67c0-36.944-29.736-67-66.286-67S89.143 30.056 89.143 67v161.129c-19.909-7.41-43.272-5.094-62.083 8.872-29.355 21.795-35.793 63.333-14.55 93.152l109.699 154.001C134.632 501.59 154.741 512 176 512h178.286c30.802 0 57.574-21.5 64.557-51.797l27.429-118.999A67.873 67.873 0 0 0 448 326v-84c0-46.844-46.625-79.273-89.818-62.639zM80.985 279.697l27.126 38.079c8.995 12.626 29.031 6.287 29.031-9.283V67c0-25.12 36.571-25.16 36.571 0v175c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16v-35c0-25.12 36.571-25.16 36.571 0v35c0 8.836 7.163 16 16 16H272c8.837 0 16-7.164 16-16v-21c0-25.12 36.571-25.16 36.571 0v21c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16 0-25.121 36.571-25.16 36.571 0v84c0 1.488-.169 2.977-.502 4.423l-27.43 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H176c-5.769 0-11.263-2.878-14.697-7.697l-109.712-154c-14.406-20.223 14.994-42.818 29.394-22.606zM176.143 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.733 0-14-7.163-14-16zm75.428 0v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16zM327 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16z"
    ]
};
var $77643f1129269c08$export$97a81eba394c8c44 = {
    prefix: "far",
    iconName: "hand-rock",
    icon: [
        512,
        512,
        [],
        "f255",
        "M408.864 79.052c-22.401-33.898-66.108-42.273-98.813-23.588-29.474-31.469-79.145-31.093-108.334-.022-47.16-27.02-108.71 5.055-110.671 60.806C44.846 105.407 0 140.001 0 187.429v56.953c0 32.741 14.28 63.954 39.18 85.634l97.71 85.081c4.252 3.702 3.11 5.573 3.11 32.903 0 17.673 14.327 32 32 32h252c17.673 0 32-14.327 32-32 0-23.513-1.015-30.745 3.982-42.37l42.835-99.656c6.094-14.177 9.183-29.172 9.183-44.568V146.963c0-52.839-54.314-88.662-103.136-67.911zM464 261.406a64.505 64.505 0 0 1-5.282 25.613l-42.835 99.655c-5.23 12.171-7.883 25.04-7.883 38.25V432H188v-10.286c0-16.37-7.14-31.977-19.59-42.817l-97.71-85.08C56.274 281.255 48 263.236 48 244.381v-56.953c0-33.208 52-33.537 52 .677v41.228a16 16 0 0 0 5.493 12.067l7 6.095A16 16 0 0 0 139 235.429V118.857c0-33.097 52-33.725 52 .677v26.751c0 8.836 7.164 16 16 16h7c8.836 0 16-7.164 16-16v-41.143c0-33.134 52-33.675 52 .677v40.466c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16v-27.429c0-33.03 52-33.78 52 .677v26.751c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16 0-33.146 52-33.613 52 .677v114.445z"
    ]
};
var $77643f1129269c08$export$c578e919f2c5c135 = {
    prefix: "far",
    iconName: "hand-scissors",
    icon: [
        512,
        512,
        [],
        "f257",
        "M256 480l70-.013c5.114 0 10.231-.583 15.203-1.729l118.999-27.427C490.56 443.835 512 417.02 512 386.277V180.575c0-23.845-13.03-45.951-34.005-57.69l-97.999-54.853c-34.409-19.261-67.263-5.824-92.218 24.733L142.85 37.008c-37.887-14.579-80.612 3.727-95.642 41.201-15.098 37.642 3.635 80.37 41.942 95.112L168 192l-94-9.141c-40.804 0-74 32.811-74 73.14 0 40.33 33.196 73.141 74 73.141h87.635c-3.675 26.245 8.692 51.297 30.341 65.006C178.657 436.737 211.044 480 256 480zm0-48.013c-25.16 0-25.12-36.567 0-36.567 8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16h-28c-25.159 0-25.122-36.567 0-36.567h28c8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16H74c-34.43 0-34.375-50.281 0-50.281h182c8.837 0 16-7.163 16-16v-11.632a16 16 0 0 0-10.254-14.933L106.389 128.51c-31.552-12.14-13.432-59.283 19.222-46.717l166.549 64.091a16.001 16.001 0 0 0 18.139-4.812l21.764-26.647c5.82-7.127 16.348-9.064 24.488-4.508l98 54.854c5.828 3.263 9.449 9.318 9.449 15.805v205.701c0 8.491-5.994 15.804-14.576 17.782l-119.001 27.427a19.743 19.743 0 0 1-4.423.502h-70z"
    ]
};
var $77643f1129269c08$export$2262d6b626de1120 = {
    prefix: "far",
    iconName: "hand-spock",
    icon: [
        512,
        512,
        [],
        "f259",
        "M501.03053,116.17605c-19.39059-31.50779-51.24406-35.72849-66.31044-35.01756-14.11325-50.81051-62.0038-54.08-70.73816-54.08a74.03091,74.03091,0,0,0-72.23816,58.916l-4.64648,22.66014-13.68357-53.207c-9.09569-35.37107-46.412-64.05074-89.66-53.07223a73.89749,73.89749,0,0,0-55.121,78.94722,73.68273,73.68273,0,0,0-64.8495,94.42181l24.35933,82.19721c-38.24017-7.54492-62.79677,16.18358-68.11512,21.84764a73.6791,73.6791,0,0,0,3.19921,104.19329l91.36509,85.9765A154.164,154.164,0,0,0,220.62279,512h107.4549A127.30079,127.30079,0,0,0,452.3392,413.86139l57.623-241.96272A73.20274,73.20274,0,0,0,501.03053,116.17605Zm-37.7597,44.60544L405.64788,402.74812a79.46616,79.46616,0,0,1-77.57019,61.25972H220.62279a106.34052,106.34052,0,0,1-73.1366-28.998l-91.369-85.98041C31.34381,325.72669,66.61133,288.131,91.39644,311.5392l51.123,48.10739c5.42577,5.10937,13.48239.71679,13.48239-5.82617a246.79914,246.79914,0,0,0-10.17771-70.1523l-36.01362-121.539c-9.7324-32.88279,39.69916-47.27145,49.38664-14.625l31.3437,105.77923c5.59374,18.90428,33.78119,10.71288,28.9648-8.00781L177.06427,80.23662c-8.50389-33.1035,41.43157-45.64646,49.86515-12.83593l47.32609,184.035c4.42773,17.24218,29.16207,16.5039,32.71089-.80468l31.791-154.9706c6.81054-33.1074,57.51748-24.10741,50.11906,11.96288L360.32764,246.78924c-3.72265,18.10936,23.66793,24.63084,28.05659,6.21679L413.185,148.85962C421.1498,115.512,471.14,127.79713,463.27083,160.78149Z"
    ]
};
var $77643f1129269c08$export$b4c63e9bfc7906f1 = {
    prefix: "far",
    iconName: "handshake",
    icon: [
        640,
        512,
        [],
        "f2b5",
        "M519.2 127.9l-47.6-47.6A56.252 56.252 0 0 0 432 64H205.2c-14.8 0-29.1 5.9-39.6 16.3L118 127.9H0v255.7h64c17.6 0 31.8-14.2 31.9-31.7h9.1l84.6 76.4c30.9 25.1 73.8 25.7 105.6 3.8 12.5 10.8 26 15.9 41.1 15.9 18.2 0 35.3-7.4 48.8-24 22.1 8.7 48.2 2.6 64-16.8l26.2-32.3c5.6-6.9 9.1-14.8 10.9-23h57.9c.1 17.5 14.4 31.7 31.9 31.7h64V127.9H519.2zM48 351.6c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16zm390-6.9l-26.1 32.2c-2.8 3.4-7.8 4-11.3 1.2l-23.9-19.4-30 36.5c-6 7.3-15 4.8-18 2.4l-36.8-31.5-15.6 19.2c-13.9 17.1-39.2 19.7-55.3 6.6l-97.3-88H96V175.8h41.9l61.7-61.6c2-.8 3.7-1.5 5.7-2.3H262l-38.7 35.5c-29.4 26.9-31.1 72.3-4.4 101.3 14.8 16.2 61.2 41.2 101.5 4.4l8.2-7.5 108.2 87.8c3.4 2.8 3.9 7.9 1.2 11.3zm106-40.8h-69.2c-2.3-2.8-4.9-5.4-7.7-7.7l-102.7-83.4 12.5-11.4c6.5-6 7-16.1 1-22.6L367 167.1c-6-6.5-16.1-6.9-22.6-1l-55.2 50.6c-9.5 8.7-25.7 9.4-34.6 0-9.3-9.9-8.5-25.1 1.2-33.9l65.6-60.1c7.4-6.8 17-10.5 27-10.5l83.7-.2c2.1 0 4.1.8 5.5 2.3l61.7 61.6H544v128zm48 47.7c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16z"
    ]
};
var $77643f1129269c08$export$62551e9c5ba7093f = {
    prefix: "far",
    iconName: "hdd",
    icon: [
        576,
        512,
        [],
        "f0a0",
        "M567.403 235.642L462.323 84.589A48 48 0 0 0 422.919 64H153.081a48 48 0 0 0-39.404 20.589L8.597 235.642A48.001 48.001 0 0 0 0 263.054V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V263.054c0-9.801-3-19.366-8.597-27.412zM153.081 112h269.838l77.913 112H75.168l77.913-112zM528 400H48V272h480v128zm-32-64c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-96 0c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32z"
    ]
};
var $77643f1129269c08$export$e4b51a47a2f8b9db = {
    prefix: "far",
    iconName: "heart",
    icon: [
        512,
        512,
        [],
        "f004",
        "M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"
    ]
};
var $77643f1129269c08$export$7a76c9d35b42d691 = {
    prefix: "far",
    iconName: "hospital",
    icon: [
        448,
        512,
        [],
        "f0f8",
        "M128 244v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12zm140 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm-76 84v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm76 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm180 124v36H0v-36c0-6.627 5.373-12 12-12h19.5V85.035C31.5 73.418 42.245 64 55.5 64H144V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v40h88.5c13.255 0 24 9.418 24 21.035V464H436c6.627 0 12 5.373 12 12zM79.5 463H192v-67c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v67h112.5V112H304v24c0 13.255-10.745 24-24 24H168c-13.255 0-24-10.745-24-24v-24H79.5v351zM266 64h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6z"
    ]
};
var $77643f1129269c08$export$b9098a890f61e022 = {
    prefix: "far",
    iconName: "hourglass",
    icon: [
        384,
        512,
        [],
        "f254",
        "M368 48h4c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h4c0 80.564 32.188 165.807 97.18 208C47.899 298.381 16 383.9 16 464h-4c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-4c0-80.564-32.188-165.807-97.18-208C336.102 213.619 368 128.1 368 48zM64 48h256c0 101.62-57.307 184-128 184S64 149.621 64 48zm256 416H64c0-101.62 57.308-184 128-184s128 82.38 128 184z"
    ]
};
var $77643f1129269c08$export$a75288855ea05282 = {
    prefix: "far",
    iconName: "id-badge",
    icon: [
        384,
        512,
        [],
        "f2c1",
        "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 464H48V48h288v416zM144 112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48 176c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
    ]
};
var $77643f1129269c08$export$782ac893fc22249b = {
    prefix: "far",
    iconName: "id-card",
    icon: [
        576,
        512,
        [],
        "f2c2",
        "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H303.2c.9-4.5.8 3.6.8-22.4 0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6 0 26-.2 17.9.8 22.4H48V144h480v288zm-168-80h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm-168 96c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
    ]
};
var $77643f1129269c08$export$7e9f0928967e03b = {
    prefix: "far",
    iconName: "image",
    icon: [
        512,
        512,
        [],
        "f03e",
        "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z"
    ]
};
var $77643f1129269c08$export$74f06b41ed2ca28a = {
    prefix: "far",
    iconName: "images",
    icon: [
        576,
        512,
        [],
        "f302",
        "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"
    ]
};
var $77643f1129269c08$export$fb61df5d98785fa8 = {
    prefix: "far",
    iconName: "keyboard",
    icon: [
        576,
        512,
        [],
        "f11c",
        "M528 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm8 336c0 4.411-3.589 8-8 8H48c-4.411 0-8-3.589-8-8V112c0-4.411 3.589-8 8-8h480c4.411 0 8 3.589 8 8v288zM170 270v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-336 82v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm384 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zM122 188v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-98 158v-16c0-6.627-5.373-12-12-12H180c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h216c6.627 0 12-5.373 12-12z"
    ]
};
var $77643f1129269c08$export$c762a77aabf64fd0 = {
    prefix: "far",
    iconName: "kiss",
    icon: [
        496,
        512,
        [],
        "f596",
        "M168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm136 132c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
    ]
};
var $77643f1129269c08$export$d6ff8a73c0812e63 = {
    prefix: "far",
    iconName: "kiss-beam",
    icon: [
        496,
        512,
        [],
        "f597",
        "M168 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm56-148c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zm24-156c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4z"
    ]
};
var $77643f1129269c08$export$ebba617701dfb917 = {
    prefix: "far",
    iconName: "kiss-wink-heart",
    icon: [
        504,
        512,
        [],
        "f598",
        "M304 308.5c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36 21.7-9.1 35.1-23.4 35.1-36.4zm70.5-83.5l9.5 8.5c3.8 3.3 9.3 4 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 5.8 3.1 11.2.7 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0zM136 208.5c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm365.1 194c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zM334 436.3c-26.1 12.5-55.2 19.7-86 19.7-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200c0 22.1-3.7 43.3-10.4 63.2 9 6.4 17 14.2 22.6 23.9 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-2.5-7.3 4.3 17.2-13.4-46.8z"
    ]
};
var $77643f1129269c08$export$6c74e314e801a4fe = {
    prefix: "far",
    iconName: "laugh",
    icon: [
        496,
        512,
        [],
        "f599",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
    ]
};
var $77643f1129269c08$export$a88d1f4073ea9369 = {
    prefix: "far",
    iconName: "laugh-beam",
    icon: [
        496,
        512,
        [],
        "f59a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 152c-23.8 0-52.7 29.3-56 71.4-.7 8.6 10.8 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.1-42.1-32-71.4-55.8-71.4zm-201 75.9l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.6 8.5 10.9 11.9 15.1 4.5zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
    ]
};
var $77643f1129269c08$export$b206e700cf7084e1 = {
    prefix: "far",
    iconName: "laugh-squint",
    icon: [
        496,
        512,
        [],
        "f59b",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM343.6 196l33.6-40.3c8.6-10.3-3.8-24.8-15.4-18l-80 48c-7.8 4.7-7.8 15.9 0 20.6l80 48c11.5 6.8 24-7.6 15.4-18L343.6 196zm-209.4 58.3l80-48c7.8-4.7 7.8-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18l33.6 40.3-33.6 40.3c-8.7 10.4 3.8 24.8 15.4 18zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
    ]
};
var $77643f1129269c08$export$77ac40095f39933e = {
    prefix: "far",
    iconName: "laugh-wink",
    icon: [
        496,
        512,
        [],
        "f59c",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6C68.8 359.6 48 309.4 48 256s20.8-103.6 58.6-141.4C144.4 76.8 194.6 56 248 56s103.6 20.8 141.4 58.6c37.8 37.8 58.6 88 58.6 141.4s-20.8 103.6-58.6 141.4zM328 164c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1zm-160 60c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
    ]
};
var $77643f1129269c08$export$4fbda8f64648f3b5 = {
    prefix: "far",
    iconName: "lemon",
    icon: [
        512,
        512,
        [],
        "f094",
        "M484.112 27.889C455.989-.233 416.108-8.057 387.059 8.865 347.604 31.848 223.504-41.111 91.196 91.197-41.277 223.672 31.923 347.472 8.866 387.058c-16.922 29.051-9.1 68.932 19.022 97.054 28.135 28.135 68.011 35.938 97.057 19.021 39.423-22.97 163.557 49.969 295.858-82.329 132.474-132.477 59.273-256.277 82.331-295.861 16.922-29.05 9.1-68.931-19.022-97.054zm-22.405 72.894c-38.8 66.609 45.6 165.635-74.845 286.08-120.44 120.443-219.475 36.048-286.076 74.843-22.679 13.207-64.035-27.241-50.493-50.488 38.8-66.609-45.6-165.635 74.845-286.08C245.573 4.702 344.616 89.086 411.219 50.292c22.73-13.24 64.005 27.288 50.488 50.491zm-169.861 8.736c1.37 10.96-6.404 20.957-17.365 22.327-54.846 6.855-135.779 87.787-142.635 142.635-1.373 10.989-11.399 18.734-22.326 17.365-10.961-1.37-18.735-11.366-17.365-22.326 9.162-73.286 104.167-168.215 177.365-177.365 10.953-1.368 20.956 6.403 22.326 17.364z"
    ]
};
var $77643f1129269c08$export$53dd2cacf674142a = {
    prefix: "far",
    iconName: "life-ring",
    icon: [
        512,
        512,
        [],
        "f1cd",
        "M256 504c136.967 0 248-111.033 248-248S392.967 8 256 8 8 119.033 8 256s111.033 248 248 248zm-103.398-76.72l53.411-53.411c31.806 13.506 68.128 13.522 99.974 0l53.411 53.411c-63.217 38.319-143.579 38.319-206.796 0zM336 256c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zm91.28 103.398l-53.411-53.411c13.505-31.806 13.522-68.128 0-99.974l53.411-53.411c38.319 63.217 38.319 143.579 0 206.796zM359.397 84.72l-53.411 53.411c-31.806-13.505-68.128-13.522-99.973 0L152.602 84.72c63.217-38.319 143.579-38.319 206.795 0zM84.72 152.602l53.411 53.411c-13.506 31.806-13.522 68.128 0 99.974L84.72 359.398c-38.319-63.217-38.319-143.579 0-206.796z"
    ]
};
var $77643f1129269c08$export$1e80f89fe84a215b = {
    prefix: "far",
    iconName: "lightbulb",
    icon: [
        352,
        512,
        [],
        "f0eb",
        "M176 80c-52.94 0-96 43.06-96 96 0 8.84 7.16 16 16 16s16-7.16 16-16c0-35.3 28.72-64 64-64 8.84 0 16-7.16 16-16s-7.16-16-16-16zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z"
    ]
};
var $77643f1129269c08$export$c6327a203ffc65a3 = {
    prefix: "far",
    iconName: "list-alt",
    icon: [
        512,
        512,
        [],
        "f022",
        "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-42-92v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm-252 12c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36z"
    ]
};
var $77643f1129269c08$export$fc82fb79180cd17c = {
    prefix: "far",
    iconName: "map",
    icon: [
        576,
        512,
        [],
        "f279",
        "M560.02 32c-1.96 0-3.98.37-5.96 1.16L384.01 96H384L212 35.28A64.252 64.252 0 0 0 191.76 32c-6.69 0-13.37 1.05-19.81 3.14L20.12 87.95A32.006 32.006 0 0 0 0 117.66v346.32C0 473.17 7.53 480 15.99 480c1.96 0 3.97-.37 5.96-1.16L192 416l172 60.71a63.98 63.98 0 0 0 40.05.15l151.83-52.81A31.996 31.996 0 0 0 576 394.34V48.02c0-9.19-7.53-16.02-15.98-16.02zM224 90.42l128 45.19v285.97l-128-45.19V90.42zM48 418.05V129.07l128-44.53v286.2l-.64.23L48 418.05zm480-35.13l-128 44.53V141.26l.64-.24L528 93.95v288.97z"
    ]
};
var $77643f1129269c08$export$6d2db489aaeeecd2 = {
    prefix: "far",
    iconName: "meh",
    icon: [
        496,
        512,
        [],
        "f11a",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm8 144H160c-13.2 0-24 10.8-24 24s10.8 24 24 24h176c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
    ]
};
var $77643f1129269c08$export$e945435725f71e88 = {
    prefix: "far",
    iconName: "meh-blank",
    icon: [
        496,
        512,
        [],
        "f5a4",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
    ]
};
var $77643f1129269c08$export$fdc62a1bea767cc2 = {
    prefix: "far",
    iconName: "meh-rolling-eyes",
    icon: [
        496,
        512,
        [],
        "f5a5",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm88-304c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40 0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40zm-104-40c0-39.8-32.2-72-72-72s-72 32.2-72 72 32.2 72 72 72 72-32.2 72-72zm-112 0c0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40s-40-17.9-40-40zm192 128H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
    ]
};
var $77643f1129269c08$export$ffe9387966b3e681 = {
    prefix: "far",
    iconName: "minus-square",
    icon: [
        448,
        512,
        [],
        "f146",
        "M108 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H108zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var $77643f1129269c08$export$a35d573395884c3d = {
    prefix: "far",
    iconName: "money-bill-alt",
    icon: [
        640,
        512,
        [],
        "f3d1",
        "M320 144c-53.02 0-96 50.14-96 112 0 61.85 42.98 112 96 112 53 0 96-50.13 96-112 0-61.86-42.98-112-96-112zm40 168c0 4.42-3.58 8-8 8h-64c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h16v-55.44l-.47.31a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09l15.33-10.22a23.99 23.99 0 0 1 13.31-4.03H328c4.42 0 8 3.58 8 8v88h16c4.42 0 8 3.58 8 8v16zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zm-16 272c-35.35 0-64 28.65-64 64H112c0-35.35-28.65-64-64-64V176c35.35 0 64-28.65 64-64h416c0 35.35 28.65 64 64 64v160z"
    ]
};
var $77643f1129269c08$export$c4c2f69a53bab720 = {
    prefix: "far",
    iconName: "moon",
    icon: [
        512,
        512,
        [],
        "f186",
        "M279.135 512c78.756 0 150.982-35.804 198.844-94.775 28.27-34.831-2.558-85.722-46.249-77.401-82.348 15.683-158.272-47.268-158.272-130.792 0-48.424 26.06-92.292 67.434-115.836 38.745-22.05 28.999-80.788-15.022-88.919A257.936 257.936 0 0 0 279.135 0c-141.36 0-256 114.575-256 256 0 141.36 114.576 256 256 256zm0-464c12.985 0 25.689 1.201 38.016 3.478-54.76 31.163-91.693 90.042-91.693 157.554 0 113.848 103.641 199.2 215.252 177.944C402.574 433.964 344.366 464 279.135 464c-114.875 0-208-93.125-208-208s93.125-208 208-208z"
    ]
};
var $77643f1129269c08$export$d91b374112d4f8c1 = {
    prefix: "far",
    iconName: "newspaper",
    icon: [
        576,
        512,
        [],
        "f1ea",
        "M552 64H112c-20.858 0-38.643 13.377-45.248 32H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h496c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24zM48 392V144h16v248c0 4.411-3.589 8-8 8s-8-3.589-8-8zm480 8H111.422c.374-2.614.578-5.283.578-8V112h416v288zM172 280h136c6.627 0 12-5.373 12-12v-96c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v96c0 6.627 5.373 12 12 12zm28-80h80v40h-80v-40zm-40 140v-24c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H172c-6.627 0-12-5.373-12-12zm192 0v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0-144v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0 72v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12z"
    ]
};
var $77643f1129269c08$export$40cdac24aa94a57a = {
    prefix: "far",
    iconName: "object-group",
    icon: [
        512,
        512,
        [],
        "f247",
        "M500 128c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v256H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V128h12zm-52-64h32v32h-32V64zM32 64h32v32H32V64zm32 384H32v-32h32v32zm416 0h-32v-32h32v32zm-40-64h-12c-6.627 0-12 5.373-12 12v12H96v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h12v256zm-36-192h-84v-52c0-6.628-5.373-12-12-12H108c-6.627 0-12 5.372-12 12v168c0 6.628 5.373 12 12 12h84v52c0 6.628 5.373 12 12 12h200c6.627 0 12-5.372 12-12V204c0-6.628-5.373-12-12-12zm-268-24h144v112H136V168zm240 176H232v-24h76c6.627 0 12-5.372 12-12v-76h56v112z"
    ]
};
var $77643f1129269c08$export$887f6345573abcac = {
    prefix: "far",
    iconName: "object-ungroup",
    icon: [
        576,
        512,
        [],
        "f248",
        "M564 224c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12h-88v-24h12c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v160H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h88v24h-12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V224h12zM352 64h32v32h-32V64zm0 256h32v32h-32v-32zM64 352H32v-32h32v32zm0-256H32V64h32v32zm32 216v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h12v160h-12c-6.627 0-12 5.373-12 12v12H96zm128 136h-32v-32h32v32zm280-64h-12c-6.627 0-12 5.373-12 12v12H256v-12c0-6.627-5.373-12-12-12h-12v-24h88v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12v-88h88v12c0 6.627 5.373 12 12 12h12v160zm40 64h-32v-32h32v32zm0-256h-32v-32h32v32z"
    ]
};
var $77643f1129269c08$export$b5378818301da1be = {
    prefix: "far",
    iconName: "paper-plane",
    icon: [
        512,
        512,
        [],
        "f1d8",
        "M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-71.5-48.9zM192 464v-64.6l36.6 15.1L192 464zm212.6-28.7l-153.8-63.5L391 169.5c10.7-15.5-9.5-33.5-23.7-21.2L155.8 332.6 48 288 464 48l-59.4 387.3z"
    ]
};
var $77643f1129269c08$export$d8cf08a0362da8db = {
    prefix: "far",
    iconName: "pause-circle",
    icon: [
        512,
        512,
        [],
        "f28b",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm96-280v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm-112 0v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z"
    ]
};
var $77643f1129269c08$export$cf04333781061c5e = {
    prefix: "far",
    iconName: "play-circle",
    icon: [
        512,
        512,
        [],
        "f144",
        "M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"
    ]
};
var $77643f1129269c08$export$b6359eebfe900c35 = {
    prefix: "far",
    iconName: "plus-square",
    icon: [
        448,
        512,
        [],
        "f0fe",
        "M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
    ]
};
var $77643f1129269c08$export$5ba67d7f2265c1a5 = {
    prefix: "far",
    iconName: "question-circle",
    icon: [
        512,
        512,
        [],
        "f059",
        "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"
    ]
};
var $77643f1129269c08$export$5f519e9ac15ab8c3 = {
    prefix: "far",
    iconName: "registered",
    icon: [
        512,
        512,
        [],
        "f25d",
        "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm110.442-81.791c-53.046-96.284-50.25-91.468-53.271-96.085 24.267-13.879 39.482-41.563 39.482-73.176 0-52.503-30.247-85.252-101.498-85.252h-78.667c-6.617 0-12 5.383-12 12V380c0 6.617 5.383 12 12 12h38.568c6.617 0 12-5.383 12-12v-83.663h31.958l47.515 89.303a11.98 11.98 0 0 0 10.593 6.36h42.81c9.14 0 14.914-9.799 10.51-17.791zM256.933 239.906h-33.875v-64.14h27.377c32.417 0 38.929 12.133 38.929 31.709-.001 20.913-11.518 32.431-32.431 32.431z"
    ]
};
var $77643f1129269c08$export$8e924e6bd422cef9 = {
    prefix: "far",
    iconName: "sad-cry",
    icon: [
        496,
        512,
        [],
        "f5b3",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm144 386.4V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v151.4C315.5 447 282.8 456 248 456s-67.5-9-96-24.6V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v114.4c-34.6-36-56-84.7-56-138.4 0-110.3 89.7-200 200-200s200 89.7 200 200c0 53.7-21.4 102.5-56 138.4zM205.8 234.5c4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.3 7.9 4.8 13.7 1.6zM344 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.5 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm-96 92c-30.9 0-56 28.7-56 64s25.1 64 56 64 56-28.7 56-64-25.1-64-56-64z"
    ]
};
var $77643f1129269c08$export$4b5241926f692f91 = {
    prefix: "far",
    iconName: "sad-tear",
    icon: [
        496,
        512,
        [],
        "f5b4",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm8-152c-13.2 0-24 10.8-24 24s10.8 24 24 24c23.8 0 46.3 10.5 61.6 28.8 8.1 9.8 23.2 11.9 33.8 3.1 10.2-8.5 11.6-23.6 3.1-33.8C330 320.8 294.1 304 256 304zm-88-64c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-165.6 98.8C151 290.1 126 325.4 126 342.9c0 22.7 18.8 41.1 42 41.1s42-18.4 42-41.1c0-17.5-25-52.8-36.4-68.1-2.8-3.7-8.4-3.7-11.2 0z"
    ]
};
var $77643f1129269c08$export$1aaa83ff70706e1e = {
    prefix: "far",
    iconName: "save",
    icon: [
        448,
        512,
        [],
        "f0c7",
        "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM272 80v80H144V80h128zm122 352H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h42v104c0 13.255 10.745 24 24 24h176c13.255 0 24-10.745 24-24V83.882l78.243 78.243a6 6 0 0 1 1.757 4.243V426a6 6 0 0 1-6 6zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 128c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z"
    ]
};
var $77643f1129269c08$export$ae9e1434571f373c = {
    prefix: "far",
    iconName: "share-square",
    icon: [
        576,
        512,
        [],
        "f14d",
        "M561.938 158.06L417.94 14.092C387.926-15.922 336 5.097 336 48.032v57.198c-42.45 1.88-84.03 6.55-120.76 17.99-35.17 10.95-63.07 27.58-82.91 49.42C108.22 199.2 96 232.6 96 271.94c0 61.697 33.178 112.455 84.87 144.76 37.546 23.508 85.248-12.651 71.02-55.74-15.515-47.119-17.156-70.923 84.11-78.76V336c0 42.993 51.968 63.913 81.94 33.94l143.998-144c18.75-18.74 18.75-49.14 0-67.88zM384 336V232.16C255.309 234.082 166.492 255.35 206.31 376 176.79 357.55 144 324.08 144 271.94c0-109.334 129.14-118.947 240-119.85V48l144 144-144 144zm24.74 84.493a82.658 82.658 0 0 0 20.974-9.303c7.976-4.952 18.286.826 18.286 10.214V464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h132c6.627 0 12 5.373 12 12v4.486c0 4.917-2.987 9.369-7.569 11.152-13.702 5.331-26.396 11.537-38.05 18.585a12.138 12.138 0 0 1-6.28 1.777H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6v-25.966c0-5.37 3.579-10.059 8.74-11.541z"
    ]
};
var $77643f1129269c08$export$c632b2334f0913bc = {
    prefix: "far",
    iconName: "smile",
    icon: [
        496,
        512,
        [],
        "f118",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm4 72.6c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.1-8.4-25.3-7.1-33.8 3.1z"
    ]
};
var $77643f1129269c08$export$54ada6dc9690e0ca = {
    prefix: "far",
    iconName: "smile-beam",
    icon: [
        496,
        512,
        [],
        "f5b8",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm84-143.4c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.6-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.2-8.4-25.3-7.1-33.8 3.1zM136.5 211c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.4 1.1 7.4-.5 9.3-3.7l9.5-17zM328 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4z"
    ]
};
var $77643f1129269c08$export$f5dbb37f6801ee3f = {
    prefix: "far",
    iconName: "smile-wink",
    icon: [
        496,
        512,
        [],
        "f4da",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm117.8-146.4c-10.2-8.5-25.3-7.1-33.8 3.1-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-60c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1z"
    ]
};
var $77643f1129269c08$export$bab8f3647c394f48 = {
    prefix: "far",
    iconName: "snowflake",
    icon: [
        448,
        512,
        [],
        "f2dc",
        "M440.1 355.2l-39.2-23 34.1-9.3c8.4-2.3 13.4-11.1 11.1-19.6l-4.1-15.5c-2.2-8.5-10.9-13.6-19.3-11.3L343 298.2 271.2 256l71.9-42.2 79.7 21.7c8.4 2.3 17-2.8 19.3-11.3l4.1-15.5c2.2-8.5-2.7-17.3-11.1-19.6l-34.1-9.3 39.2-23c7.5-4.4 10.1-14.2 5.8-21.9l-7.9-13.9c-4.3-7.7-14-10.3-21.5-5.9l-39.2 23 9.1-34.7c2.2-8.5-2.7-17.3-11.1-19.6l-15.2-4.1c-8.4-2.3-17 2.8-19.3 11.3l-21.3 81-71.9 42.2v-84.5L306 70.4c6.1-6.2 6.1-16.4 0-22.6l-11.1-11.3c-6.1-6.2-16.1-6.2-22.2 0l-24.9 25.4V16c0-8.8-7-16-15.7-16h-15.7c-8.7 0-15.7 7.2-15.7 16v46.1l-24.9-25.4c-6.1-6.2-16.1-6.2-22.2 0L142.1 48c-6.1 6.2-6.1 16.4 0 22.6l58.3 59.3v84.5l-71.9-42.2-21.3-81c-2.2-8.5-10.9-13.6-19.3-11.3L72.7 84c-8.4 2.3-13.4 11.1-11.1 19.6l9.1 34.7-39.2-23c-7.5-4.4-17.1-1.8-21.5 5.9l-7.9 13.9c-4.3 7.7-1.8 17.4 5.8 21.9l39.2 23-34.1 9.1c-8.4 2.3-13.4 11.1-11.1 19.6L6 224.2c2.2 8.5 10.9 13.6 19.3 11.3l79.7-21.7 71.9 42.2-71.9 42.2-79.7-21.7c-8.4-2.3-17 2.8-19.3 11.3l-4.1 15.5c-2.2 8.5 2.7 17.3 11.1 19.6l34.1 9.3-39.2 23c-7.5 4.4-10.1 14.2-5.8 21.9L10 391c4.3 7.7 14 10.3 21.5 5.9l39.2-23-9.1 34.7c-2.2 8.5 2.7 17.3 11.1 19.6l15.2 4.1c8.4 2.3 17-2.8 19.3-11.3l21.3-81 71.9-42.2v84.5l-58.3 59.3c-6.1 6.2-6.1 16.4 0 22.6l11.1 11.3c6.1 6.2 16.1 6.2 22.2 0l24.9-25.4V496c0 8.8 7 16 15.7 16h15.7c8.7 0 15.7-7.2 15.7-16v-46.1l24.9 25.4c6.1 6.2 16.1 6.2 22.2 0l11.1-11.3c6.1-6.2 6.1-16.4 0-22.6l-58.3-59.3v-84.5l71.9 42.2 21.3 81c2.2 8.5 10.9 13.6 19.3 11.3L375 428c8.4-2.3 13.4-11.1 11.1-19.6l-9.1-34.7 39.2 23c7.5 4.4 17.1 1.8 21.5-5.9l7.9-13.9c4.6-7.5 2.1-17.3-5.5-21.7z"
    ]
};
var $77643f1129269c08$export$90b4406457aae8cc = {
    prefix: "far",
    iconName: "square",
    icon: [
        448,
        512,
        [],
        "f0c8",
        "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
    ]
};
var $77643f1129269c08$export$a3b0eb2cd7942125 = {
    prefix: "far",
    iconName: "star",
    icon: [
        576,
        512,
        [],
        "f005",
        "M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"
    ]
};
var $77643f1129269c08$export$228008b5e11032fa = {
    prefix: "far",
    iconName: "star-half",
    icon: [
        576,
        512,
        [],
        "f089",
        "M288 385.3l-124.3 65.4 23.7-138.4-100.6-98 139-20.2 62.2-126V0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6v-54.3z"
    ]
};
var $77643f1129269c08$export$80889adc5d98bf4a = {
    prefix: "far",
    iconName: "sticky-note",
    icon: [
        448,
        512,
        [],
        "f249",
        "M448 348.106V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80v351.988c0 26.51 21.49 48 48 48h268.118a48 48 0 0 0 33.941-14.059l83.882-83.882A48 48 0 0 0 448 348.106zm-128 80v-76.118h76.118L320 428.106zM400 80v223.988H296c-13.255 0-24 10.745-24 24v104H48V80h352z"
    ]
};
var $77643f1129269c08$export$47af2aad60ab3e7c = {
    prefix: "far",
    iconName: "stop-circle",
    icon: [
        512,
        512,
        [],
        "f28d",
        "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm296-80v160c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16z"
    ]
};
var $77643f1129269c08$export$2fa35dcbc038dbe9 = {
    prefix: "far",
    iconName: "sun",
    icon: [
        512,
        512,
        [],
        "f185",
        "M494.2 221.9l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9 70.9 13.7c13.4 2.7 26.8-1.6 36.3-11.1 9.5-9.5 13.6-23.1 11.1-36.3l-13.7-71 59.8-40.5c11.1-7.5 17.8-20.1 17.8-33.5-.1-13.6-6.7-26.1-17.9-33.7zm-112.9 85.6l17.6 91.2-91-17.6L256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-17.6 91.1 76.8 52-76.8 52.1zM256 152c-57.3 0-104 46.7-104 104s46.7 104 104 104 104-46.7 104-104-46.7-104-104-104zm0 160c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"
    ]
};
var $77643f1129269c08$export$46647c72213f53ba = {
    prefix: "far",
    iconName: "surprise",
    icon: [
        496,
        512,
        [],
        "f5c2",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-176c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm-48-72c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
    ]
};
var $77643f1129269c08$export$aba24ca305bbe8c1 = {
    prefix: "far",
    iconName: "thumbs-down",
    icon: [
        512,
        512,
        [],
        "f165",
        "M466.27 225.31c4.674-22.647.864-44.538-8.99-62.99 2.958-23.868-4.021-48.565-17.34-66.99C438.986 39.423 404.117 0 327 0c-7 0-15 .01-22.22.01C201.195.01 168.997 40 128 40h-10.845c-5.64-4.975-13.042-8-21.155-8H32C14.327 32 0 46.327 0 64v240c0 17.673 14.327 32 32 32h64c11.842 0 22.175-6.438 27.708-16h7.052c19.146 16.953 46.013 60.653 68.76 83.4 13.667 13.667 10.153 108.6 71.76 108.6 57.58 0 95.27-31.936 95.27-104.73 0-18.41-3.93-33.73-8.85-46.54h36.48c48.602 0 85.82-41.565 85.82-85.58 0-19.15-4.96-34.99-13.73-49.84zM64 296c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm330.18 16.73H290.19c0 37.82 28.36 55.37 28.36 94.54 0 23.75 0 56.73-47.27 56.73-18.91-18.91-9.46-66.18-37.82-94.54C206.9 342.89 167.28 272 138.92 272H128V85.83c53.611 0 100.001-37.82 171.64-37.82h37.82c35.512 0 60.82 17.12 53.12 65.9 15.2 8.16 26.5 36.44 13.94 57.57 21.581 20.384 18.699 51.065 5.21 65.62 9.45 0 22.36 18.91 22.27 37.81-.09 18.91-16.71 37.82-37.82 37.82z"
    ]
};
var $77643f1129269c08$export$47e4e0d519d33497 = {
    prefix: "far",
    iconName: "thumbs-up",
    icon: [
        512,
        512,
        [],
        "f164",
        "M466.27 286.69C475.04 271.84 480 256 480 236.85c0-44.015-37.218-85.58-85.82-85.58H357.7c4.92-12.81 8.85-28.13 8.85-46.54C366.55 31.936 328.86 0 271.28 0c-61.607 0-58.093 94.933-71.76 108.6-22.747 22.747-49.615 66.447-68.76 83.4H32c-17.673 0-32 14.327-32 32v240c0 17.673 14.327 32 32 32h64c14.893 0 27.408-10.174 30.978-23.95 44.509 1.001 75.06 39.94 177.802 39.94 7.22 0 15.22.01 22.22.01 77.117 0 111.986-39.423 112.94-95.33 13.319-18.425 20.299-43.122 17.34-66.99 9.854-18.452 13.664-40.343 8.99-62.99zm-61.75 53.83c12.56 21.13 1.26 49.41-13.94 57.57 7.7 48.78-17.608 65.9-53.12 65.9h-37.82c-71.639 0-118.029-37.82-171.64-37.82V240h10.92c28.36 0 67.98-70.89 94.54-97.46 28.36-28.36 18.91-75.63 37.82-94.54 47.27 0 47.27 32.98 47.27 56.73 0 39.17-28.36 56.72-28.36 94.54h103.99c21.11 0 37.73 18.91 37.82 37.82.09 18.9-12.82 37.81-22.27 37.81 13.489 14.555 16.371 45.236-5.21 65.62zM88 432c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
    ]
};
var $77643f1129269c08$export$ab0ec50720a747eb = {
    prefix: "far",
    iconName: "times-circle",
    icon: [
        512,
        512,
        [],
        "f057",
        "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"
    ]
};
var $77643f1129269c08$export$3d016d62cda18371 = {
    prefix: "far",
    iconName: "tired",
    icon: [
        496,
        512,
        [],
        "f5c8",
        "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm129.1-303.8c-3.8-4.4-10.3-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.8 1.6 15.3-2.5 3.8-4.5 3.9-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zM220 208c0-4.2-2.2-8.1-5.8-10.3l-80-48c-5-3-11.5-1.9-15.3 2.5-3.8 4.5-3.9 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.5 4.1 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3zm28 64c-45.4 0-100.9 38.3-107.8 93.3-1.5 11.8 6.9 21.6 15.5 17.9C178.4 373.5 212 368 248 368s69.6 5.5 92.3 15.2c8.5 3.7 17-6 15.5-17.9-6.9-55-62.4-93.3-107.8-93.3z"
    ]
};
var $77643f1129269c08$export$88df7ff7eb32f9dc = {
    prefix: "far",
    iconName: "trash-alt",
    icon: [
        448,
        512,
        [],
        "f2ed",
        "M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"
    ]
};
var $77643f1129269c08$export$f5699fa0844e0188 = {
    prefix: "far",
    iconName: "user",
    icon: [
        448,
        512,
        [],
        "f007",
        "M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
    ]
};
var $77643f1129269c08$export$be7d974e9e0dba1a = {
    prefix: "far",
    iconName: "user-circle",
    icon: [
        496,
        512,
        [],
        "f2bd",
        "M248 104c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-240C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-49.7 0-95.1-18.3-130.1-48.4 14.9-23 40.4-38.6 69.6-39.5 20.8 6.4 40.6 9.6 60.5 9.6s39.7-3.1 60.5-9.6c29.2 1 54.7 16.5 69.6 39.5-35 30.1-80.4 48.4-130.1 48.4zm162.7-84.1c-24.4-31.4-62.1-51.9-105.1-51.9-10.2 0-26 9.6-57.6 9.6-31.5 0-47.4-9.6-57.6-9.6-42.9 0-80.6 20.5-105.1 51.9C61.9 339.2 48 299.2 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 43.2-13.9 83.2-37.3 115.9z"
    ]
};
var $77643f1129269c08$export$18b7775f78a3e16 = {
    prefix: "far",
    iconName: "window-close",
    icon: [
        512,
        512,
        [],
        "f410",
        "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v340zM356.5 194.6L295.1 256l61.4 61.4c4.6 4.6 4.6 12.1 0 16.8l-22.3 22.3c-4.6 4.6-12.1 4.6-16.8 0L256 295.1l-61.4 61.4c-4.6 4.6-12.1 4.6-16.8 0l-22.3-22.3c-4.6-4.6-4.6-12.1 0-16.8l61.4-61.4-61.4-61.4c-4.6-4.6-4.6-12.1 0-16.8l22.3-22.3c4.6-4.6 12.1-4.6 16.8 0l61.4 61.4 61.4-61.4c4.6-4.6 12.1-4.6 16.8 0l22.3 22.3c4.7 4.6 4.7 12.1 0 16.8z"
    ]
};
var $77643f1129269c08$export$703cd98be31ec905 = {
    prefix: "far",
    iconName: "window-maximize",
    icon: [
        512,
        512,
        [],
        "f2d0",
        "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V192h416v234z"
    ]
};
var $77643f1129269c08$export$26a3f9d2784b90d8 = {
    prefix: "far",
    iconName: "window-minimize",
    icon: [
        512,
        512,
        [],
        "f2d1",
        "M480 480H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
    ]
};
var $77643f1129269c08$export$eccfff9bfd585652 = {
    prefix: "far",
    iconName: "window-restore",
    icon: [
        512,
        512,
        [],
        "f2d2",
        "M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z"
    ]
};
var $77643f1129269c08$export$f9059ea71e16fa16 = {
    faAddressBook: $77643f1129269c08$export$853fd1561789e3bb,
    faAddressCard: $77643f1129269c08$export$6ea408c7266ed557,
    faAngry: $77643f1129269c08$export$3c96c08e234498c5,
    faArrowAltCircleDown: $77643f1129269c08$export$ff3afbc8c0bc5d59,
    faArrowAltCircleLeft: $77643f1129269c08$export$5460a5b11a24996f,
    faArrowAltCircleRight: $77643f1129269c08$export$88962ffdad8b856d,
    faArrowAltCircleUp: $77643f1129269c08$export$3747a8ef0995eadf,
    faBell: $77643f1129269c08$export$9b6162797ab1b255,
    faBellSlash: $77643f1129269c08$export$6b31a1e5968b2378,
    faBookmark: $77643f1129269c08$export$4ed9da5c3cca0ef1,
    faBuilding: $77643f1129269c08$export$f26673f8b10c3d46,
    faCalendar: $77643f1129269c08$export$34f5c36a3e80efa2,
    faCalendarAlt: $77643f1129269c08$export$cbc139f33cff356,
    faCalendarCheck: $77643f1129269c08$export$5655108e1162ba45,
    faCalendarMinus: $77643f1129269c08$export$23e8b4955c2d951b,
    faCalendarPlus: $77643f1129269c08$export$16768a660ae3ca9d,
    faCalendarTimes: $77643f1129269c08$export$99b20d7352fbcf08,
    faCaretSquareDown: $77643f1129269c08$export$61aea18df1c84401,
    faCaretSquareLeft: $77643f1129269c08$export$d0c8ba444f1f9581,
    faCaretSquareRight: $77643f1129269c08$export$ae86c9de7e0f62fa,
    faCaretSquareUp: $77643f1129269c08$export$307ae80b26533ce5,
    faChartBar: $77643f1129269c08$export$b532f5d25de97633,
    faCheckCircle: $77643f1129269c08$export$be9e388158c74f29,
    faCheckSquare: $77643f1129269c08$export$f0c8040f596df7fe,
    faCircle: $77643f1129269c08$export$4280b2387fbdad12,
    faClipboard: $77643f1129269c08$export$97d84347d71ba297,
    faClock: $77643f1129269c08$export$95b9968e7fceb821,
    faClone: $77643f1129269c08$export$76c1aa4bf9a39458,
    faClosedCaptioning: $77643f1129269c08$export$8e047801a8603af7,
    faComment: $77643f1129269c08$export$805cd88398a70581,
    faCommentAlt: $77643f1129269c08$export$6e96904d9af0ec4a,
    faCommentDots: $77643f1129269c08$export$63ffcb3d4e94cb92,
    faComments: $77643f1129269c08$export$932912e74adb8939,
    faCompass: $77643f1129269c08$export$b4d344633433e50e,
    faCopy: $77643f1129269c08$export$e9bd786d30cb716c,
    faCopyright: $77643f1129269c08$export$da61665fff8aebfe,
    faCreditCard: $77643f1129269c08$export$3e7437bf6535bef0,
    faDizzy: $77643f1129269c08$export$89a2b10dabc487e8,
    faDotCircle: $77643f1129269c08$export$92bc269cb244d66a,
    faEdit: $77643f1129269c08$export$7be713e57d023733,
    faEnvelope: $77643f1129269c08$export$6f095630677adc,
    faEnvelopeOpen: $77643f1129269c08$export$c6c3bd5f7d9b8bf2,
    faEye: $77643f1129269c08$export$b8c3e79e8c99c95b,
    faEyeSlash: $77643f1129269c08$export$ed3f2918429d029a,
    faFile: $77643f1129269c08$export$cad54bead856a678,
    faFileAlt: $77643f1129269c08$export$243b47dca32bf0b8,
    faFileArchive: $77643f1129269c08$export$bf2047a9946b5c3f,
    faFileAudio: $77643f1129269c08$export$b8d24c57c9e64933,
    faFileCode: $77643f1129269c08$export$143d0ca7d2200f20,
    faFileExcel: $77643f1129269c08$export$77cb1a465c4fe84,
    faFileImage: $77643f1129269c08$export$6440b286d3cbac9b,
    faFilePdf: $77643f1129269c08$export$38611f1c776aba73,
    faFilePowerpoint: $77643f1129269c08$export$c341daeecdea449a,
    faFileVideo: $77643f1129269c08$export$b44eb38345c6a964,
    faFileWord: $77643f1129269c08$export$f0858dff6e769cf6,
    faFlag: $77643f1129269c08$export$6591b1ea509be9da,
    faFlushed: $77643f1129269c08$export$dfd2bd012685aeac,
    faFolder: $77643f1129269c08$export$72b780186370e953,
    faFolderOpen: $77643f1129269c08$export$ff7e93418af88b78,
    faFontAwesomeLogoFull: $77643f1129269c08$export$6e20d421a2e0f320,
    faFrown: $77643f1129269c08$export$43b7108508aecc5f,
    faFrownOpen: $77643f1129269c08$export$c4775e66bed5d96,
    faFutbol: $77643f1129269c08$export$65a345b33858a655,
    faGem: $77643f1129269c08$export$31ee86ac717db552,
    faGrimace: $77643f1129269c08$export$3d08cd36ac1ef231,
    faGrin: $77643f1129269c08$export$37e1f10b6de76621,
    faGrinAlt: $77643f1129269c08$export$b4abebfe416d36ba,
    faGrinBeam: $77643f1129269c08$export$734da5249381ec7e,
    faGrinBeamSweat: $77643f1129269c08$export$14d0ccc54c5b6826,
    faGrinHearts: $77643f1129269c08$export$c56cf0e0c3bc5ed2,
    faGrinSquint: $77643f1129269c08$export$243ae757907b1580,
    faGrinSquintTears: $77643f1129269c08$export$542206d6a85f3b42,
    faGrinStars: $77643f1129269c08$export$64347a5c8c402ef4,
    faGrinTears: $77643f1129269c08$export$b2f7512221512b5b,
    faGrinTongue: $77643f1129269c08$export$ef222816a43a4b3a,
    faGrinTongueSquint: $77643f1129269c08$export$4edf34c3def09a31,
    faGrinTongueWink: $77643f1129269c08$export$58099903d50aefb3,
    faGrinWink: $77643f1129269c08$export$2397fcd34eb12177,
    faHandLizard: $77643f1129269c08$export$54608d0a883fea4d,
    faHandPaper: $77643f1129269c08$export$6e6216c8b50471bb,
    faHandPeace: $77643f1129269c08$export$e49e3cfceea441cc,
    faHandPointDown: $77643f1129269c08$export$f6dcbf0a940428f4,
    faHandPointLeft: $77643f1129269c08$export$b276ec3dc9760d39,
    faHandPointRight: $77643f1129269c08$export$f7bc8714c970afa4,
    faHandPointUp: $77643f1129269c08$export$cdc9f5e7e94e76da,
    faHandPointer: $77643f1129269c08$export$d97ff927c450c87f,
    faHandRock: $77643f1129269c08$export$97a81eba394c8c44,
    faHandScissors: $77643f1129269c08$export$c578e919f2c5c135,
    faHandSpock: $77643f1129269c08$export$2262d6b626de1120,
    faHandshake: $77643f1129269c08$export$b4c63e9bfc7906f1,
    faHdd: $77643f1129269c08$export$62551e9c5ba7093f,
    faHeart: $77643f1129269c08$export$e4b51a47a2f8b9db,
    faHospital: $77643f1129269c08$export$7a76c9d35b42d691,
    faHourglass: $77643f1129269c08$export$b9098a890f61e022,
    faIdBadge: $77643f1129269c08$export$a75288855ea05282,
    faIdCard: $77643f1129269c08$export$782ac893fc22249b,
    faImage: $77643f1129269c08$export$7e9f0928967e03b,
    faImages: $77643f1129269c08$export$74f06b41ed2ca28a,
    faKeyboard: $77643f1129269c08$export$fb61df5d98785fa8,
    faKiss: $77643f1129269c08$export$c762a77aabf64fd0,
    faKissBeam: $77643f1129269c08$export$d6ff8a73c0812e63,
    faKissWinkHeart: $77643f1129269c08$export$ebba617701dfb917,
    faLaugh: $77643f1129269c08$export$6c74e314e801a4fe,
    faLaughBeam: $77643f1129269c08$export$a88d1f4073ea9369,
    faLaughSquint: $77643f1129269c08$export$b206e700cf7084e1,
    faLaughWink: $77643f1129269c08$export$77ac40095f39933e,
    faLemon: $77643f1129269c08$export$4fbda8f64648f3b5,
    faLifeRing: $77643f1129269c08$export$53dd2cacf674142a,
    faLightbulb: $77643f1129269c08$export$1e80f89fe84a215b,
    faListAlt: $77643f1129269c08$export$c6327a203ffc65a3,
    faMap: $77643f1129269c08$export$fc82fb79180cd17c,
    faMeh: $77643f1129269c08$export$6d2db489aaeeecd2,
    faMehBlank: $77643f1129269c08$export$e945435725f71e88,
    faMehRollingEyes: $77643f1129269c08$export$fdc62a1bea767cc2,
    faMinusSquare: $77643f1129269c08$export$ffe9387966b3e681,
    faMoneyBillAlt: $77643f1129269c08$export$a35d573395884c3d,
    faMoon: $77643f1129269c08$export$c4c2f69a53bab720,
    faNewspaper: $77643f1129269c08$export$d91b374112d4f8c1,
    faObjectGroup: $77643f1129269c08$export$40cdac24aa94a57a,
    faObjectUngroup: $77643f1129269c08$export$887f6345573abcac,
    faPaperPlane: $77643f1129269c08$export$b5378818301da1be,
    faPauseCircle: $77643f1129269c08$export$d8cf08a0362da8db,
    faPlayCircle: $77643f1129269c08$export$cf04333781061c5e,
    faPlusSquare: $77643f1129269c08$export$b6359eebfe900c35,
    faQuestionCircle: $77643f1129269c08$export$5ba67d7f2265c1a5,
    faRegistered: $77643f1129269c08$export$5f519e9ac15ab8c3,
    faSadCry: $77643f1129269c08$export$8e924e6bd422cef9,
    faSadTear: $77643f1129269c08$export$4b5241926f692f91,
    faSave: $77643f1129269c08$export$1aaa83ff70706e1e,
    faShareSquare: $77643f1129269c08$export$ae9e1434571f373c,
    faSmile: $77643f1129269c08$export$c632b2334f0913bc,
    faSmileBeam: $77643f1129269c08$export$54ada6dc9690e0ca,
    faSmileWink: $77643f1129269c08$export$f5dbb37f6801ee3f,
    faSnowflake: $77643f1129269c08$export$bab8f3647c394f48,
    faSquare: $77643f1129269c08$export$90b4406457aae8cc,
    faStar: $77643f1129269c08$export$a3b0eb2cd7942125,
    faStarHalf: $77643f1129269c08$export$228008b5e11032fa,
    faStickyNote: $77643f1129269c08$export$80889adc5d98bf4a,
    faStopCircle: $77643f1129269c08$export$47af2aad60ab3e7c,
    faSun: $77643f1129269c08$export$2fa35dcbc038dbe9,
    faSurprise: $77643f1129269c08$export$46647c72213f53ba,
    faThumbsDown: $77643f1129269c08$export$aba24ca305bbe8c1,
    faThumbsUp: $77643f1129269c08$export$47e4e0d519d33497,
    faTimesCircle: $77643f1129269c08$export$ab0ec50720a747eb,
    faTired: $77643f1129269c08$export$3d016d62cda18371,
    faTrashAlt: $77643f1129269c08$export$88df7ff7eb32f9dc,
    faUser: $77643f1129269c08$export$f5699fa0844e0188,
    faUserCircle: $77643f1129269c08$export$be7d974e9e0dba1a,
    faWindowClose: $77643f1129269c08$export$18b7775f78a3e16,
    faWindowMaximize: $77643f1129269c08$export$703cd98be31ec905,
    faWindowMinimize: $77643f1129269c08$export$26a3f9d2784b90d8,
    faWindowRestore: $77643f1129269c08$export$eccfff9bfd585652
};

});

parcelRegister("8MuU1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $664ac70725c024ba$var$prefix = "fas";
var $664ac70725c024ba$var$iconName = "cloud-upload-alt";
var $664ac70725c024ba$var$width = 640;
var $664ac70725c024ba$var$height = 512;
var $664ac70725c024ba$var$ligatures = [];
var $664ac70725c024ba$var$unicode = "f382";
var $664ac70725c024ba$var$svgPathData = "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z";
module.exports.definition = {
    prefix: $664ac70725c024ba$var$prefix,
    iconName: $664ac70725c024ba$var$iconName,
    icon: [
        $664ac70725c024ba$var$width,
        $664ac70725c024ba$var$height,
        $664ac70725c024ba$var$ligatures,
        $664ac70725c024ba$var$unicode,
        $664ac70725c024ba$var$svgPathData
    ]
};
module.exports.faCloudUploadAlt = module.exports.definition;
module.exports.prefix = $664ac70725c024ba$var$prefix;
module.exports.iconName = $664ac70725c024ba$var$iconName;
module.exports.width = $664ac70725c024ba$var$width;
module.exports.height = $664ac70725c024ba$var$height;
module.exports.ligatures = $664ac70725c024ba$var$ligatures;
module.exports.unicode = $664ac70725c024ba$var$unicode;
module.exports.svgPathData = $664ac70725c024ba$var$svgPathData;

});

parcelRegister("apvVy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $794501456e8a6c1e$var$prefix = "fas";
var $794501456e8a6c1e$var$iconName = "redo";
var $794501456e8a6c1e$var$width = 512;
var $794501456e8a6c1e$var$height = 512;
var $794501456e8a6c1e$var$ligatures = [];
var $794501456e8a6c1e$var$unicode = "f01e";
var $794501456e8a6c1e$var$svgPathData = "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z";
module.exports.definition = {
    prefix: $794501456e8a6c1e$var$prefix,
    iconName: $794501456e8a6c1e$var$iconName,
    icon: [
        $794501456e8a6c1e$var$width,
        $794501456e8a6c1e$var$height,
        $794501456e8a6c1e$var$ligatures,
        $794501456e8a6c1e$var$unicode,
        $794501456e8a6c1e$var$svgPathData
    ]
};
module.exports.faRedo = module.exports.definition;
module.exports.prefix = $794501456e8a6c1e$var$prefix;
module.exports.iconName = $794501456e8a6c1e$var$iconName;
module.exports.width = $794501456e8a6c1e$var$width;
module.exports.height = $794501456e8a6c1e$var$height;
module.exports.ligatures = $794501456e8a6c1e$var$ligatures;
module.exports.unicode = $794501456e8a6c1e$var$unicode;
module.exports.svgPathData = $794501456e8a6c1e$var$svgPathData;

});

parcelRegister("gZhRQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29532f6411106b8e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "ProductVariant", function () { return $29532f6411106b8e$export$e8f1c00077d11650; });

var $bhqzv = parcelRequire("bhqzv");
var $29532f6411106b8e$export$2e2bcd8739ae039 = (query)=>(0, $bhqzv.default).get({
        path: "/products",
        query: query
    });
var $29532f6411106b8e$export$e8f1c00077d11650;
(function(ProductVariant) {
    ProductVariant["Chargepoint"] = "Chargepoint";
    ProductVariant["ChargingCable"] = "ChargingCable";
    ProductVariant["MeasurementDevice"] = "MeasurementDevice";
})($29532f6411106b8e$export$e8f1c00077d11650 || ($29532f6411106b8e$export$e8f1c00077d11650 = {}));

});

parcelRegister("QoO6n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d476722f6d278b0$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $iZaUM = parcelRequire("iZaUM");

var $hyWja = parcelRequire("hyWja");

var $aKbcG = parcelRequire("aKbcG");
const $8d476722f6d278b0$var$SHeader = (0, $akcQ4.default).div`
    display: flex;
    justify-content: space-between;
`;
const $8d476722f6d278b0$var$SBackButtonContainer = (0, $akcQ4.default).div`
    display: flex;
    align-items: center;
`;
const $8d476722f6d278b0$var$SBackButton = (0, $akcQ4.default).button`
    display: flex;
    align-items: center;
    color: #093aa3;
    font-weight: 500;
    font-size: 14px;
    background-color: transparent;
    border: none;
`;
const $8d476722f6d278b0$var$SBackIcon = (0, $akcQ4.default)((0, $aKbcG.default))`
    fill: #093aa3;
    height: 8px;
    transform: rotate(90deg);
`;
const $8d476722f6d278b0$var$MainPageLayout = ({ children: children, title: title, backButton: backButton })=>{
    const navigate = (0, $iZaUM.useNavigate)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "page-layout-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "row"
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($8d476722f6d278b0$var$SHeader, {
        className: "col-xs-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "margin-top-small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $hyWja.Header), {
        message: title,
        size: "lg"
    })), backButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($8d476722f6d278b0$var$SBackButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($8d476722f6d278b0$var$SBackButton, {
        onClick: ()=>navigate(backButton.link ? backButton.link : -1)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($8d476722f6d278b0$var$SBackIcon, null), backButton.title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "margin-top-small margin-bottom-small"
    }, children))));
};
var $8d476722f6d278b0$export$2e2bcd8739ae039 = $8d476722f6d278b0$var$MainPageLayout;

});
parcelRegister("aKbcG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b5001c0038bd8f14$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $eRry7 = parcelRequire("eRry7");
const $b5001c0038bd8f14$var$IconChevronDown = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $eRry7.default), {
        width: "18",
        height: "11",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        d: "M1.75958 0.243524L-3.93267e-07 2.00311L8.99689 11L18 2.00311L16.2404 0.243523L8.99689 7.48083L1.75958 0.243524Z"
    }));
var $b5001c0038bd8f14$export$2e2bcd8739ae039 = $b5001c0038bd8f14$var$IconChevronDown;

});
parcelRegister("eRry7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $866ee4ce11688e07$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $174na = parcelRequire("174na");
const $866ee4ce11688e07$var$convertSizeToStyle = (size)=>{
    if (!size) return null;
    const normalizedSize = typeof size === "number" || size.match(/^\d+$/) ? `${size}px` : size;
    return {
        width: normalizedSize,
        height: normalizedSize
    };
};
const $866ee4ce11688e07$var$IconSvgContainer = ({ children: children, className: className, name: name, size: size, style: style = {}, width: width = 24, height: height = 24, viewBox: viewBox = `0 0 ${width} ${height}`, fill: fill = "none", xmlns: xmlns = "http://www.w3.org/2000/svg", ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))("icon", {
            [`icon--${name}`]: name
        }, className),
        width: width,
        height: height,
        viewBox: viewBox,
        fill: fill,
        xmlns: xmlns,
        style: {
            ...style,
            ...$866ee4ce11688e07$var$convertSizeToStyle(size)
        },
        ...rest
    }, children);
var $866ee4ce11688e07$export$2e2bcd8739ae039 = $866ee4ce11688e07$var$IconSvgContainer;

});



parcelRegister("eK784", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f94a2b2d6b9b4fa1$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $lWDz3 = parcelRequire("lWDz3");

var $iJ6Cm = parcelRequire("iJ6Cm");

var $174na = parcelRequire("174na");
const $f94a2b2d6b9b4fa1$var$SButtonGroup = (0, $akcQ4.default).div`
    display: flex;
    z-index: 0;
`;
const $f94a2b2d6b9b4fa1$var$SButton = (0, $akcQ4.default).button`
    display: inline-block;
    margin-bottom: 0;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid transparent;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.42857143;
    border-radius: 4px;
    user-select: none;
    min-height: 37px;
    color: #333;
    background-color: #fff;
    border-color: #ccc;

    :hover {
        ${({ active: active })=>!active && (0, $akcQ4.css)`
                background-color: #e6e6e6;
                border-color: #adadad;
            `}
    }

    :not(:first-child) {
        margin-left: -1px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    :not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    ${(p)=>p.active && (0, $akcQ4.css)`
            color: ${({ theme: theme })=>theme.font.darkestColor};
            background-color: ${({ theme: theme })=>theme.brandColors.CA_Green};
            background-image: none;
            border-color: #adadad;
        `}
`;
const $f94a2b2d6b9b4fa1$var$SButtonGroupItem = (0, $akcQ4.default)($f94a2b2d6b9b4fa1$var$SButton)`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const $f94a2b2d6b9b4fa1$var$SIcon = (0, $akcQ4.default)((0, $lWDz3.FontAwesomeIcon))`
    padding-left: 8px;
    color: ${({ theme: theme })=>theme.font.darkestColor};
    font-size: 18px;
`;
const $f94a2b2d6b9b4fa1$var$ButtonGroup = ({ value: value, options: options, onChange: onChange, dataTestId: dataTestId, isUnselectable: isUnselectable, withCheckmark: withCheckmark, style: style, className: className })=>{
    const onClick = (newValue)=>{
        if (isUnselectable && newValue === value) {
            onChange({
                value: ""
            });
            return;
        }
        onChange({
            value: newValue
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($f94a2b2d6b9b4fa1$var$SButtonGroup, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($174na)))("btn-group", "TID-ButtonGroup", className),
        style: style
    }, options.map((option, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($f94a2b2d6b9b4fa1$var$SButtonGroupItem, {
            key: `firmwareType${option.value}`,
            onClick: ()=>onClick(option.value),
            type: "button",
            active: value === option.value,
            "data-testid": "button-" + i,
            dataTestId: dataTestId
        }, option.label, withCheckmark && value === option.value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($f94a2b2d6b9b4fa1$var$SIcon, {
            icon: (0, $iJ6Cm.faCheck),
            "data-testid": "checkmark"
        }))));
};
var $f94a2b2d6b9b4fa1$export$2e2bcd8739ae039 = $f94a2b2d6b9b4fa1$var$ButtonGroup;

});

parcelRegister("2gfhP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $264110a4227feca0$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $4wg2b = parcelRequire("4wg2b");

var $fvmYM = parcelRequire("fvmYM");

var $aL1Vp = parcelRequire("aL1Vp");

var $2460e = parcelRequire("2460e");

var $cq3ae = parcelRequire("cq3ae");

var $1jt6z = parcelRequire("1jt6z");
const $264110a4227feca0$var$defaultUploadFirmwareErrorsValue = {
    firmwareVersion: undefined,
    description: undefined,
    file: undefined
};
const $264110a4227feca0$export$a85c47b0d1ce366 = 3;
const $264110a4227feca0$var$maxItemsCount = 1000;
const $264110a4227feca0$var$UploadFirmwareTab = ({ product: product })=>{
    const text = (0, $aL1Vp.default)();
    const [firmwareUploadErrors, setFirmwareUploadErrors] = (0, $6uMv9.useState)($264110a4227feca0$var$defaultUploadFirmwareErrorsValue);
    const [visibleItemsCount, setVisibleItemsCount] = (0, $6uMv9.useState)($264110a4227feca0$export$a85c47b0d1ce366);
    const [uploadFirmware] = (0, $fvmYM.useFirmwareUploadFirmwareMutation)();
    const [deleteFirmware] = (0, $fvmYM.useFirmwareDeleteFirmwareMutation)();
    const { data: firmware } = (0, $fvmYM.useFirmwareGetFirmwaresByFilterQuery)({
        productId: product.productId,
        ProductId: product.productId,
        firmwareType: product.firmwareType,
        noOfItems: visibleItemsCount,
        ocppEnabled: product.ocppEnabledFirmware
    }, {
        skip: !product.productId
    });
    const [availableFirmwares, setAvailableFirmwares] = (0, $6uMv9.useState)([]);
    const [confirmRemoveFirmware, setConfirmRemoveFirmware] = (0, $6uMv9.useState)(false);
    const [selectedFirmwareId, setSelectedFirmwareId] = (0, $6uMv9.useState)(null);
    const { data: activeFirmwareData, isLoading: activeFirmwareIsLoading } = (0, $fvmYM.useFirmwareGetActiveFirmwareQuery)({
        productId: product.productId
    }, {
        skip: !product || !product.productId
    });
    (0, $6uMv9.useEffect)(()=>setAvailableFirmwares(firmware?.items || []), [
        firmware
    ]);
    const totalAvailableFirmwares = (0, $6uMv9.useMemo)(()=>firmware?.totalCount || 0, [
        firmware?.totalCount
    ]);
    const firmwareList = (0, $6uMv9.useMemo)(()=>{
        return activeFirmwareData && activeFirmwareData.firmwareType === product.firmwareType && !product.ocppEnabledFirmware ? [
            {
                ...activeFirmwareData,
                isActive: true
            },
            ...availableFirmwares
        ].filter((obj, index, arr)=>{
            return index === arr.findIndex((o)=>obj.id === o.id);
        }) : availableFirmwares;
    }, [
        availableFirmwares,
        activeFirmwareData,
        product
    ]);
    (0, $6uMv9.useEffect)(()=>{
        if (product.firmwareVersion) {
            if (!availableFirmwares.find((x)=>x.firmwareVersion && Number(x.firmwareVersion) === Number(product.firmwareVersion))) setFirmwareUploadErrors((prevValue)=>({
                    ...prevValue,
                    firmwareVersion: undefined
                }));
        }
    }, [
        availableFirmwares,
        product.firmwareVersion
    ]);
    const submitUploadFirmware = (formValues)=>{
        const body = new FormData();
        body.append("FirmwareType", product.firmwareType);
        body.append("OcppEnabledFirmware", product.ocppEnabledFirmware);
        body.append("ProductId", product.productId);
        body.append("Title", product.title);
        body.append("FirmwareServerLocationId", product.firmwareServerLocationId);
        body.append("Description", formValues.description);
        body.append("FirmwareVersion", formValues.firmwareVersion);
        body.append("File", formValues.file);
        uploadFirmware({
            productId: product.productId,
            body: body
        }).unwrap().then(()=>{
            (0, $2460e.notifySuccess)(text("msgNewFirmwareUploadedSuccessfully"));
        }).catch(()=>{
            (0, $2460e.notifyError)(text("msgNewFirmwareUploadedFailed"));
        });
    };
    (0, $6uMv9.useEffect)(()=>{
        setFirmwareUploadErrors($264110a4227feca0$var$defaultUploadFirmwareErrorsValue);
    }, [
        product
    ]);
    const onRemoveFirmware = (id, removeIsConfirmed)=>{
        setSelectedFirmwareId(id);
        setConfirmRemoveFirmware(removeIsConfirmed);
    };
    const handleRemoveConfirm = ()=>{
        if (product.productId && selectedFirmwareId) deleteFirmware({
            productId: product.productId,
            firmwareId: selectedFirmwareId
        }).unwrap().then(()=>{
            onRemoveFirmware(null, false);
            (0, $2460e.notifySuccess)(text("msgFirmwareRemoved"));
        }, ({ error: error })=>error && (0, $2460e.notifyError)(error));
    };
    const shouldShowLess = availableFirmwares.length > $264110a4227feca0$export$a85c47b0d1ce366;
    const shouldShowMore = !shouldShowLess && totalAvailableFirmwares > $264110a4227feca0$export$a85c47b0d1ce366;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "w-12 sm:w-5 md:w-4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $4wg2b.default), {
        productName: product.title,
        firmware: product,
        errors: firmwareUploadErrors,
        onSubmit: submitUploadFirmware
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "w-12 sm:w-7 md:w-8 ml-8"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1jt6z.default), {
        showMoreIsVisible: shouldShowMore,
        onShowMore: ()=>setVisibleItemsCount($264110a4227feca0$var$maxItemsCount),
        showLessIsVisible: shouldShowLess,
        onShowLess: ()=>setAvailableFirmwares(availableFirmwares.slice(0, $264110a4227feca0$export$a85c47b0d1ce366)),
        onRemove: (id)=>onRemoveFirmware(id, true),
        title: text("msgFWVersions"),
        data: firmwareList,
        isOcpp: product.ocppEnabledFirmware ?? false,
        loading: activeFirmwareIsLoading,
        showActionMenu: true
    })), confirmRemoveFirmware && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cq3ae.default), {
        message: text("msgConfirmFwRemoval"),
        onClose: ()=>onRemoveFirmware(null, false),
        confirmButtonText: text("lblConfirm"),
        onConfirm: handleRemoveConfirm,
        title: text("lblConfirmFirmwareRemove")
    }));
};
var $264110a4227feca0$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $6uMv9.memo)($264110a4227feca0$var$UploadFirmwareTab);

});
parcelRegister("4wg2b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $663490924f47cd51$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $cbVaW = parcelRequire("cbVaW");

var $akcQ4 = parcelRequire("akcQ4");

var $f7UZA = parcelRequire("f7UZA");

var $iktXR = parcelRequire("iktXR");

var $bN3Nf = parcelRequire("bN3Nf");

var $9Ezdl = parcelRequire("9Ezdl");

var $3Epa9 = parcelRequire("3Epa9");

var $aL1Vp = parcelRequire("aL1Vp");

var $kvJbm = parcelRequire("kvJbm");
const $663490924f47cd51$var$SWrapper = (0, $akcQ4.default).div`
    border: 1px solid #e6e6e6;
    border-radius: 8px;
    padding: 25px 25px 45px 25px;
`;
const $663490924f47cd51$var$STitle = (0, $akcQ4.default).h3`
    font-family: ${({ theme: theme })=>theme.font.name};
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    margin: 0 0 1em 0;
`;
const $663490924f47cd51$var$STitleFirmware = (0, $akcQ4.default).span`
    font-family: ${({ theme: theme })=>theme.font.name};
    font-size: 18px;
    font-weight: 300;
    line-height: 24px;
`;
const $663490924f47cd51$var$SButtons = (0, $akcQ4.default).div`
    display: flex;
    justify-content: space-between;
    margin-top: 2.5em;
`;
const $663490924f47cd51$var$UploadFirmwarePanel = ({ productName: productName, firmware: firmware, errors: errors, onSubmit: onSubmit })=>{
    const { handleSubmit: handleSubmit, register: register, formState: { errors: formErrors, isValid: isValid }, reset: reset } = (0, $cbVaW.useForm)({
        mode: "onChange",
        delayError: 500
    });
    const text = (0, $aL1Vp.default)();
    const fwValidation = (0, $6uMv9.useMemo)(()=>(0, $9Ezdl.firmwareInputValidation)(productName, true), [
        productName
    ]);
    const submit = async (formValues)=>{
        onSubmit({
            ...formValues,
            file: formValues.file[0]
        });
    };
    const clearForm = (0, $6uMv9.useCallback)(()=>{
        reset({
            firmwareVersion: "",
            description: "",
            file: null
        });
    }, [
        reset
    ]);
    (0, $6uMv9.useEffect)(()=>{
        clearForm();
    }, [
        clearForm
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($663490924f47cd51$var$SWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($663490924f47cd51$var$STitle, {
        "data-testid": "upload-title"
    }, "Upload firmware ", productName, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($663490924f47cd51$var$STitleFirmware, null, firmware.firmwareType)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        id: "input-version",
        "data-testid": "input-version",
        type: (0, $3Epa9.default)(productName) || (0, $kvJbm.default)(productName) ? "text" : "number",
        labelText: "Version number",
        error: formErrors.firmwareVersion?.message,
        ...!(0, $3Epa9.default)(productName) && {
            step: 1
        },
        ...register("firmwareVersion", fwValidation)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $bN3Nf.default), {
        "data-testid": "textarea",
        error: formErrors.description?.message,
        labelText: "Description",
        ...register("description", {
            required: "Description is required"
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        id: "input-file",
        "data-testid": "input-file",
        error: errors?.file,
        type: "file",
        accept: ".zfw,.fw,.img,.enc",
        ...register("file", {
            required: "File is required"
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($663490924f47cd51$var$SButtons, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        onClick: clearForm,
        "data-testid": "btn-clear",
        label: text("btnClear"),
        size: "sm",
        primary: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        onClick: handleSubmit(submit),
        "data-testid": "btn-upload",
        label: text("btnUpload"),
        size: "sm",
        disabled: !isValid
    })));
};
var $663490924f47cd51$export$2e2bcd8739ae039 = $663490924f47cd51$var$UploadFirmwarePanel;

});
parcelRegister("9Ezdl", function(module, exports) {

$parcel$export(module.exports, "firmwareInputValidation", function () { return $c4aa34e41f47f2de$export$9cc6a38a08a20586; });

var $3Epa9 = parcelRequire("3Epa9");

var $kvJbm = parcelRequire("kvJbm");

var $aqGOF = parcelRequire("aqGOF");
const $c4aa34e41f47f2de$export$9cc6a38a08a20586 = (productName, required)=>({
        ...required && {
            required: "Version number required"
        },
        ...(0, $3Epa9.default)(productName) || (0, $kvJbm.default)(productName) ? {
            pattern: {
                value: (0, $aqGOF.default),
                message: "Version number not valid. Example: 1.1.0"
            }
        } : {
            pattern: {
                value: /^[-\d]\d*$/,
                message: "Version number not valid. Example: 830"
            }
        },
        ...(!(0, $3Epa9.default)(productName) || (0, $kvJbm.default)(productName)) && {
            step: 1
        }
    });

});


parcelRegister("1jt6z", function(module, exports) {

$parcel$export(module.exports, "FirmwareModalTable", function () { return $542db5fb2810bb8a$export$5f5816b384f31c3f; });
$parcel$export(module.exports, "default", function () { return $542db5fb2810bb8a$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");

var $aKbcG = parcelRequire("aKbcG");
parcelRequire("icCom");
var $fyYJX = parcelRequire("fyYJX");

var $gyGCK = parcelRequire("gyGCK");

var $7jCZT = parcelRequire("7jCZT");

var $1xw2Y = parcelRequire("1xw2Y");

var $2naDF = parcelRequire("2naDF");

var $3YfCm = parcelRequire("3YfCm");

var $f7UZA = parcelRequire("f7UZA");

var $ekQQG = parcelRequire("ekQQG");
parcelRequire("ibSgR");
var $9Auwb = parcelRequire("9Auwb");

var $aL1Vp = parcelRequire("aL1Vp");
const $542db5fb2810bb8a$export$3f2444121320c737 = (0, $akcQ4.default)((0, $aKbcG.default))`
    fill: #424242;
    margin-left: 0.5em;
`;
const $542db5fb2810bb8a$var$SUnlockButtonContainer = (0, $akcQ4.default).div`
    display: flex;
    justify-content: flex-end;
    padding-top: 40px;
`;
const $542db5fb2810bb8a$var$SCollapseIcon = (0, $akcQ4.default)($542db5fb2810bb8a$export$3f2444121320c737)`
    transform: rotate(180deg);
`;
const $542db5fb2810bb8a$export$f0b62611333e40aa = (0, $akcQ4.default).button`
    display: block;
    margin: 1em auto 0 auto;
    background: transparent;
    border: none;
    font-size: 16px;
    font-weight: 400;
    color: #424242;
`;
const $542db5fb2810bb8a$var$SSelectFirmwareVersionInstruction = (0, $akcQ4.default).p`
    font-size: 16px;
    font-weight: 400;
`;
const $542db5fb2810bb8a$var$STitleWithIcon = (0, $akcQ4.default).div`
    padding-right: 70px;
    width: 100%;
    position: relative;
`;
const $542db5fb2810bb8a$export$5f5816b384f31c3f = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableRow), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "version"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblVersion"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "date"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblDate"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "no-of-chargers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblStatus"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "desc"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($542db5fb2810bb8a$var$STitleWithIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblDescription"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), {
        "data-testid": "no-of-chargers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblNoOfChargers"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.TableHeaderCell), null)));
};
const $542db5fb2810bb8a$var$FirmwareList = ({ data: data, onActivate: onActivate, onRemove: onRemove, onShowMore: onShowMore, onShowLess: onShowLess, showLessIsVisible: showLessIsVisible, showMoreIsVisible: showMoreIsVisible, loading: loading, showActionMenu: showActionMenu })=>{
    const text = (0, $aL1Vp.default)();
    const [firmwares, setFirmwares] = (0, $6uMv9.useState)([]);
    (0, $6uMv9.useEffect)(()=>{
        setFirmwares(data || []);
        setIsSettingsLocked(true);
    }, [
        data
    ]);
    const onLoadMoreClick = ()=>{
        onShowMore && onShowMore();
    };
    const onHideClick = ()=>{
        onShowLess && onShowLess();
    };
    const [isUnlockSettingsModalVisible, setIsUnlockSettingsModalVisible] = (0, $6uMv9.useState)(false);
    const [isSettingsLocked, setIsSettingsLocked] = (0, $6uMv9.useState)(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $3YfCm.WidgetLayout), {
        title: text("msgFWVersions"),
        headerButtons: onActivate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($542db5fb2810bb8a$var$SUnlockButtonContainer, {
            "data-testid": "btn-unlock"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
            label: text(isSettingsLocked ? "btnUnlock" : "btnLock"),
            onClick: ()=>setIsUnlockSettingsModalVisible(true),
            disabled: !isSettingsLocked,
            icon: isSettingsLocked ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $ekQQG.LockIcon), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9Auwb.UnlockIcon), null)
        }))
    }, onActivate && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($542db5fb2810bb8a$var$SSelectFirmwareVersionInstruction, {
        "data-testid": "instructions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgFWVersionInstruction"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($542db5fb2810bb8a$export$5f5816b384f31c3f, null), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, firmwares.map((firmware)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $fyYJX.FirmwareListItem), {
            key: firmware.id,
            data: firmware,
            onActivate: onActivate,
            onRemove: onRemove,
            isActivationDisabled: isSettingsLocked,
            showActionMenu: showActionMenu
        })))), showMoreIsVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($542db5fb2810bb8a$export$f0b62611333e40aa, {
        onClick: onLoadMoreClick,
        "data-testid": "load-more"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnLoadMore"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($542db5fb2810bb8a$export$3f2444121320c737, null)), showLessIsVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($542db5fb2810bb8a$export$f0b62611333e40aa, {
        onClick: onHideClick,
        "data-testid": "show-less"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnHide"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($542db5fb2810bb8a$var$SCollapseIcon, null)), isUnlockSettingsModalVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $gyGCK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7jCZT.default), {
        title: "Unlocking factory firmware settings",
        message: "By proceeding, you are identifying yourself as an authorized user. Any changes you make in the settings will be stored in an audit log.",
        showCancel: true,
        dismiss: ()=>setIsUnlockSettingsModalVisible(false),
        close: ()=>{
            setIsSettingsLocked(false);
            setIsUnlockSettingsModalVisible(false);
        },
        okButtonText: "Unlock"
    })));
};
var $542db5fb2810bb8a$export$2e2bcd8739ae039 = $542db5fb2810bb8a$var$FirmwareList;

});
parcelRegister("ibSgR", function(module, exports) {
$parcel$export(module.exports, "UnlockIcon", function () { return (parcelRequire("9Auwb")).UnlockIcon; });
parcelRequire("9Auwb");

});
parcelRegister("9Auwb", function(module, exports) {

$parcel$export(module.exports, "UnlockIcon", function () { return $3e4f9e1af54a7bfc$export$caf8e4bd765e502b; });

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");
const $3e4f9e1af54a7bfc$var$SSPan = (0, $akcQ4.default).span`
    display: flex;
    align-items: center;
`;
function $3e4f9e1af54a7bfc$export$caf8e4bd765e502b({ fill: fill, size: size = 14, title: title, dataTestid: dataTestid, id: id = "lock-icon" }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($3e4f9e1af54a7bfc$var$SSPan, {
        title: title,
        id: id,
        "data-testid": dataTestid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: fill ?? "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-unlock"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("rect", {
        x: "3",
        y: "11",
        width: "18",
        height: "11",
        rx: "2",
        ry: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        d: "M7 11V7a5 5 0 0 1 9.9-1"
    })));
}

});




parcelRegister("7o7Qd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37254199332ac099$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");
const $37254199332ac099$var$Tab = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", props, children);
};
var $37254199332ac099$export$2e2bcd8739ae039 = $37254199332ac099$var$Tab;

});

parcelRegister("32rQe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $df2b8600cccd48a5$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $fvmYM = parcelRequire("fvmYM");

var $aL1Vp = parcelRequire("aL1Vp");
parcelRequire("fTfCo");
var $hVnQj = parcelRequire("hVnQj");

var $cq3ae = parcelRequire("cq3ae");

var $2460e = parcelRequire("2460e");

var $1jt6z = parcelRequire("1jt6z");
const $df2b8600cccd48a5$export$a85c47b0d1ce366 = 3;
const $df2b8600cccd48a5$var$maxItemsCount = 1000;
const $df2b8600cccd48a5$var$SelectFactoryFirmwareTab = ({ product: product })=>{
    const text = (0, $aL1Vp.default)();
    const [visibleItemsCount, setVisibleItemsCount] = (0, $6uMv9.useState)($df2b8600cccd48a5$export$a85c47b0d1ce366);
    const [activateFirmware] = (0, $fvmYM.useFirmwareSetActiveFirmwareMutation)();
    const [deleteFirmware] = (0, $fvmYM.useFirmwareDeleteFirmwareMutation)();
    const { data: firmware } = (0, $fvmYM.useFirmwareGetFirmwaresByFilterQuery)({
        productId: product.productId,
        firmwareType: product.firmwareType,
        noOfItems: visibleItemsCount,
        ocppEnabled: product.ocppEnabledFirmware
    }, {
        skip: !product.productId
    });
    const [availableFirmwares, setAvailableFirmwares] = (0, $6uMv9.useState)([]);
    const [confirmRemoveFirmware, setConfirmRemoveFirmware] = (0, $6uMv9.useState)(false);
    const [selectedFirmwareId, setSelectedFirmwareId] = (0, $6uMv9.useState)(null);
    const [confirmActivateFirmware, setConfirmActivateFirmware] = (0, $6uMv9.useState)(false);
    (0, $6uMv9.useEffect)(()=>setAvailableFirmwares(firmware?.items || []), [
        firmware
    ]);
    const totalAvailableFirmwares = (0, $6uMv9.useMemo)(()=>firmware?.totalCount || 0, [
        firmware?.totalCount
    ]);
    const { data: activeFirmwareData, isLoading: activeFirmwareIsLoading } = (0, $fvmYM.useFirmwareGetActiveFirmwareQuery)({
        productId: product.productId
    }, {
        skip: !product || !product.productId
    });
    const firmwareList = (0, $6uMv9.useMemo)(()=>{
        return activeFirmwareData && activeFirmwareData.firmwareType === product.firmwareType && !product.ocppEnabledFirmware ? [
            {
                ...activeFirmwareData,
                isActive: true
            },
            ...availableFirmwares
        ].filter((obj, index, arr)=>{
            return index === arr.findIndex((o)=>obj.id === o.id);
        }) : availableFirmwares;
    }, [
        availableFirmwares,
        activeFirmwareData,
        product
    ]);
    const onRemoveFirmware = (id, removeIsConfirmed)=>{
        setSelectedFirmwareId(id);
        setConfirmRemoveFirmware(removeIsConfirmed);
    };
    const onActivateFirmware = (id, activateIsConfirmed)=>{
        setSelectedFirmwareId(id);
        setConfirmActivateFirmware(activateIsConfirmed);
    };
    const handleRemoveConfirm = ()=>{
        if (product.productId && selectedFirmwareId) deleteFirmware({
            productId: product.productId,
            firmwareId: selectedFirmwareId
        }).then(()=>{
            onRemoveFirmware(null, false);
            (0, $2460e.notifySuccess)(text("msgFirmwareRemoved"));
        }, ({ error: error })=>error && (0, $2460e.notifyError)(error));
    };
    const handleActivateConfirm = ()=>{
        activateFirmware({
            productId: product.productId,
            firmwareId: selectedFirmwareId
        }).then(()=>{
            onActivateFirmware(selectedFirmwareId, false);
            (0, $2460e.notifySuccess)(text("msgFirmwareActivated"));
        }, ({ error: error })=>error && (0, $2460e.notifyError)(error));
    };
    const shouldShowLess = availableFirmwares.length > $df2b8600cccd48a5$export$a85c47b0d1ce366;
    const shouldShowMore = !shouldShowLess && totalAvailableFirmwares > $df2b8600cccd48a5$export$a85c47b0d1ce366;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "w-12"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1jt6z.default), {
        title: text("lblSelectFactoryFirmware"),
        showMoreIsVisible: shouldShowMore,
        onShowMore: ()=>setVisibleItemsCount($df2b8600cccd48a5$var$maxItemsCount),
        showLessIsVisible: shouldShowLess,
        onShowLess: ()=>setAvailableFirmwares(availableFirmwares.slice(0, $df2b8600cccd48a5$export$a85c47b0d1ce366)),
        onRemove: (id)=>{
            onRemoveFirmware(id, true);
        },
        onActivate: (id)=>onActivateFirmware(id, true),
        loading: activeFirmwareIsLoading,
        isOcpp: product.ocppEnabledFirmware ?? false,
        data: firmwareList
    })), confirmRemoveFirmware && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cq3ae.default), {
        message: text("msgConfirmFwRemoval"),
        onClose: ()=>onRemoveFirmware(null, false),
        confirmButtonText: text("lblConfirm"),
        onConfirm: handleRemoveConfirm,
        title: text("lblConfirmFirmwareRemove")
    }), confirmActivateFirmware ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $hVnQj.ActivateFirmwareModal), {
        onCancel: ()=>onActivateFirmware(null, false),
        onConfirm: handleActivateConfirm,
        currentFactoryFirmware: availableFirmwares.find((firmware)=>firmware.id === activeFirmwareData?.id),
        newFactoryFirmware: availableFirmwares.find((firmware)=>firmware.id === selectedFirmwareId)
    }) : null);
};
var $df2b8600cccd48a5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $6uMv9.memo)($df2b8600cccd48a5$var$SelectFactoryFirmwareTab);

});
parcelRegister("fTfCo", function(module, exports) {
$parcel$export(module.exports, "ActivateFirmwareModal", function () { return (parcelRequire("hVnQj")).ActivateFirmwareModal; });
parcelRequire("hVnQj");

});
parcelRegister("hVnQj", function(module, exports) {

$parcel$export(module.exports, "ActivateFirmwareModal", function () { return $cbc1e5ce460a0e50$export$5d96b00099bf1938; });

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");
parcelRequire("icCom");
var $fyYJX = parcelRequire("fyYJX");

var $1xw2Y = parcelRequire("1xw2Y");

var $8gLAc = parcelRequire("8gLAc");

var $1jt6z = parcelRequire("1jt6z");

var $2naDF = parcelRequire("2naDF");

var $aL1Vp = parcelRequire("aL1Vp");
const $cbc1e5ce460a0e50$var$SText = (0, $akcQ4.default).div`
    font-weight: 500;
`;
function $cbc1e5ce460a0e50$export$5d96b00099bf1938({ onCancel: onCancel, onConfirm: onConfirm, currentFactoryFirmware: currentFactoryFirmware, newFactoryFirmware: newFactoryFirmware }) {
    const text = (0, $aL1Vp.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), {
        title: text("msgFWActivateModal"),
        size: "lg",
        "data-testid": "activate-firmware-modal",
        actions: [
            {
                label: text("btnCancel"),
                btn: "btn-secondary",
                callback: onCancel
            },
            {
                label: text("btnConfirm"),
                callback: onConfirm
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cbc1e5ce460a0e50$var$SText, {
        "data-testid": "info"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgFWInfo"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cbc1e5ce460a0e50$var$SText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgFWCurrent"
    })), currentFactoryFirmware && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1jt6z.FirmwareModalTable), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $fyYJX.FirmwareListItem), {
        data: currentFactoryFirmware
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($cbc1e5ce460a0e50$var$SText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgFWNew"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $2naDF.Table), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1jt6z.FirmwareModalTable), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $fyYJX.FirmwareListItem), {
        data: newFactoryFirmware
    })));
}

});



parcelRegister("kkkuC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12e55ce58ef857c9$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $iZaUM = parcelRequire("iZaUM");

var $blgfq = parcelRequire("blgfq");

var $fvmYM = parcelRequire("fvmYM");

var $2460e = parcelRequire("2460e");

var $5fQlh = parcelRequire("5fQlh");

var $bFvpP = parcelRequire("bFvpP");

var $aL1Vp = parcelRequire("aL1Vp");

var $6Wbwp = parcelRequire("6Wbwp");

var $7wlt6 = parcelRequire("7wlt6");

var $9Lreg = parcelRequire("9Lreg");

var $jEjkX = parcelRequire("jEjkX");

var $6yckW = parcelRequire("6yckW");
const $12e55ce58ef857c9$var$defaultFiltersValue = {
    id: "",
    companyName: "",
    installedFirmwareVersion: "",
    status: undefined,
    noOfItems: 50,
    page: 0,
    partnerId: undefined
};
const $12e55ce58ef857c9$export$a85c47b0d1ce366 = 3;
const $12e55ce58ef857c9$var$UpdateChargersFirmwareTab = ({ product: product })=>{
    const text = (0, $aL1Vp.default)();
    const filtersContainerRef = (0, $6uMv9.useRef)(null);
    const [params, setParams] = (0, $iZaUM.useSearchParams)();
    const [filters, setFilters] = (0, $6uMv9.useState)(Object.fromEntries(params.entries()));
    (0, $6uMv9.useEffect)(()=>{
        setFilters(Object.fromEntries(params.entries()));
    }, [
        params
    ]);
    const { data: firmware } = (0, $fvmYM.useFirmwareGetFirmwaresByFilterQuery)({
        productId: product.productId,
        firmwareType: product.firmwareType,
        noOfItems: $12e55ce58ef857c9$export$a85c47b0d1ce366,
        ocppEnabled: product.ocppEnabledFirmware
    }, {
        skip: !product.productId
    });
    const latestFirmwareVersion = firmware?.items && firmware?.items.length > 0 ? firmware?.items.reduce((previousValue, currentValue)=>(0, $5fQlh.compareSemanticVersions)(previousValue.firmwareVersion ?? 0, currentValue.firmwareVersion ?? 0) ? previousValue : currentValue) : undefined;
    const [currentPage, setCurrentPage] = (0, $6uMv9.useState)(0);
    const [pageSize, setPageSize] = (0, $6uMv9.useState)(50);
    const { data: partners } = (0, $fvmYM.usePartnerGetAllAllQuery)({
        excludeOrphans: false
    });
    const { data: chargePointsList, isFetching: chargePointsIsLoading, refetch: refetchChargers, error: chargePointsError } = (0, $fvmYM.useChargePointGetChargePointsQuery)({
        ...filters,
        productId: product.productId,
        firmwareType: product.ocppEnabledFirmware ? undefined : product.firmwareType,
        ocppOnly: product.ocppEnabledFirmware,
        page: currentPage,
        status: filters.status,
        noOfItems: pageSize,
        expand: (0, $6Wbwp.default).OcppConfig
    }, {
        skip: !product.productId
    });
    const [chargePoints, setChargePoints] = (0, $6uMv9.useState)([]);
    const [confirmUpdateChargers, setConfirmUpdateChargers] = (0, $6uMv9.useState)(false);
    const [sort, setSort] = (0, $6uMv9.useState)({});
    const partnerOptions = (0, $6uMv9.useMemo)(()=>[
            {
                value: undefined,
                label: "Any partner"
            },
            ...(partners || []).map((x)=>({
                    value: x.id,
                    label: x.name
                }))
        ], [
        partners
    ]);
    const handlePageClick = (selected)=>{
        window.scrollTo(0, filtersContainerRef.current?.offsetTop || 0);
        setCurrentPage(selected);
    };
    const pageClick = ()=>{
        setCurrentPage(0);
    };
    const onSelectCharger = (id, checked)=>{
        setChargePoints(chargePoints?.map((cp)=>cp.id === id ? {
                ...cp,
                checked: checked
            } : cp));
    };
    const onSelectAllChargers = (checked)=>{
        const selectedChargePoints = chargePoints?.map((chargePoint)=>{
            const latestFirmwareVersionNotInstalled = latestFirmwareVersion?.firmwareVersion !== chargePoint.installedFirmwareVersion || (0, $5fQlh.compareSemanticVersions)(latestFirmwareVersion?.firmwareVersion ?? 0, (0, $5fQlh.getFirmwareVersion)(chargePoint.ocppConfigKeys));
            return latestFirmwareVersionNotInstalled && (0, $7wlt6.default)(chargePoint) ? {
                ...chargePoint,
                checked: checked
            } : chargePoint;
        });
        setChargePoints(selectedChargePoints);
    };
    const submitUpdateFirmware = (firmwareId)=>{
        const updateModel = {
            firmwareId: firmwareId,
            chargePointIds: chargePoints.filter((x)=>x.checked).map((x)=>x.id)
        };
        return (0, $bFvpP.default)(updateModel);
    };
    (0, $6uMv9.useEffect)(()=>{
        if (chargePointsError) (0, $2460e.notifyError)(text("msgFirmwareLoadError"));
    }, [
        chargePointsError
    ]);
    (0, $6uMv9.useEffect)(()=>{
        setChargePoints(chargePointsList?.items ?? []);
    }, [
        chargePointsList
    ]);
    const onChargePointFiltersChange = (fieldName, value)=>{
        const params = {
            [fieldName]: value,
            ...fieldName !== "page" && {
                page: 0
            }
        };
        updateFilters(params);
    };
    const updateFilters = (filterParams)=>{
        const newFilter = {
            ...filters,
            ...filterParams
        };
        const params = (0, $blgfq.pickBy)(newFilter, (value)=>value !== undefined && value !== null);
        setParams(params);
    };
    const clearFilters = ()=>{
        updateFilters($12e55ce58ef857c9$var$defaultFiltersValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jEjkX.default), {
        filters: filters,
        productName: product.title,
        partnerOptions: partnerOptions,
        onChange: onChargePointFiltersChange,
        onClearFilters: clearFilters,
        onSubmit: (filter)=>{
            updateFilters(filter);
            setCurrentPage(0);
        },
        pageClick: pageClick,
        isFetching: chargePointsIsLoading
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $9Lreg.default), {
        currentPage: currentPage,
        setCurrentPage: setCurrentPage,
        latestFirmwareVersion: latestFirmwareVersion?.firmwareVersion,
        handlePageClick: handlePageClick,
        onSelect: onSelectCharger,
        onSelectAll: onSelectAllChargers,
        totalCount: chargePointsList?.totalCount ?? 0,
        filters: params,
        onUpdate: ()=>setConfirmUpdateChargers(true),
        onChangeSort: (by, direction)=>setSort({
                by: by,
                direction: direction
            }),
        sortBy: sort.by,
        sortDirection: sort.direction,
        chargePoints: chargePoints,
        setSelectedPageSize: setPageSize,
        isPending: chargePointsIsLoading
    }), confirmUpdateChargers && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $6yckW.default), {
        productId: product.productId,
        firmwareType: product.firmwareType,
        firmwareTitle: product.firmwareType,
        chargePoints: chargePoints.filter((chargePoint)=>chargePoint.checked),
        productTitle: product.title,
        onSubmit: submitUpdateFirmware,
        onCancel: (refresh)=>{
            setConfirmUpdateChargers(false);
            if (refresh) refetchChargers();
        }
    }));
};
var $12e55ce58ef857c9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $6uMv9.memo)($12e55ce58ef857c9$var$UpdateChargersFirmwareTab);

});
parcelRegister("bFvpP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6122df476de04722$export$2e2bcd8739ae039; });

var $bhqzv = parcelRequire("bhqzv");
const $6122df476de04722$var$updateChargePointsFirmware = (model)=>(0, $bhqzv.default)({
        method: "POST",
        path: "/chargepoints/firmware/update",
        body: model
    });
var $6122df476de04722$export$2e2bcd8739ae039 = $6122df476de04722$var$updateChargePointsFirmware;

});

parcelRegister("7wlt6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e02300d086001aff$export$2e2bcd8739ae039; });
function $e02300d086001aff$export$2e2bcd8739ae039(chargePoint) {
    return chargePoint.isOcpp ? chargePoint.chargePointStatus !== "Offline" : true;
}

});

parcelRegister("9Lreg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ecd1bda8cf3db291$export$2e2bcd8739ae039; });

var $go3CH = parcelRequire("go3CH");

var $knKVd = parcelRequire("knKVd");

var $akcQ4 = parcelRequire("akcQ4");

var $lWDz3 = parcelRequire("lWDz3");

var $6uMv9 = parcelRequire("6uMv9");

var $iZaUM = parcelRequire("iZaUM");

var $bhWK5 = parcelRequire("bhWK5");

var $1xw2Y = parcelRequire("1xw2Y");

var $cBlPU = parcelRequire("cBlPU");

var $35vY7 = parcelRequire("35vY7");

var $5fQlh = parcelRequire("5fQlh");

var $aL1Vp = parcelRequire("aL1Vp");

var $1wGKW = parcelRequire("1wGKW");

var $7pGEV = parcelRequire("7pGEV");

var $7wlt6 = parcelRequire("7wlt6");

var $jEjkX = parcelRequire("jEjkX");
const $ecd1bda8cf3db291$var$WidgetWrapper = (0, $akcQ4.default).div`
    margin-top: 40px;
    padding-top: 40px;
    border-top: 1px solid #b3b3b3;
`;
const $ecd1bda8cf3db291$export$592f2e2cecbdbd14 = (0, $akcQ4.default).div`
    text-transform: capitalize;
    font-family: 'Lateral Extended';
    font-weight: 500;
    font-size: 1.25rem;
    margin-bottom: 20px;
`;
const $ecd1bda8cf3db291$var$SpinnerContainer = (0, $akcQ4.default).div`
    text-align: center;
`;
const $ecd1bda8cf3db291$var$SCheckboxLabel = (0, $akcQ4.default).label`
    font-family: ${({ theme: theme })=>theme.font.name};
    font-size: 16px;
    font-weight: 500;
    line-height: 1.2em;
`;
const $ecd1bda8cf3db291$var$SSearchResultsNumber = (0, $akcQ4.default).div`
    font-family: ${({ theme: theme })=>theme.font.name};
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
`;
const $ecd1bda8cf3db291$var$SFilterGroup = (0, $akcQ4.default).div`
    display: flex;
    flex-wrap: wrap;
    margin: 0 -15px;
`;
const $ecd1bda8cf3db291$var$SFilter = (0, $akcQ4.default).div`
    padding: 0 15px 1em;

    ${(p)=>p.actions ? (0, $akcQ4.css)`
                  @media (min-width: 1024px) {
                      margin-left: auto;
                      display: flex;
                      justify-content: flex-end;
                      align-items: flex-end;
                  }
              ` : ""}

    flex: 1 0 auto;
    ${(p)=>p.large ? (0, $akcQ4.css)`
                  @media (max-width: 1023px) {
                      width: 100%;
                  }
              ` : ""}

    @media (max-width: 767px) {
        width: 100%;
    }
`;
const $ecd1bda8cf3db291$var$STableWrapper = (0, $akcQ4.default).div`
    width: 100%;
    overflow: auto;
`;
const $ecd1bda8cf3db291$var$STable = (0, $akcQ4.default).table`
    min-width: 100%;
`;
const $ecd1bda8cf3db291$var$TableColumn = ({ children: children, sorted: sorted, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("th", props, children, " ", sorted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $lWDz3.FontAwesomeIcon), {
        icon: sorted === "asc" ? (0, $go3CH.faCaretDown) : (0, $knKVd.faCaretUp)
    }));
const $ecd1bda8cf3db291$var$STableColumn = (0, $akcQ4.default)($ecd1bda8cf3db291$var$TableColumn)`
    font-family: ${({ theme: theme })=>theme.font.name};
    font-size: 12px;
    font-weight: 300;
    line-height: 18px;
    padding: 12px 8px;
    white-space: nowrap;
    ${(p)=>p.sortable && (0, $akcQ4.css)`
            cursor: pointer;
            color: ${({ theme: theme })=>theme.brandColors.CA_Blue};
        `}
    width: ${({ width: width })=>width ?? "inherit"};
`;
const $ecd1bda8cf3db291$var$STableRow = (0, $akcQ4.default).tr`
    &:nth-child(odd) {
        background: #f5f5f5;
    }
`;
const $ecd1bda8cf3db291$var$STableCell = (0, $akcQ4.default).td`
    font-family: ${({ theme: theme })=>theme.font.name};
    font-size: 14px;
    font-weight: 300;
    line-height: 24px;
    padding: 12px 8px;
`;
const $ecd1bda8cf3db291$var$columns = [
    {
        name: "Id",
        sortableProperty: "id"
    },
    {
        name: "Name",
        sortableProperty: "name"
    },
    {
        name: "Status",
        sortableProperty: "chargePointStatus"
    },
    {
        name: "Organisation",
        sortableProperty: "companyName"
    },
    {
        name: "Current FW",
        sortableProperty: "installedFirmwareVersion"
    },
    {
        name: "Update to"
    },
    {
        name: "FW update status"
    },
    {
        name: "Last updated",
        sortableProperty: "firmwareLastUpdated"
    }
];
const $ecd1bda8cf3db291$var$UpdateChargersFirmwareList = ({ filters: filters, totalCount: totalCount, currentPage: currentPage, chargePoints: chargePoints, handlePageClick: handlePageClick, latestFirmwareVersion: latestFirmwareVersion, sortBy: sortBy, sortDirection: sortDirection, onSelect: onSelect, onSelectAll: onSelectAll, setCurrentPage: setCurrentPage, onChangeSort: onChangeSort, onUpdate: onUpdate, setSelectedPageSize: setSelectedPageSize, isPending: isPending })=>{
    const text = (0, $aL1Vp.default)();
    const [selectAllCheckboxIsDisabled, setSelectAllCheckboxIsDisabled] = (0, $6uMv9.useState)(false);
    const [pageSize, setPageSize] = (0, $6uMv9.useState)(50);
    const sortedChargePoints = (0, $6uMv9.useMemo)(()=>{
        if (!sortBy || !sortDirection) return chargePoints;
        return [
            ...chargePoints
        ].sort((a, b)=>{
            const directionMultiplier = sortDirection === "asc" ? 1 : -1;
            if (typeof a[sortBy] !== "string") {
                if (a[sortBy] < b[sortBy]) return directionMultiplier * -1;
                if (a[sortBy] > b[sortBy]) return directionMultiplier * 1;
                return 0;
            }
            if (a[sortBy] !== "" && !b[sortBy]) return directionMultiplier * 1;
            if (b[sortBy] !== "" && !a[sortBy]) return directionMultiplier * -1;
            const firstItem = a[sortBy].toString().toLowerCase();
            const secondItem = b[sortBy].toString().toLowerCase();
            if (firstItem < secondItem) return directionMultiplier * -1;
            if (firstItem > secondItem) return directionMultiplier * 1;
            return 0;
        });
    }, [
        chargePoints,
        sortBy,
        sortDirection
    ]);
    const sort = (name)=>onChangeSort(name, name === sortBy && sortDirection === "asc" && "desc" || "asc");
    const allChecked = (0, $6uMv9.useMemo)(()=>{
        const editableChargePoints = chargePoints.filter((chargePoint)=>{
            return (0, $7wlt6.default)(chargePoint) && (latestFirmwareVersion !== +(0, $5fQlh.getFirmwareVersion)(chargePoint.ocppConfigKeys) || (0, $5fQlh.compareSemanticVersions)(latestFirmwareVersion, (0, $5fQlh.getFirmwareVersion)(chargePoint.ocppConfigKeys)));
        });
        setSelectAllCheckboxIsDisabled(editableChargePoints.length === 0);
        return editableChargePoints.length > 0 ? editableChargePoints.every((cp)=>cp.checked) : false;
    }, [
        chargePoints,
        latestFirmwareVersion
    ]);
    const getStatus = (chargePoint)=>{
        if (filters.status === (0, $1wGKW.ChargePointStatus).Charging && chargePoint.isCharging) return (0, $1wGKW.ChargePointStatus).Charging;
        if (chargePoint.chargePointStatus === (0, $1wGKW.ChargePointStatus).Online) return (0, $1wGKW.ChargePointStatus).Online;
        return chargePoint.chargePointStatus;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$WidgetWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$export$592f2e2cecbdbd14, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "lblChargersWidget"
    }), isPending && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        className: "fa fa-spinner fa-pulse margin-left-small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$SSearchResultsNumber, {
        "data-testid": "search-result"
    }, !isPending && (totalCount > 0 ? `${totalCount} chargers found` : text("lblNoChargersFound"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$SFilterGroup, null, totalCount > 20 && !isPending && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "text-right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        "data-testid": "pagination-title"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgResultPage"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", null, ":")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cBlPU.default), {
        value: pageSize,
        onChange: (value)=>{
            setPageSize(value);
            setSelectedPageSize(value);
            setCurrentPage(0);
        },
        dataTestId: "button-paginate-group"
    }))), totalCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$SFilter, {
        actions: true,
        large: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("button", {
        disabled: !chargePoints.some((cp)=>cp.checked),
        type: "button",
        className: "btn btn-ok btn-sm heading5",
        onClick: ()=>onUpdate(),
        "data-testid": "btn-update"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnUpdate"
    }))))), isPending && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$SpinnerContainer, {
        "data-testid": "loader"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "shimmer-container shimmer-medium"
    })), !!sortedChargePoints.length && !isPending && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$STableWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$STable, {
        className: "table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("thead", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("tr", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$STableColumn, {
        width: "5%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$SCheckboxLabel, {
        "data-testid": "checkbox-select-all"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
        className: "checkbox-black",
        type: "checkbox",
        onChange: (event)=>onSelectAll(event.target.checked),
        checked: allChecked,
        disabled: selectAllCheckboxIsDisabled,
        title: "Select All",
        "data-testid": "checkbox-select-all"
    }))), $ecd1bda8cf3db291$var$columns.map(({ name: name, sortableProperty: sortableProperty })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$STableColumn, {
            "data-testid": "col" + name,
            key: name,
            sortable: !!sortableProperty,
            sorted: sortBy === sortableProperty ? sortDirection : undefined,
            onClick: ()=>sortableProperty && sort(sortableProperty)
        }, name)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("tbody", null, sortedChargePoints?.map((chargePoint)=>{
        const checkBoxIsDisabled = !(0, $7wlt6.default)(chargePoint) || latestFirmwareVersion === +(0, $5fQlh.getFirmwareVersion)(chargePoint.ocppConfigKeys) || !(0, $5fQlh.compareSemanticVersions)(latestFirmwareVersion, (0, $5fQlh.getFirmwareVersion)(chargePoint.ocppConfigKeys));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$STableRow, {
            key: chargePoint.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$STableCell, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$SCheckboxLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("input", {
            className: "checkbox-black",
            type: "checkbox",
            title: checkBoxIsDisabled ? "ChargePoint is offline or already has the latest firmware version" : undefined,
            checked: !!chargePoint.checked,
            onChange: (event)=>onSelect(chargePoint.id, event.target.checked),
            disabled: checkBoxIsDisabled,
            "data-testid": "checkbox-" + chargePoint.id
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$STableCell, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
            to: `/chargepoints/${chargePoint.id}`,
            className: "btn-link",
            "data-testid": "id-" + chargePoint.id
        }, chargePoint.id)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$STableCell, {
            "data-testid": "name-" + chargePoint.id
        }, chargePoint.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$STableCell, {
            "data-testid": "status-" + chargePoint.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jEjkX.SStatusIcon), {
            status: getStatus(chargePoint)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$STableCell, {
            "data-testid": "org-" + chargePoint.id
        }, chargePoint.companyName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$STableCell, {
            "data-testid": "fw-version-" + chargePoint.id
        }, chargePoint.isOcpp ? (0, $5fQlh.getFirmwareVersion)(chargePoint.ocppConfigKeys) : chargePoint.installedFirmwareVersion), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$STableCell, {
            "data-testid": "available-" + chargePoint.id
        }, chargePoint?.availableFirmwareVersion), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$STableCell, {
            "data-testid": "fw-status-" + chargePoint.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $7pGEV.default), {
            availableVersion: chargePoint.availableFirmwareVersion,
            currentVersion: chargePoint.installedFirmwareVersion
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($ecd1bda8cf3db291$var$STableCell, {
            "data-testid": "last-updated-" + chargePoint.id
        }, (0, $bhWK5.default)(chargePoint?.firmwareLastUpdated)));
    })))), totalCount >= pageSize && !isPending && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $35vY7.ChargersPagination), {
        setPageIndex: handlePageClick,
        totalCount: totalCount,
        pageSize: pageSize,
        pageIndex: currentPage,
        displayedChargers: pageSize
    }));
};
var $ecd1bda8cf3db291$export$2e2bcd8739ae039 = $ecd1bda8cf3db291$var$UpdateChargersFirmwareList;

});
parcelRegister("go3CH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bee1b2b75e08ac4d$var$prefix = "fas";
var $bee1b2b75e08ac4d$var$iconName = "caret-down";
var $bee1b2b75e08ac4d$var$width = 320;
var $bee1b2b75e08ac4d$var$height = 512;
var $bee1b2b75e08ac4d$var$ligatures = [];
var $bee1b2b75e08ac4d$var$unicode = "f0d7";
var $bee1b2b75e08ac4d$var$svgPathData = "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z";
module.exports.definition = {
    prefix: $bee1b2b75e08ac4d$var$prefix,
    iconName: $bee1b2b75e08ac4d$var$iconName,
    icon: [
        $bee1b2b75e08ac4d$var$width,
        $bee1b2b75e08ac4d$var$height,
        $bee1b2b75e08ac4d$var$ligatures,
        $bee1b2b75e08ac4d$var$unicode,
        $bee1b2b75e08ac4d$var$svgPathData
    ]
};
module.exports.faCaretDown = module.exports.definition;
module.exports.prefix = $bee1b2b75e08ac4d$var$prefix;
module.exports.iconName = $bee1b2b75e08ac4d$var$iconName;
module.exports.width = $bee1b2b75e08ac4d$var$width;
module.exports.height = $bee1b2b75e08ac4d$var$height;
module.exports.ligatures = $bee1b2b75e08ac4d$var$ligatures;
module.exports.unicode = $bee1b2b75e08ac4d$var$unicode;
module.exports.svgPathData = $bee1b2b75e08ac4d$var$svgPathData;

});

parcelRegister("knKVd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ed6a5a5657ee818b$var$prefix = "fas";
var $ed6a5a5657ee818b$var$iconName = "caret-up";
var $ed6a5a5657ee818b$var$width = 320;
var $ed6a5a5657ee818b$var$height = 512;
var $ed6a5a5657ee818b$var$ligatures = [];
var $ed6a5a5657ee818b$var$unicode = "f0d8";
var $ed6a5a5657ee818b$var$svgPathData = "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z";
module.exports.definition = {
    prefix: $ed6a5a5657ee818b$var$prefix,
    iconName: $ed6a5a5657ee818b$var$iconName,
    icon: [
        $ed6a5a5657ee818b$var$width,
        $ed6a5a5657ee818b$var$height,
        $ed6a5a5657ee818b$var$ligatures,
        $ed6a5a5657ee818b$var$unicode,
        $ed6a5a5657ee818b$var$svgPathData
    ]
};
module.exports.faCaretUp = module.exports.definition;
module.exports.prefix = $ed6a5a5657ee818b$var$prefix;
module.exports.iconName = $ed6a5a5657ee818b$var$iconName;
module.exports.width = $ed6a5a5657ee818b$var$width;
module.exports.height = $ed6a5a5657ee818b$var$height;
module.exports.ligatures = $ed6a5a5657ee818b$var$ligatures;
module.exports.unicode = $ed6a5a5657ee818b$var$unicode;
module.exports.svgPathData = $ed6a5a5657ee818b$var$svgPathData;

});

parcelRegister("bhWK5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc5755c5baaf9c4a$export$2e2bcd8739ae039; });

var $g8kA8 = parcelRequire("g8kA8");
const $fc5755c5baaf9c4a$var$displayDateTime = (date)=>date ? (0, $g8kA8.default)(new Date(date), "yyyy-MM-dd HH:mm") : "";
var $fc5755c5baaf9c4a$export$2e2bcd8739ae039 = $fc5755c5baaf9c4a$var$displayDateTime;

});

parcelRegister("7pGEV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb7033fa5ebbe367$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $lWDz3 = parcelRequire("lWDz3");

var $coPO7 = parcelRequire("coPO7");

var $dzm7O = parcelRequire("dzm7O");
const $eb7033fa5ebbe367$var$FWStatusIcon = ({ availableVersion: availableVersion, currentVersion: currentVersion })=>{
    if (availableVersion === currentVersion) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $lWDz3.FontAwesomeIcon), {
        icon: (0, $coPO7.faCheck),
        color: "#81E18B"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $lWDz3.FontAwesomeIcon), {
        icon: (0, $dzm7O.faClock),
        color: "#006EF0"
    });
};
var $eb7033fa5ebbe367$export$2e2bcd8739ae039 = $eb7033fa5ebbe367$var$FWStatusIcon;

});
parcelRegister("coPO7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $906fe9c93dc06bf2$var$prefix = "fas";
var $906fe9c93dc06bf2$var$iconName = "check";
var $906fe9c93dc06bf2$var$width = 512;
var $906fe9c93dc06bf2$var$height = 512;
var $906fe9c93dc06bf2$var$ligatures = [];
var $906fe9c93dc06bf2$var$unicode = "f00c";
var $906fe9c93dc06bf2$var$svgPathData = "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z";
module.exports.definition = {
    prefix: $906fe9c93dc06bf2$var$prefix,
    iconName: $906fe9c93dc06bf2$var$iconName,
    icon: [
        $906fe9c93dc06bf2$var$width,
        $906fe9c93dc06bf2$var$height,
        $906fe9c93dc06bf2$var$ligatures,
        $906fe9c93dc06bf2$var$unicode,
        $906fe9c93dc06bf2$var$svgPathData
    ]
};
module.exports.faCheck = module.exports.definition;
module.exports.prefix = $906fe9c93dc06bf2$var$prefix;
module.exports.iconName = $906fe9c93dc06bf2$var$iconName;
module.exports.width = $906fe9c93dc06bf2$var$width;
module.exports.height = $906fe9c93dc06bf2$var$height;
module.exports.ligatures = $906fe9c93dc06bf2$var$ligatures;
module.exports.unicode = $906fe9c93dc06bf2$var$unicode;
module.exports.svgPathData = $906fe9c93dc06bf2$var$svgPathData;

});

parcelRegister("dzm7O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9e0fb4ce44164ab4$var$prefix = "fas";
var $9e0fb4ce44164ab4$var$iconName = "clock";
var $9e0fb4ce44164ab4$var$width = 512;
var $9e0fb4ce44164ab4$var$height = 512;
var $9e0fb4ce44164ab4$var$ligatures = [];
var $9e0fb4ce44164ab4$var$unicode = "f017";
var $9e0fb4ce44164ab4$var$svgPathData = "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z";
module.exports.definition = {
    prefix: $9e0fb4ce44164ab4$var$prefix,
    iconName: $9e0fb4ce44164ab4$var$iconName,
    icon: [
        $9e0fb4ce44164ab4$var$width,
        $9e0fb4ce44164ab4$var$height,
        $9e0fb4ce44164ab4$var$ligatures,
        $9e0fb4ce44164ab4$var$unicode,
        $9e0fb4ce44164ab4$var$svgPathData
    ]
};
module.exports.faClock = module.exports.definition;
module.exports.prefix = $9e0fb4ce44164ab4$var$prefix;
module.exports.iconName = $9e0fb4ce44164ab4$var$iconName;
module.exports.width = $9e0fb4ce44164ab4$var$width;
module.exports.height = $9e0fb4ce44164ab4$var$height;
module.exports.ligatures = $9e0fb4ce44164ab4$var$ligatures;
module.exports.unicode = $9e0fb4ce44164ab4$var$unicode;
module.exports.svgPathData = $9e0fb4ce44164ab4$var$svgPathData;

});


parcelRegister("jEjkX", function(module, exports) {

$parcel$export(module.exports, "SStatusIcon", function () { return $d18c161861ddcd88$export$3132e23835c49a85; });
$parcel$export(module.exports, "default", function () { return $d18c161861ddcd88$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $cbVaW = parcelRequire("cbVaW");

var $5xOHE = parcelRequire("5xOHE");

var $akcQ4 = parcelRequire("akcQ4");

var $iktXR = parcelRequire("iktXR");

var $9Ezdl = parcelRequire("9Ezdl");

var $1xw2Y = parcelRequire("1xw2Y");

var $1wGKW = parcelRequire("1wGKW");
const $d18c161861ddcd88$var$STip = (0, $akcQ4.default).div`
    font-family: ${({ theme: theme })=>theme.font.name};
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 1em;
`;
const $d18c161861ddcd88$export$3132e23835c49a85 = (0, $akcQ4.default).div`
    display: inline-block;
    vertical-align: middle;
    width: 12px;
    height: 12px;
    border-radius: 100%;
    margin-right: 0.5em;
    ${(p)=>p.status === "Online" ? (0, $akcQ4.css)`
                  background: ${({ theme: theme })=>theme.brandColors.CA_Green};
              ` : ""}
    ${(p)=>p.status === "Charging" ? (0, $akcQ4.css)`
                  background: ${({ theme: theme })=>theme.brandColors.CA_Blue};
              ` : ""}
    ${(p)=>p.status === "Offline" ? (0, $akcQ4.css)`
                  background: ${({ theme: theme })=>theme.font.errorColor};
              ` : ""}
`;
const $d18c161861ddcd88$var$SButton = (0, $akcQ4.default).button`
    margin-left: 1.5em;
`;
const $d18c161861ddcd88$var$chargerStatuses = [
    {
        label: "All chargers status",
        value: undefined
    },
    ...Object.values((0, $1wGKW.ChargePointStatus)).map((status)=>({
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($d18c161861ddcd88$export$3132e23835c49a85, {
                status: status
            }), status),
            value: status
        }))
];
const $d18c161861ddcd88$var$UpdateChargersFirmwareFilters = ({ partnerOptions: partnerOptions, onClearFilters: onClearFilters, filters: filters, pageClick: pageClick, isFetching: isFetching, onChange: onChange, productName: productName, onSubmit: onSubmit })=>{
    const { control: control, handleSubmit: handleSubmit, reset: reset, register: register, formState: { errors: formErrors, isValid: isValid } } = (0, $cbVaW.useForm)({
        mode: "onChange",
        delayError: 500,
        defaultValues: {
            id: filters.id ?? undefined,
            companyName: filters.companyName ?? undefined,
            firmwareVersion: filters.installedFirmwareVersion,
            status: filters?.status
        }
    });
    const fwValidation = (0, $6uMv9.useMemo)(()=>(0, $9Ezdl.firmwareInputValidation)(productName, false), [
        productName
    ]);
    const submit = (formValues)=>{
        const chargePointsQuery = {
            id: formValues.id,
            partnerId: formValues.partnerId?.value,
            companyName: formValues.companyName,
            installedFirmwareVersion: formValues.firmwareVersion,
            status: filters?.status
        };
        onSubmit(chargePointsQuery, pageClick);
    };
    const clearForm = ()=>{
        onClearFilters(), reset({
            firmwareVersion: "",
            id: "",
            companyName: "",
            partnerId: {
                value: undefined,
                label: "Any partner"
            }
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($d18c161861ddcd88$var$STip, {
        "data-testid": "update-fw"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "msgFWUpdateFWInfo"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-12 col-sm-6 col-md-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        type: "text",
        labelText: "Serial Number",
        "data-testid": "input-serial-no",
        id: "serial-no",
        ...register("id")
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-12 col-sm-6 col-md-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        type: "text",
        labelText: "Organisation",
        "data-testid": "input-org",
        id: "organization",
        ...register("companyName")
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-12 col-sm-6 col-md-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
        labelText: "Firmware Version",
        "data-testid": "input-fw-version",
        id: "fw-version",
        error: formErrors.firmwareVersion?.message,
        ...register("firmwareVersion", fwValidation)
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-12 col-sm-6 col-md-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $5xOHE.default), {
        isSearchable: false,
        options: $d18c161861ddcd88$var$chargerStatuses,
        defaultValue: $d18c161861ddcd88$var$chargerStatuses?.[0],
        value: $d18c161861ddcd88$var$chargerStatuses.find((option)=>option.value === filters.status),
        onChange: (option)=>onChange && onChange("status", option?.value),
        styles: {
            control: (styles)=>({
                    ...styles,
                    minHeight: "34px",
                    fontSize: 14
                }),
            dropdownIndicator: (styles)=>({
                    ...styles,
                    padding: "6px"
                })
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-12 col-sm-6 col-md-3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group",
        "data-testid": "input-partner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cbVaW.Controller), {
        name: "partnerId",
        control: control,
        render: ({ field: field })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $5xOHE.default), {
                isSearchable: true,
                placeholder: "Select partner",
                options: partnerOptions,
                defaultValue: partnerOptions?.[0],
                styles: {
                    control: (styles)=>({
                            ...styles,
                            minHeight: "34px",
                            fontSize: 14
                        }),
                    dropdownIndicator: (styles)=>({
                            ...styles,
                            padding: "6px"
                        })
                },
                ...field
            })
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "col-xs-12 col-md-6"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-inline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "pull-right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($d18c161861ddcd88$var$SButton, {
        type: "button",
        className: "btn btn-ok btn-sm heading5",
        onClick: clearForm,
        "data-testid": "btn-save"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnClear"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($d18c161861ddcd88$var$SButton, {
        type: "button",
        className: "btn btn-ok btn-sm heading5",
        onClick: handleSubmit(submit),
        "data-testid": "btn-search",
        disabled: !isValid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
        code: "btnSearch"
    }), isFetching && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        className: "fa fa-spinner fa-pulse margin-left-small",
        "data-testid": "btn-search"
    })))))));
};
var $d18c161861ddcd88$export$2e2bcd8739ae039 = $d18c161861ddcd88$var$UpdateChargersFirmwareFilters;

});


parcelRegister("6yckW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e72cb2cd49df5811$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $5xOHE = parcelRequire("5xOHE");

var $akcQ4 = parcelRequire("akcQ4");

var $iGeMy = parcelRequire("iGeMy");

var $jJBxK = parcelRequire("jJBxK");

var $8UeDP = parcelRequire("8UeDP");

var $fvmYM = parcelRequire("fvmYM");

var $f7UZA = parcelRequire("f7UZA");

var $aL1Vp = parcelRequire("aL1Vp");

var $5fQlh = parcelRequire("5fQlh");

var $8gLAc = parcelRequire("8gLAc");

var $4CNFe = parcelRequire("4CNFe");
const $e72cb2cd49df5811$var$SErrorAlert = (0, $akcQ4.default).div`
    font-family: ${({ theme: theme })=>theme.font.name};
    font-size: 16px;
    padding: 15px;
    font-weight: 300;
    border: 1px solid transparent;
    border-radius: 4px;
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
`;
const $e72cb2cd49df5811$var$SFilterLabel = (0, $akcQ4.default).label`
    font-family: ${({ theme: theme })=>theme.font.name};
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
    text-align: left;
`;
const $e72cb2cd49df5811$var$SFormContainer = (0, $akcQ4.default).div`
    border-radius: 8px;
    padding: 36px 130px;
    margin-top: 70px;

    @media (max-width: 900px) {
        padding: 20px 15px;
        margin-top: 40px;
    }
`;
const $e72cb2cd49df5811$var$SUpdateFormContainer = (0, $akcQ4.default).div`
    padding-bottom: 40px;

    @media (max-width: 900px) {
        padding-bottom: 0;
    }
`;
const $e72cb2cd49df5811$var$SSearchResultsNumber = (0, $akcQ4.default).p`
    font-family: ${({ theme: theme })=>theme.font.name};
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
`;
const $e72cb2cd49df5811$var$SCentered = (0, $akcQ4.default).div`
    text-align: center;
`;
const $e72cb2cd49df5811$var$SSpinnerTitle = (0, $akcQ4.default).div`
    font-family: ${({ theme: theme })=>theme.font.name};
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
`;
const $e72cb2cd49df5811$var$SButtonContainer = (0, $akcQ4.default).div`
    display: flex;
    align-items: center;
    justify-content: space-around;
`;
const $e72cb2cd49df5811$var$SFinishModalContainer = (0, $akcQ4.default).div`
    padding-bottom: 48px;
    display: flex;
    flex-direction: column;
    color: #000;
    font-size: 16px;
    font-weight: 400;
`;
const $e72cb2cd49df5811$var$SIconContainer = (0, $akcQ4.default).div`
    padding-bottom: 28px;
`;
const $e72cb2cd49df5811$var$UpdateChargersFirmwareModal = ({ productId: productId, firmwareType: firmwareType, productTitle: productTitle, firmwareTitle: firmwareTitle, chargePoints: chargePoints, onSubmit: onSubmit, onCancel: onCancel })=>{
    const text = (0, $aL1Vp.default)();
    const isOcpp = chargePoints[0].isOcpp;
    const [selectedVersion, setSelectedVersion] = (0, $6uMv9.useState)(null);
    const [isSubmitted, setIsSubmitted] = (0, $6uMv9.useState)(false);
    const [isFinished, setIsFinished] = (0, $6uMv9.useState)(false);
    const [isDifferentFirmwareTypes, setIsDifferentFirmwareTypes] = (0, $6uMv9.useState)(false);
    const [error, setError] = (0, $6uMv9.useState)(null);
    const { data: firmwaresResponse } = (0, $fvmYM.useFirmwareGetFirmwaresByFilterQuery)({
        productId: productId,
        ProductId: productId,
        firmwareType: firmwareType,
        ocppEnabled: isOcpp
    });
    const firmwaresOptions = (0, $6uMv9.useMemo)(()=>{
        if (firmwaresResponse) {
            const maxInstalled = chargePoints.reduce((previousValue, currentValue)=>{
                return (0, $5fQlh.compareSemanticVersions)(isOcpp ? (0, $5fQlh.getFirmwareVersion)(previousValue.ocppConfigKeys) : previousValue.installedFirmwareVersion, isOcpp ? (0, $5fQlh.getFirmwareVersion)(currentValue.ocppConfigKeys) : currentValue.installedFirmwareVersion) ? previousValue : currentValue;
            });
            const firmwares = firmwaresResponse?.items && firmwaresResponse?.items.filter((fw)=>(0, $5fQlh.compareSemanticVersions)(fw.firmwareVersion ?? 0, isOcpp ? (0, $5fQlh.getFirmwareVersion)(maxInstalled.ocppConfigKeys) : maxInstalled.installedFirmwareVersion));
            return firmwares ? firmwares.map((fw)=>{
                return {
                    value: fw.id,
                    label: fw.firmwareVersion
                };
            }) : [];
        } else return [];
    }, [
        firmwaresResponse
    ]);
    (0, $6uMv9.useEffect)(()=>{
        if (chargePoints.length != chargePoints.filter((x)=>x.isOcpp === chargePoints[0].isOcpp).length) {
            setIsDifferentFirmwareTypes(true);
            return;
        }
    }, []);
    (0, $6uMv9.useEffect)(()=>{
        if (firmwaresOptions.length > 0) setSelectedVersion(firmwaresOptions[0].value);
    }, [
        firmwaresOptions
    ]);
    const submit = ()=>{
        setIsSubmitted(true);
        onSubmit(selectedVersion).catch(({ error: error })=>setError(error)).finally(()=>setIsFinished(true));
    };
    (0, $4CNFe.default)({
        onEnterPress: submit,
        onEscapePress: ()=>onCancel()
    });
    const isEmptyState = firmwaresOptions.length === 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), {
        size: "lg",
        title: `Update chargers with firmware ${productTitle} ${firmwareTitle}`,
        actions: isFinished ? [] : [
            {
                label: text("btnCancel"),
                btn: "btn-secondary",
                callback: ()=>onCancel()
            },
            {
                label: text("btnUpdate"),
                callback: submit,
                disabled: isDifferentFirmwareTypes || !selectedVersion
            }
        ]
    }, isDifferentFirmwareTypes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e72cb2cd49df5811$var$SErrorAlert, {
        "data-testid": "alert-message"
    }, "You are not able to update OCPP and non-OCPP charger(s) at the same time. Select OCPP only or non-OCPP only chargers for update."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e72cb2cd49df5811$var$SFormContainer, null, !isSubmitted && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e72cb2cd49df5811$var$SUpdateFormContainer, null, isEmptyState ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e72cb2cd49df5811$var$SCentered, {
        className: "margin-bottom-med aweFontSizeSmall"
    }, "You have the latest version of firmware") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e72cb2cd49df5811$var$SSearchResultsNumber, {
        "data-testid": "no-of-chargers"
    }, chargePoints.length, " charger(s) selected for firmware update"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
        className: "form-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e72cb2cd49df5811$var$SFilterLabel, {
        "data-testid": "select-fw"
    }, "Select firmware version"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $5xOHE.default), {
        isDisabled: isDifferentFirmwareTypes,
        isSearchable: true,
        filterOption: (option, inputValue)=>{
            const { label: label } = option;
            return label.toString().includes(inputValue);
        },
        options: firmwaresOptions,
        defaultValue: firmwaresOptions?.[0],
        value: firmwaresOptions.find((option)=>option.value === selectedVersion),
        onChange: (option)=>setSelectedVersion(option?.value),
        styles: {
            control: (base)=>({
                    ...base,
                    fontSize: 14
                })
        }
    })))), isSubmitted && !isFinished && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e72cb2cd49df5811$var$SCentered, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iGeMy.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e72cb2cd49df5811$var$SSpinnerTitle, null, "Updating...")), isFinished && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e72cb2cd49df5811$var$SCentered, null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e72cb2cd49df5811$var$SFinishModalContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e72cb2cd49df5811$var$SIconContainer, {
        "data-testid": "icon-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8UeDP.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("p", {
        "data-testid": "message-error"
    }, "Update firmware to charger failed. Please try again later."), "error code: ", error) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e72cb2cd49df5811$var$SFinishModalContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e72cb2cd49df5811$var$SIconContainer, {
        "data-testid": "icon-success"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $jJBxK.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("p", {
        "data-testid": "message-success"
    }, chargePoints.length, " charger(s) has been scheduled for update with selected firmware. Please check the progress for each charger in the Update Chargers page.")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($e72cb2cd49df5811$var$SButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $f7UZA.Button), {
        primary: false,
        onClick: ()=>onCancel(true),
        label: text("btnClose"),
        "data-testid": "cancel-btn-1"
    })))));
};
var $e72cb2cd49df5811$export$2e2bcd8739ae039 = $e72cb2cd49df5811$var$UpdateChargersFirmwareModal;

});
parcelRegister("iGeMy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e12e4bef7c08897$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $akcQ4 = parcelRequire("akcQ4");
const $1e12e4bef7c08897$var$SSpinner = (0, $akcQ4.default).div`
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;

    div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 64px;
        height: 64px;
        margin: 8px;
        border: 8px solid ${({ theme: theme })=>theme.brandColors.CA_Blue};
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: ${(props)=>props.color} transparent transparent transparent;
    }

    div:nth-child(1) {
        animation-delay: -0.45s;
    }

    div:nth-child(2) {
        animation-delay: -0.3s;
    }

    div:nth-child(3) {
        animation-delay: -0.15s;
    }

    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;
const $1e12e4bef7c08897$var$Spinner = ({ color: color })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement($1e12e4bef7c08897$var$SSpinner, {
        color: color ?? "#006EF0"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", null));
var $1e12e4bef7c08897$export$2e2bcd8739ae039 = $1e12e4bef7c08897$var$Spinner;

});

parcelRegister("jJBxK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d38e24c51474dbfa$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $eRry7 = parcelRequire("eRry7");
const $d38e24c51474dbfa$var$IconSuccess = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $eRry7.default), {
        width: "60",
        height: "60",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M46.2517 20.02L24.9283 41.3435L19.3239 35.7299L20.02 35.035L24.9289 39.9519L45.5562 19.3245L46.2517 20.02ZM17.6329 34.0361L13.9141 30.3112L14.6101 29.6162L18.3289 33.3411L17.6329 34.0361Z",
        fill: "#006C5C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30 0.983607C13.9747 0.983607 0.983607 13.9747 0.983607 30C0.983607 46.0253 13.9747 59.0164 30 59.0164C46.0253 59.0164 59.0164 46.0253 59.0164 30C59.0164 13.9747 46.0253 0.983607 30 0.983607ZM0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30Z",
        fill: "#006C5C"
    }));
var $d38e24c51474dbfa$export$2e2bcd8739ae039 = $d38e24c51474dbfa$var$IconSuccess;

});

parcelRegister("8UeDP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80c4c54f1e78e4bd$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $eRry7 = parcelRequire("eRry7");
const $80c4c54f1e78e4bd$var$IconError = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $eRry7.default), {
        width: "60",
        height: "60",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M42.3953 18.0527L38.4608 21.9872L37.7653 21.2917L41.6998 17.3572L42.3953 18.0527ZM37.2313 23.2166L18.051 42.397L17.3555 41.7014L36.5358 22.5211L37.2313 23.2166Z",
        fill: "#EB5757"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M41.949 42.397L17.6048 18.0527L18.3003 17.3572L42.6445 41.7015L41.949 42.397Z",
        fill: "#EB5757"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30 0.983607C13.9747 0.983607 0.983607 13.9747 0.983607 30C0.983607 46.0253 13.9747 59.0164 30 59.0164C46.0253 59.0164 59.0164 46.0253 59.0164 30C59.0164 13.9747 46.0253 0.983607 30 0.983607ZM0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30Z",
        fill: "#EB5757"
    }));
var $80c4c54f1e78e4bd$export$2e2bcd8739ae039 = $80c4c54f1e78e4bd$var$IconError;

});






parcelRegister("dXAqI", function(module, exports) {

$parcel$export(module.exports, "EditFirmwareModal", function () { return $37176cb2c251d5d1$export$8b02c450a1a4a845; });

var $6uMv9 = parcelRequire("6uMv9");

var $cbVaW = parcelRequire("cbVaW");

var $iIdvQ = parcelRequire("iIdvQ");

var $fvmYM = parcelRequire("fvmYM");

var $iktXR = parcelRequire("iktXR");

var $2460e = parcelRequire("2460e");

var $8gLAc = parcelRequire("8gLAc");

var $aL1Vp = parcelRequire("aL1Vp");
const $37176cb2c251d5d1$export$2425b41e18ec8805 = [
    "New",
    "UpdateToAvailable",
    "UpdateToUnavailable",
    "UpdateFromUnavailable"
];
function $37176cb2c251d5d1$export$8b02c450a1a4a845({ setEditFirmwareModalIsOpen: setEditFirmwareModalIsOpen, selectedFirmwareData: selectedFirmwareData }) {
    const text = (0, $aL1Vp.default)();
    const [updateFirmWare] = (0, $fvmYM.useFirmwareUpdateFirmwareMutation)();
    const firmwareUpdate = async (formValues)=>{
        const tempFirmWare = {
            ...selectedFirmwareData,
            ...formValues
        };
        try {
            await updateFirmWare({
                firmwareGeneralModel: tempFirmWare
            }).unwrap();
            setEditFirmwareModalIsOpen(false);
            (0, $2460e.notifySuccess)(text("lblFirmwareVersionUpdatedSuccess"));
        } catch  {
            (0, $2460e.notifyError)(text("lblFirmwareVersionUpdatedFailed"));
        }
    };
    const statusOptions = $37176cb2c251d5d1$export$2425b41e18ec8805.map((option)=>({
            value: option,
            label: option
        }));
    const { handleSubmit: handleSubmit, register: register, control: control, formState: { isSubmitting: isSubmitting, isDirty: isDirty } } = (0, $cbVaW.useForm)({
        mode: "all",
        values: {
            description: selectedFirmwareData?.description,
            firmwareStatus: selectedFirmwareData?.firmwareStatus
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8gLAc.default), {
        title: text("lblEditFirmware"),
        size: "lg",
        "data-testid": "edit-firmware-modal",
        actions: [
            {
                label: text("btnCancel"),
                btn: "btn-secondary",
                callback: ()=>setEditFirmwareModalIsOpen(false)
            },
            {
                label: text("btnSave"),
                callback: handleSubmit(firmwareUpdate),
                loading: isSubmitting,
                disabled: isSubmitting || !isDirty
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        className: "flex flex-column gap-7"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cbVaW.Controller), {
        name: "description",
        control: control,
        render: ({ field: { value: value } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iktXR.default), {
                value: value,
                ...register("description"),
                id: "description",
                labelText: text("lblDescription"),
                "data-testid": "description-input",
                type: "text"
            })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("span", {
        className: "h-6rem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $cbVaW.Controller), {
        name: "firmwareStatus",
        control: control,
        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iIdvQ.Combobox), {
                options: statusOptions,
                labelText: text("lblFirmwareStatus"),
                id: "firmwareStatus",
                "data-testid": "firmwareStatus-input",
                enableDefaultOption: false,
                value: value,
                onChange: (option)=>{
                    onChange(option.value);
                }
            })
    }))));
}

});



parcelRegister("7SnmO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5c4f5612c6ab22d$export$2e2bcd8739ae039; });

var $6uMv9 = parcelRequire("6uMv9");

var $dRyYg = parcelRequire("dRyYg");

var $gZhRQ = parcelRequire("gZhRQ");

var $aol72 = parcelRequire("aol72");
const $f5c4f5612c6ab22d$var$createOptionForProduct = (product)=>{
    return {
        value: product.id,
        label: (0, $aol72.getProductName)(product.id).toString()
    };
};
const $f5c4f5612c6ab22d$var$loadOptions = (productVariant)=>(0, $gZhRQ.default)(productVariant && {
        productVariant: productVariant
    }).then((products)=>products.map((product)=>$f5c4f5612c6ab22d$var$createOptionForProduct(product)).sort((o1, o2)=>o1.label.localeCompare(o2.label)));
const $f5c4f5612c6ab22d$var$addEmptyOption = (options, emptyOption)=>{
    if (!emptyOption) options;
    const defaultOption = {
        value: undefined,
        label: typeof emptyOption === "string" ? emptyOption : "None"
    };
    return [
        defaultOption
    ].concat(options);
};
const $f5c4f5612c6ab22d$var$customStyles = {
    control: (base)=>({
            ...base,
            height: 34,
            minHeight: 34,
            fontSize: 14
        })
};
const $f5c4f5612c6ab22d$var$ProductSelect = ({ value: value, emptyOption: emptyOption, onChange: onChange })=>{
    const [storedOptions, storeOptions] = (0, $6uMv9.useState)([]);
    const requestOptions = ()=>{
        storeOptions([]);
        return $f5c4f5612c6ab22d$var$loadOptions((0, $gZhRQ.ProductVariant).MeasurementDevice).then((options)=>{
            const newOptions = $f5c4f5612c6ab22d$var$addEmptyOption(options, emptyOption);
            storeOptions(newOptions);
            return newOptions;
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dRyYg.default), {
        cacheOptions: true,
        defaultOptions: true,
        value: storedOptions.find((option)=>option.value === value),
        loadOptions: requestOptions,
        isSearchable: false,
        onChange: (product)=>{
            if (onChange) onChange(product?.value);
        },
        styles: $f5c4f5612c6ab22d$var$customStyles
    });
};
var $f5c4f5612c6ab22d$export$2e2bcd8739ae039 = $f5c4f5612c6ab22d$var$ProductSelect;

});
parcelRegister("dRyYg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a17b5a21d232c34a$export$2e2bcd8739ae039; });

var $dzwm9 = parcelRequire("dzwm9");

var $6uMv9 = parcelRequire("6uMv9");

var $5HZsE = parcelRequire("5HZsE");

var $dpKsq = parcelRequire("dpKsq");

var $bktAM = parcelRequire("bktAM");
parcelRequire("3f5k0");
parcelRequire("jBLpf");
parcelRequire("1Crz8");
parcelRequire("9Vlky");
parcelRequire("1rXDM");
parcelRequire("76TfG");


parcelRequire("8wqBD");
parcelRequire("aMSYH");
parcelRequire("jn4GR");
parcelRequire("9GUVC");
parcelRequire("8I5Gi");
parcelRequire("2vndP");

parcelRequire("dndSj");

var $a17b5a21d232c34a$var$AsyncSelect = /*#__PURE__*/ (0, $6uMv9.forwardRef)(function(props, ref) {
    var stateManagedProps = (0, $bktAM.u)(props);
    var selectProps = (0, $dpKsq.u)(stateManagedProps);
    return /*#__PURE__*/ $6uMv9.createElement((0, $5HZsE.S), (0, $dzwm9.default)({
        ref: ref
    }, selectProps));
});
var $a17b5a21d232c34a$export$2e2bcd8739ae039 = $a17b5a21d232c34a$var$AsyncSelect;

});
parcelRegister("bktAM", function(module, exports) {

$parcel$export(module.exports, "u", function () { return $83f8845d85e29190$export$3b14a55fb2447963; });

var $fLHSy = parcelRequire("fLHSy");

var $6qR8O = parcelRequire("6qR8O");

var $f5pbA = parcelRequire("f5pbA");

var $8V0cF = parcelRequire("8V0cF");

var $6uMv9 = parcelRequire("6uMv9");

var $jnyWp = parcelRequire("jnyWp");
var $83f8845d85e29190$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $83f8845d85e29190$export$3b14a55fb2447963(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions;
    _ref.options;
    var _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, $8V0cF.default)(_ref, $83f8845d85e29190$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $6uMv9.useRef)(undefined);
    var mounted = (0, $6uMv9.useRef)(false);
    var _useState = (0, $6uMv9.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, $f5pbA.default)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $6uMv9.useState)(typeof propsInputValue !== "undefined" ? propsInputValue : ""), _useState4 = (0, $f5pbA.default)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $6uMv9.useState)(propsDefaultOptions === true), _useState6 = (0, $f5pbA.default)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $6uMv9.useState)(undefined), _useState8 = (0, $f5pbA.default)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $6uMv9.useState)([]), _useState10 = (0, $f5pbA.default)(_useState9, 2), loadedOptions = _useState10[0], setLoadedOptions = _useState10[1];
    var _useState11 = (0, $6uMv9.useState)(false), _useState12 = (0, $f5pbA.default)(_useState11, 2), passEmptyOptions = _useState12[0], setPassEmptyOptions = _useState12[1];
    var _useState13 = (0, $6uMv9.useState)({}), _useState14 = (0, $f5pbA.default)(_useState13, 2), optionsCache = _useState14[0], setOptionsCache = _useState14[1];
    var _useState15 = (0, $6uMv9.useState)(undefined), _useState16 = (0, $f5pbA.default)(_useState15, 2), prevDefaultOptions = _useState16[0], setPrevDefaultOptions = _useState16[1];
    var _useState17 = (0, $6uMv9.useState)(undefined), _useState18 = (0, $f5pbA.default)(_useState17, 2), prevCacheOptions = _useState18[0], setPrevCacheOptions = _useState18[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $6uMv9.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $6uMv9.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === "function") loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $6uMv9.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $6uMv9.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $jnyWp.L)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue("");
            setLoadedInputValue("");
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? (0, $6qR8O.default)((0, $6qR8O.default)({}, optionsCache), {}, (0, $fLHSy.default)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return (0, $6qR8O.default)((0, $6qR8O.default)({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

});



parcelRegister("4MzD1", function(module, exports) {

$parcel$export(module.exports, "CompanyTransfersWidget", function () { return $b4ad22aa6c9f4282$export$a8a25bb8c30c6f3e; });

var $6uMv9 = parcelRequire("6uMv9");

var $4vH3e = parcelRequire("4vH3e");

var $dpspD = parcelRequire("dpspD");

var $aIcGc = parcelRequire("aIcGc");

var $iQS7O = parcelRequire("iQS7O");

var $iZaUM = parcelRequire("iZaUM");

var $fvmYM = parcelRequire("fvmYM");

var $8RYO3 = parcelRequire("8RYO3");

var $8N7S6 = parcelRequire("8N7S6");

var $8LupL = parcelRequire("8LupL");

var $aL1Vp = parcelRequire("aL1Vp");

var $3jZfA = parcelRequire("3jZfA");

var $1xw2Y = parcelRequire("1xw2Y");
const $b4ad22aa6c9f4282$export$a8a25bb8c30c6f3e = ()=>{
    const { partnerId: partnerId } = (0, $4vH3e.useSelector)((state)=>state.user);
    const text = (0, $aL1Vp.default)();
    const toast = (0, $3jZfA.useToast)();
    const { data: transfers, isLoading: transfersIsLoading } = (0, $fvmYM.useCompanyTransferGetRequestsForPartnerQuery)({
        partnerId: partnerId ?? -1
    }, {
        skip: !partnerId
    });
    const { data: supportTransfers, isLoading: supportTransfersIsLoading } = (0, $fvmYM.useCompanyTransferGetRequestsQuery)();
    const [acceptTransfer] = (0, $fvmYM.useCompanyTransferAcceptRequestMutation)();
    const [rejectTransfer] = (0, $fvmYM.useCompanyTransferRejectRequestMutation)();
    const confirmApproveTransfer = (companyTransferRequest)=>{
        (0, $iQS7O.confirmDialog)({
            header: text("lblApprovingOrgInvitation"),
            message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
                className: "flex flex-column gap-3"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
                code: "msgTransferApprovingOrgInvitation",
                values: {
                    organisation: companyTransferRequest.companyName
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("p", null, text("msgTransferApprovingOrgInvitationInfo"))),
            accept: ()=>{
                if (!companyTransferRequest.companyId || !companyTransferRequest.toPartnerId) return;
                acceptTransfer({
                    companyId: companyTransferRequest.companyId,
                    partnerId: companyTransferRequest.toPartnerId
                }).unwrap().then(()=>{
                    toast.notifySuccess(text("msgTransferSuccessful"));
                }).catch(()=>{
                    toast.notifyError(text("lblSomethingWentWrong"));
                });
            },
            acceptLabel: text("btnApprove"),
            rejectLabel: text("btnCancel")
        });
    };
    const confirmRejectTransfer = (companyTransferRequest)=>{
        (0, $iQS7O.confirmDialog)({
            header: text("lblTransferRejectingOrgInvitation"),
            message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $1xw2Y.default), {
                code: "msgTransferRejectingOrgInvitation",
                values: {
                    organisation: companyTransferRequest.companyName
                }
            }),
            accept: ()=>{
                if (!companyTransferRequest.companyId || !companyTransferRequest.toPartnerId) return;
                rejectTransfer({
                    companyId: companyTransferRequest.companyId,
                    partnerId: companyTransferRequest.toPartnerId
                }).unwrap().then(()=>{
                    toast.notifySuccess(text("msgTransferRejected"));
                }).catch(()=>{
                    toast.notifyError(text("lblSomethingWentWrong"));
                });
            },
            acceptLabel: text("btnDeny"),
            rejectLabel: text("btnCancel")
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $8RYO3.Table), {
        value: (0, $8LupL.isPartnerDomain) ? transfers : supportTransfers,
        dataKey: "id",
        paginator: true,
        rows: 10,
        emptyMessage: text("msgNoPendingTransfersFound"),
        "data-testid": "transfers-widget",
        loading: transfersIsLoading || supportTransfersIsLoading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        field: "companyName",
        body: (rowData)=>(0, $8LupL.isPartnerDomain) ? rowData.companyName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
                className: "pr-4",
                to: `/company/${rowData.companyId}`
            }, rowData.companyName),
        header: text("lblName"),
        sortable: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        body: (rowData)=>(0, $8N7S6.dateLocalize)(rowData.validTo),
        header: text("lblValidUntil"),
        sortable: true,
        field: "validTo"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        header: text("lblInitiatedBy"),
        field: "requestByName",
        sortable: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        hidden: (0, $8LupL.isPartnerDomain),
        header: text("lblFromPartner"),
        sortable: true,
        field: "fromPartnerName",
        body: (rowData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
                className: "pr-4",
                to: `/partner/${rowData.fromPartnerId}`
            }, rowData.fromPartnerName)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        hidden: (0, $8LupL.isPartnerDomain),
        header: text("lblToPartner"),
        sortable: true,
        field: "toPartnerName",
        body: (rowData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $iZaUM.Link), {
                className: "pr-4",
                to: `/partner/${rowData.toPartnerId}`
            }, rowData.toPartnerName)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $dpspD.Column), {
        body: (rowData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement("div", {
                className: "flex gap-2 justify-content-end"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
                size: "small",
                outlined: true,
                label: text("btnDeny"),
                onClick: ()=>confirmRejectTransfer(rowData)
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6uMv9))).createElement((0, $aIcGc.Button), {
                size: "small",
                label: text("btnApprove"),
                onClick: ()=>confirmApproveTransfer(rowData)
            }))
    }));
};

});


//# sourceMappingURL=index.3c50a3f0.js.map
